"undefined" != typeof exports && (exports = void 0),
  (function () {
    var t = {
      2: function (t, e, i) {
        (i =
          "undefined" != typeof window
            ? window
            : void 0 !== i.g
              ? i.g
              : "undefined" != typeof self
                ? self
                : {}),
          (t.exports = i);
      },
      1: function (t) {
        t.exports = function (t) {
          "complete" === document.readyState ||
            "interactive" === document.readyState
            ? t.call()
            : document.attachEvent
              ? document.attachEvent("onreadystatechange", function () {
                "interactive" === document.readyState && t.call();
              })
              : document.addEventListener &&
              document.addEventListener("DOMContentLoaded", t);
        };
      },
      8: function (t, e, i) {
        "use strict";
        i.r(e);
        var n = i(1),
          a = ((n = i.n(n)), i(2));
        function o(t, e) {
          return (
            (function (t) {
              if (Array.isArray(t)) return t;
            })(t) ||
            (function (t, e) {
              var i =
                null == t
                  ? null
                  : ("undefined" != typeof Symbol && t[Symbol.iterator]) ||
                  t["@@iterator"];
              if (null != i) {
                var n,
                  a,
                  o = [],
                  s = !0,
                  r = !1;
                try {
                  for (
                    i = i.call(t);
                    !(s = (n = i.next()).done) &&
                    (o.push(n.value), !e || o.length !== e);
                    s = !0
                  );
                } catch (t) {
                  (r = !0), (a = t);
                } finally {
                  try {
                    s || null == i.return || i.return();
                  } finally {
                    if (r) throw a;
                  }
                }
                return o;
              }
            })(t, e) ||
            (function (t, e) {
              if (t) {
                if ("string" == typeof t) return s(t, e);
                var i = Object.prototype.toString.call(t).slice(8, -1);
                return "Map" ===
                  (i =
                    "Object" === i && t.constructor
                      ? t.constructor.name
                      : i) || "Set" === i
                  ? Array.from(t)
                  : "Arguments" === i ||
                    /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i)
                    ? s(t, e)
                    : void 0;
              }
            })(t, e) ||
            (function () {
              throw new TypeError(
                "Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
              );
            })()
          );
        }
        function s(t, e) {
          (null == e || e > t.length) && (e = t.length);
          for (var i = 0, n = new Array(e); i < e; i++) n[i] = t[i];
          return n;
        }
        function r(t) {
          return (r =
            "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
              ? function (t) {
                return typeof t;
              }
              : function (t) {
                return t &&
                  "function" == typeof Symbol &&
                  t.constructor === Symbol &&
                  t !== Symbol.prototype
                  ? "symbol"
                  : typeof t;
              })(t);
        }
        function l(t, e) {
          for (var i = 0; i < e.length; i++) {
            var n = e[i];
            (n.enumerable = n.enumerable || !1),
              (n.configurable = !0),
              "value" in n && (n.writable = !0),
              Object.defineProperty(t, n.key, n);
          }
        }
        var d,
          c,
          u = a.window.navigator,
          f =
            -1 < u.userAgent.indexOf("MSIE ") ||
            -1 < u.userAgent.indexOf("Trident/") ||
            -1 < u.userAgent.indexOf("Edge/"),
          p =
            /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
              u.userAgent
            ),
          h = (function () {
            for (
              var t = "transform WebkitTransform MozTransform".split(" "),
              e = document.createElement("div"),
              i = 0;
              i < t.length;
              i += 1
            )
              if (e && void 0 !== e.style[t[i]]) return t[i];
            return !1;
          })();
        function m() {
          c = p
            ? (!d &&
              document.body &&
              (((d = document.createElement("div")).style.cssText =
                "position: fixed; top: -9999px; left: 0; height: 100vh; width: 0;"),
                document.body.appendChild(d)),
              (d ? d.clientHeight : 0) ||
              a.window.innerHeight ||
              document.documentElement.clientHeight)
            : a.window.innerHeight || document.documentElement.clientHeight;
        }
        m(),
          a.window.addEventListener("resize", m),
          a.window.addEventListener("orientationchange", m),
          a.window.addEventListener("load", m),
          n()(function () {
            m();
          });
        var g = [];
        function v() {
          g.length &&
            (g.forEach(function (t, e) {
              var i,
                n = t.instance,
                o = t.oldData;
              (t = {
                width: (i = n.$item.getBoundingClientRect()).width,
                height: i.height,
                top: i.top,
                bottom: i.bottom,
                wndW: a.window.innerWidth,
                wndH: c,
              }),
                (o =
                  (i =
                    !o ||
                    o.wndW !== t.wndW ||
                    o.wndH !== t.wndH ||
                    o.width !== t.width ||
                    o.height !== t.height) ||
                  !o ||
                  o.top !== t.top ||
                  o.bottom !== t.bottom);
              (g[e].oldData = t), i && n.onResize(), o && n.onScroll();
            }),
              a.window.requestAnimationFrame(v));
        }
        var y = 0,
          b = (function () {
            function t(e, i) {
              !(function (e, i) {
                if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function");
              })(this);
              var n = this;
              (n.instanceID = y),
                (y += 1),
                (n.$item = e),
                (n.defaults = {
                  type: "scroll",
                  speed: 0.5,
                  imgSrc: null,
                  imgElement: ".jarallax-img",
                  imgSize: "cover",
                  imgPosition: "50% 50%",
                  imgRepeat: "no-repeat",
                  keepImg: !1,
                  elementInViewport: null,
                  zIndex: -100,
                  disableParallax: !1,
                  disableVideo: !1,
                  videoSrc: null,
                  videoStartTime: 0,
                  videoEndTime: 0,
                  videoVolume: 0,
                  videoLoop: !0,
                  videoPlayOnlyVisible: !0,
                  videoLazyLoading: !0,
                  onScroll: null,
                  onInit: null,
                  onDestroy: null,
                  onCoverImage: null,
                });
              var a,
                s,
                l = n.$item.dataset || {},
                d = {};
              Object.keys(l).forEach(function (t) {
                var e = t.substr(0, 1).toLowerCase() + t.substr(1);
                e && void 0 !== n.defaults[e] && (d[e] = l[t]);
              }),
                (n.options = n.extend({}, n.defaults, d, i)),
                (n.pureOptions = n.extend({}, n.options)),
                Object.keys(n.options).forEach(function (t) {
                  "true" === n.options[t]
                    ? (n.options[t] = !0)
                    : "false" === n.options[t] && (n.options[t] = !1);
                }),
                (n.options.speed = Math.min(
                  2,
                  Math.max(-1, parseFloat(n.options.speed))
                )),
                "string" == typeof n.options.disableParallax &&
                (n.options.disableParallax = new RegExp(
                  n.options.disableParallax
                )),
                n.options.disableParallax instanceof RegExp &&
                ((a = n.options.disableParallax),
                  (n.options.disableParallax = function () {
                    return a.test(u.userAgent);
                  })),
                "function" != typeof n.options.disableParallax &&
                (n.options.disableParallax = function () {
                  return !1;
                }),
                "string" == typeof n.options.disableVideo &&
                (n.options.disableVideo = new RegExp(
                  n.options.disableVideo
                )),
                n.options.disableVideo instanceof RegExp &&
                ((s = n.options.disableVideo),
                  (n.options.disableVideo = function () {
                    return s.test(u.userAgent);
                  })),
                "function" != typeof n.options.disableVideo &&
                (n.options.disableVideo = function () {
                  return !1;
                }),
                (i =
                  (i = n.options.elementInViewport) &&
                    "object" === r(i) &&
                    void 0 !== i.length
                    ? o(i, 1)[0]
                    : i) instanceof Element || (i = null),
                (n.options.elementInViewport = i),
                (n.image = {
                  src: n.options.imgSrc || null,
                  $container: null,
                  useImgTag: !1,
                  position: "fixed",
                }),
                n.initImg() && n.canInitParallax() && n.init();
            }
            var e, i;
            return (
              (e = t),
              (i = [
                {
                  key: "css",
                  value: function (t, e) {
                    return "string" == typeof e
                      ? a.window.getComputedStyle(t).getPropertyValue(e)
                      : (e.transform && h && (e[h] = e.transform),
                        Object.keys(e).forEach(function (i) {
                          t.style[i] = e[i];
                        }),
                        t);
                  },
                },
                {
                  key: "extend",
                  value: function (t) {
                    for (
                      var e = arguments.length,
                      i = new Array(1 < e ? e - 1 : 0),
                      n = 1;
                      n < e;
                      n++
                    )
                      i[n - 1] = arguments[n];
                    return (
                      (t = t || {}),
                      Object.keys(i).forEach(function (e) {
                        i[e] &&
                          Object.keys(i[e]).forEach(function (n) {
                            t[n] = i[e][n];
                          });
                      }),
                      t
                    );
                  },
                },
                {
                  key: "getWindowData",
                  value: function () {
                    return {
                      width:
                        a.window.innerWidth ||
                        document.documentElement.clientWidth,
                      height: c,
                      y: document.documentElement.scrollTop,
                    };
                  },
                },
                {
                  key: "initImg",
                  value: function () {
                    var t = this,
                      e = t.options.imgElement;
                    return (
                      (e =
                        e && "string" == typeof e
                          ? t.$item.querySelector(e)
                          : e) instanceof Element ||
                      (t.options.imgSrc
                        ? ((e = new Image()).src = t.options.imgSrc)
                        : (e = null)),
                      e &&
                      (t.options.keepImg
                        ? (t.image.$item = e.cloneNode(!0))
                        : ((t.image.$item = e),
                          (t.image.$itemParent = e.parentNode)),
                        (t.image.useImgTag = !0)),
                      !(
                        !t.image.$item &&
                        (null === t.image.src &&
                          ((t.image.src =
                            "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"),
                            (t.image.bgImage = t.css(
                              t.$item,
                              "background-image"
                            ))),
                          !t.image.bgImage || "none" === t.image.bgImage)
                      )
                    );
                  },
                },
                {
                  key: "canInitParallax",
                  value: function () {
                    return h && !this.options.disableParallax();
                  },
                },
                {
                  key: "init",
                  value: function () {
                    var t,
                      e = this,
                      i = {
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        overflow: "hidden",
                      },
                      n = {
                        pointerEvents: "none",
                        transformStyle: "preserve-3d",
                        backfaceVisibility: "hidden",
                        willChange: "transform,opacity",
                      };
                    e.options.keepImg ||
                      ((t = e.$item.getAttribute("style")) &&
                        e.$item.setAttribute(
                          "data-jarallax-original-styles",
                          t
                        ),
                        !e.image.useImgTag ||
                        ((t = e.image.$item.getAttribute("style")) &&
                          e.image.$item.setAttribute(
                            "data-jarallax-original-styles",
                            t
                          ))),
                      "static" === e.css(e.$item, "position") &&
                      e.css(e.$item, {
                        position: "relative",
                      }),
                      "auto" === e.css(e.$item, "z-index") &&
                      e.css(e.$item, {
                        zIndex: 0,
                      }),
                      (e.image.$container = document.createElement("div")),
                      e.css(e.image.$container, i),
                      e.css(e.image.$container, {
                        "z-index": e.options.zIndex,
                      }),
                      f &&
                      e.css(e.image.$container, {
                        opacity: 0.9999,
                      }),
                      e.image.$container.setAttribute(
                        "id",
                        "jarallax-container-".concat(e.instanceID)
                      ),
                      e.$item.appendChild(e.image.$container),
                      e.image.useImgTag
                        ? (n = e.extend(
                          {
                            "object-fit": e.options.imgSize,
                            "object-position": e.options.imgPosition,
                            "font-family": "object-fit: "
                              .concat(
                                e.options.imgSize,
                                "; object-position: "
                              )
                              .concat(e.options.imgPosition, ";"),
                            "max-width": "none",
                          },
                          i,
                          n
                        ))
                        : ((e.image.$item = document.createElement("div")),
                          e.image.src &&
                          (n = e.extend(
                            {
                              "background-position": e.options.imgPosition,
                              "background-size": e.options.imgSize,
                              "background-repeat": e.options.imgRepeat,
                              "background-image":
                                e.image.bgImage ||
                                'url("'.concat(e.image.src, '")'),
                            },
                            i,
                            n
                          ))),
                      ("opacity" !== e.options.type &&
                        "scale" !== e.options.type &&
                        "scale-opacity" !== e.options.type &&
                        1 !== e.options.speed) ||
                      (e.image.position = "absolute"),
                      "fixed" === e.image.position &&
                      ((i = (function (t) {
                        for (var e = []; null !== t.parentElement;)
                          1 === (t = t.parentElement).nodeType && e.push(t);
                        return e;
                      })(e.$item).filter(function (t) {
                        var e = a.window.getComputedStyle(t);
                        return (
                          ((t =
                            e["-webkit-transform"] ||
                            e["-moz-transform"] ||
                            e.transform) &&
                            "none" !== t) ||
                          /(auto|scroll)/.test(
                            e.overflow + e["overflow-y"] + e["overflow-x"]
                          )
                        );
                      })),
                        (e.image.position = i.length ? "absolute" : "fixed")),
                      (n.position = e.image.position),
                      e.css(e.image.$item, n),
                      e.image.$container.appendChild(e.image.$item),
                      e.onResize(),
                      e.onScroll(!0),
                      e.options.onInit && e.options.onInit.call(e),
                      "none" !== e.css(e.$item, "background-image") &&
                      e.css(e.$item, {
                        "background-image": "none",
                      }),
                      e.addToParallaxList();
                  },
                },
                {
                  key: "addToParallaxList",
                  value: function () {
                    g.push({
                      instance: this,
                    }),
                      1 === g.length && a.window.requestAnimationFrame(v);
                  },
                },
                {
                  key: "removeFromParallaxList",
                  value: function () {
                    var t = this;
                    g.forEach(function (e, i) {
                      e.instance.instanceID === t.instanceID &&
                        g.splice(i, 1);
                    });
                  },
                },
                {
                  key: "destroy",
                  value: function () {
                    var t = this;
                    t.removeFromParallaxList();
                    var e,
                      i = t.$item.getAttribute(
                        "data-jarallax-original-styles"
                      );
                    t.$item.removeAttribute("data-jarallax-original-styles"),
                      i
                        ? t.$item.setAttribute("style", i)
                        : t.$item.removeAttribute("style"),
                      t.image.useImgTag &&
                      ((e = t.image.$item.getAttribute(
                        "data-jarallax-original-styles"
                      )),
                        t.image.$item.removeAttribute(
                          "data-jarallax-original-styles"
                        ),
                        e
                          ? t.image.$item.setAttribute("style", i)
                          : t.image.$item.removeAttribute("style"),
                        t.image.$itemParent &&
                        t.image.$itemParent.appendChild(t.image.$item)),
                      t.$clipStyles &&
                      t.$clipStyles.parentNode.removeChild(t.$clipStyles),
                      t.image.$container &&
                      t.image.$container.parentNode.removeChild(
                        t.image.$container
                      ),
                      t.options.onDestroy && t.options.onDestroy.call(t),
                      delete t.$item.jarallax;
                  },
                },
                {
                  key: "clipContainer",
                  value: function () {
                    var t, e, i;
                    "fixed" === this.image.position &&
                      ((e = (i = (t =
                        this).image.$container.getBoundingClientRect())
                        .width),
                        (i = i.height),
                        t.$clipStyles ||
                        ((t.$clipStyles = document.createElement("style")),
                          t.$clipStyles.setAttribute("type", "text/css"),
                          t.$clipStyles.setAttribute(
                            "id",
                            "jarallax-clip-".concat(t.instanceID)
                          ),
                          (
                            document.head ||
                            document.getElementsByTagName("head")[0]
                          ).appendChild(t.$clipStyles)),
                        (i = "#jarallax-container-"
                          .concat(t.instanceID, " {\n            clip: rect(0 ")
                          .concat(e, "px ")
                          .concat(i, "px 0);\n            clip: rect(0, ")
                          .concat(e, "px, ")
                          .concat(
                            i,
                            "px, 0);\n            -webkit-clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);\n            clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);\n        }"
                          )),
                        t.$clipStyles.styleSheet
                          ? (t.$clipStyles.styleSheet.cssText = i)
                          : (t.$clipStyles.innerHTML = i));
                  },
                },
                {
                  key: "coverImage",
                  value: function () {
                    var t,
                      e = this,
                      i = e.image.$container.getBoundingClientRect(),
                      n = i.height,
                      a = e.options.speed,
                      o =
                        "scroll" === e.options.type ||
                        "scroll-opacity" === e.options.type,
                      s = 0,
                      r = n;
                    return (
                      o &&
                      (a < 0
                        ? ((s = a * Math.max(n, c)),
                          c < n && (s -= a * (n - c)))
                        : (s = a * (n + c)),
                        1 < a
                          ? (r = Math.abs(s - c))
                          : a < 0
                            ? (r = s / a + Math.abs(s))
                            : (r += (c - n) * (1 - a)),
                        (s /= 2)),
                      (e.parallaxScrollDistance = s),
                      (t = o ? (c - r) / 2 : (n - r) / 2),
                      e.css(e.image.$item, {
                        height: "".concat(r, "px"),
                        marginTop: "".concat(t, "px"),
                        left:
                          "fixed" === e.image.position
                            ? "".concat(i.left, "px")
                            : "0",
                        width: "".concat(i.width, "px"),
                      }),
                      e.options.onCoverImage &&
                      e.options.onCoverImage.call(e),
                      {
                        image: {
                          height: r,
                          marginTop: t,
                        },
                        container: i,
                      }
                    );
                  },
                },
                {
                  key: "isVisible",
                  value: function () {
                    return this.isElementInViewport || !1;
                  },
                },
                {
                  key: "onScroll",
                  value: function (t) {
                    var e,
                      i,
                      n,
                      o,
                      s,
                      r,
                      l,
                      d = this,
                      u = d.$item.getBoundingClientRect(),
                      f = u.top,
                      p = u.height,
                      h = {},
                      m = u;
                    d.options.elementInViewport &&
                      (m =
                        d.options.elementInViewport.getBoundingClientRect()),
                      (d.isElementInViewport =
                        0 <= m.bottom &&
                        0 <= m.right &&
                        m.top <= c &&
                        m.left <= a.window.innerWidth),
                      (t || d.isElementInViewport) &&
                      ((e = Math.max(0, f)),
                        (i = Math.max(0, p + f)),
                        (n = Math.max(0, -f)),
                        (o = Math.max(0, f + p - c)),
                        (s = Math.max(0, p - (f + p - c))),
                        (r = Math.max(0, -f + c - p)),
                        (m = 1 - ((c - f) / (c + p)) * 2),
                        (t = 1),
                        p < c
                          ? (t = 1 - (n || o) / p)
                          : i <= c
                            ? (t = i / c)
                            : s <= c && (t = s / c),
                        ("opacity" !== d.options.type &&
                          "scale-opacity" !== d.options.type &&
                          "scroll-opacity" !== d.options.type) ||
                        ((h.transform = "translate3d(0,0,0)"),
                          (h.opacity = t)),
                        ("scale" !== d.options.type &&
                          "scale-opacity" !== d.options.type) ||
                        ((l = 1),
                          d.options.speed < 0
                            ? (l -= d.options.speed * t)
                            : (l += d.options.speed * (1 - t)),
                          (h.transform = "scale(".concat(
                            l,
                            ") translate3d(0,0,0)"
                          ))),
                        ("scroll" !== d.options.type &&
                          "scroll-opacity" !== d.options.type) ||
                        ((l = d.parallaxScrollDistance * m),
                          "absolute" === d.image.position && (l -= f),
                          (h.transform = "translate3d(0,".concat(
                            l,
                            "px,0)"
                          ))),
                        d.css(d.image.$item, h),
                        d.options.onScroll &&
                        d.options.onScroll.call(d, {
                          section: u,
                          beforeTop: e,
                          beforeTopEnd: i,
                          afterTop: n,
                          beforeBottom: o,
                          beforeBottomEnd: s,
                          afterBottom: r,
                          visiblePercent: t,
                          fromViewportCenter: m,
                        }));
                  },
                },
                {
                  key: "onResize",
                  value: function () {
                    this.coverImage(), this.clipContainer();
                  },
                },
              ]) && l(e.prototype, i),
              t
            );
          })();
        ((n = function (t, e) {
          for (
            var i,
            n = (t = (
              "object" ===
                ("undefined" == typeof HTMLElement
                  ? "undefined"
                  : r(HTMLElement))
                ? t instanceof HTMLElement
                : t &&
                "object" === r(t) &&
                null !== t &&
                1 === t.nodeType &&
                "string" == typeof t.nodeName
            )
              ? [t]
              : t).length,
            a = 0,
            o = arguments.length,
            s = new Array(2 < o ? o - 2 : 0),
            l = 2;
            l < o;
            l++
          )
            s[l - 2] = arguments[l];
          for (; a < n; a += 1)
            if (
              ("object" === r(e) || void 0 === e
                ? t[a].jarallax || (t[a].jarallax = new b(t[a], e))
                : t[a].jarallax &&
                (i = t[a].jarallax[e].apply(t[a].jarallax, s)),
                void 0 !== i)
            )
              return i;
          return t;
        }).constructor = b),
          (e.default = n);
      },
    },
      e = {};
    function i(n) {
      var a = e[n];
      return void 0 !== a
        ? a.exports
        : ((a = e[n] =
        {
          exports: {},
        }),
          t[n](a, a.exports, i),
          a.exports);
    }
    (i.n = function (t) {
      var e =
        t && t.__esModule
          ? function () {
            return t.default;
          }
          : function () {
            return t;
          };
      return (
        i.d(e, {
          a: e,
        }),
        e
      );
    }),
      (i.d = function (t, e) {
        for (var n in e)
          i.o(e, n) &&
            !i.o(t, n) &&
            Object.defineProperty(t, n, {
              enumerable: !0,
              get: e[n],
            });
      }),
      (i.g = (function () {
        if ("object" == typeof globalThis) return globalThis;
        try {
          return this || new Function("return this")();
        } catch (t) {
          if ("object" == typeof window) return window;
        }
      })()),
      (i.o = function (t, e) {
        return Object.prototype.hasOwnProperty.call(t, e);
      }),
      (i.r = function (t) {
        "undefined" != typeof Symbol &&
          Symbol.toStringTag &&
          Object.defineProperty(t, Symbol.toStringTag, {
            value: "Module",
          }),
          Object.defineProperty(t, "__esModule", {
            value: !0,
          });
      });
    var n = {};
    !(function () {
      "use strict";
      i.r(n);
      var t = i(1),
        e = i.n(t),
        a = i(2),
        o = i(8);
      function s(t) {
        return (s =
          "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
            ? function (t) {
              return typeof t;
            }
            : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
      }
      var r,
        l = a.window.jarallax;
      (a.window.jarallax = o.default),
        (a.window.jarallax.noConflict = function () {
          return (a.window.jarallax = l), this;
        }),
        void 0 !== a.jQuery_T4NT &&
        (((t = function () {
          for (var t = arguments.length, e = new Array(t), i = 0; i < t; i++)
            e[i] = arguments[i];
          Array.prototype.unshift.call(e, this);
          var n = o.default.apply(a.window, e);
          return "object" !== s(n) ? n : this;
        }).constructor = o.default.constructor),
          (r = a.jQuery_T4NT.fn.jarallax),
          (a.jQuery_T4NT.fn.jarallax = t),
          (a.jQuery_T4NT.fn.jarallax.noConflict = function () {
            return (a.jQuery_T4NT.fn.jarallax = r), this;
          })),
        e()(function () {
          (0, o.default)(document.querySelectorAll("[data-jarallax]"));
        });
    })();
  })();
var t4sJarallax = jarallax.noConflict();
(jQuery_T4NT.fn.t4sJarallax = jQuery_T4NT.fn.jarallax.noConflict()),
  (function (t) {
    "use strict";
    "function" == typeof define && define.amd
      ? define(["jQuery_T4NT"], t)
      : t(jQuery_T4NT);
  })(function (t) {
    "use strict";
    function e(t) {
      var e = t.toString().replace(/([.?*+^$[\]\\(){}|-])/g, "\\$1");
      return new RegExp(e);
    }
    function i(t) {
      return function (i) {
        var a = i.match(/%(-|!)?[A-Z]{1}(:[^;]+;)?/gi);
        if (a)
          for (var o = 0, s = a.length; o < s; ++o) {
            var l = a[o].match(/%(-|!)?([a-zA-Z]{1})(:[^;]+;)?/),
              d = e(l[0]),
              c = l[1] || "",
              u = l[3] || "",
              f = null;
            (l = l[2]),
              r.hasOwnProperty(l) && ((f = r[l]), (f = Number(t[f]))),
              null !== f &&
              ("!" === c && (f = n(u, f)),
                "" === c && f < 10 && (f = "0" + f.toString()),
                (i = i.replace(d, f.toString())));
          }
        return i.replace(/%%/, "%");
      };
    }
    function n(t, e) {
      var i = "s",
        n = "";
      return (
        t &&
        (1 === (t = t.replace(/(:|;|\s)/gi, "").split(/\,/)).length
          ? (i = t[0])
          : ((n = t[0]), (i = t[1]))),
        Math.abs(e) > 1 ? i : n
      );
    }
    var a = [],
      o = [],
      s = {
        precision: 100,
        elapse: !1,
        defer: !1,
      };
    o.push(/^[0-9]*$/.source),
      o.push(/([0-9]{1,2}\/){2}[0-9]{4}( [0-9]{1,2}(:[0-9]{2}){2})?/.source),
      o.push(
        /[0-9]{4}([\/\-][0-9]{1,2}){2}( [0-9]{1,2}(:[0-9]{2}){2})?/.source
      ),
      (o = new RegExp(o.join("|")));
    var r = {
      Y: "years",
      m: "months",
      n: "daysToMonth",
      d: "daysToWeek",
      w: "weeks",
      W: "weeksToMonth",
      H: "hours",
      M: "minutes",
      S: "seconds",
      D: "totalDays",
      I: "totalHours",
      N: "totalMinutes",
      T: "totalSeconds",
    },
      l = function (e, i, n) {
        (this.el = e),
          (this.$el = t(e)),
          (this.interval = null),
          (this.offset = {}),
          (this.options = t.extend({}, s)),
          (this.instanceNumber = a.length),
          a.push(this),
          this.$el.data("countdown-instance", this.instanceNumber),
          n &&
          ("function" == typeof n
            ? (this.$el.on("update.countdown", n),
              this.$el.on("stoped.countdown", n),
              this.$el.on("finish.countdown", n))
            : (this.options = t.extend({}, s, n))),
          this.setFinalDate(i),
          !1 === this.options.defer && this.start();
      };
    t.extend(l.prototype, {
      start: function () {
        null !== this.interval && clearInterval(this.interval);
        var t = this;
        this.update(),
          (this.interval = setInterval(function () {
            t.update.call(t);
          }, this.options.precision));
      },
      stop: function () {
        clearInterval(this.interval),
          (this.interval = null),
          this.dispatchEvent("stoped");
      },
      toggle: function () {
        this.interval ? this.stop() : this.start();
      },
      pause: function () {
        this.stop();
      },
      resume: function () {
        this.start();
      },
      remove: function () {
        this.stop.call(this),
          (a[this.instanceNumber] = null),
          delete this.$el.data().countdownInstance;
      },
      setFinalDate: function (t) {
        this.finalDate = (function (t) {
          if (t instanceof Date) return t;
          if (String(t).match(o))
            return (
              String(t).match(/^[0-9]*$/) && (t = Number(t)),
              String(t).match(/\-/) && (t = String(t).replace(/\-/g, "/")),
              new Date(t)
            );
          throw new Error("Couldn't cast `" + t + "` to a date object.");
        })(t);
      },
      update: function () {
        if (0 !== this.$el.closest("html").length) {
          var e,
            i = void 0 !== t._data(this.el, "events"),
            n = new Date();
          (e = this.finalDate.getTime() - n.getTime()),
            (e = Math.ceil(e / 1e3)),
            (e = !this.options.elapse && e < 0 ? 0 : Math.abs(e)),
            this.totalSecsLeft !== e &&
            i &&
            ((this.totalSecsLeft = e),
              (this.elapsed = n >= this.finalDate),
              (this.offset = {
                seconds: this.totalSecsLeft % 60,
                minutes: Math.floor(this.totalSecsLeft / 60) % 60,
                hours: Math.floor(this.totalSecsLeft / 60 / 60) % 24,
                days: Math.floor(this.totalSecsLeft / 60 / 60 / 24) % 7,
                daysToWeek: Math.floor(this.totalSecsLeft / 60 / 60 / 24) % 7,
                daysToMonth: Math.floor(
                  (this.totalSecsLeft / 60 / 60 / 24) % 30.4368
                ),
                weeks: Math.floor(this.totalSecsLeft / 60 / 60 / 24 / 7),
                weeksToMonth:
                  Math.floor(this.totalSecsLeft / 60 / 60 / 24 / 7) % 4,
                months: Math.floor(this.totalSecsLeft / 60 / 60 / 24 / 30.4368),
                years: Math.abs(this.finalDate.getFullYear() - n.getFullYear()),
                totalDays: Math.floor(this.totalSecsLeft / 60 / 60 / 24),
                totalHours: Math.floor(this.totalSecsLeft / 60 / 60),
                totalMinutes: Math.floor(this.totalSecsLeft / 60),
                totalSeconds: this.totalSecsLeft,
              }),
              this.options.elapse || 0 !== this.totalSecsLeft
                ? this.dispatchEvent("update")
                : (this.stop(), this.dispatchEvent("finish")));
        } else this.remove();
      },
      dispatchEvent: function (e) {
        var n = t.Event(e + ".countdown");
        (n.finalDate = this.finalDate),
          (n.elapsed = this.elapsed),
          (n.offset = t.extend({}, this.offset)),
          (n.strftime = i(this.offset)),
          this.$el.trigger(n);
      },
    }),
      (t.fn.countdown = function () {
        var e = Array.prototype.slice.call(arguments, 0);
        return this.each(function () {
          var i = t(this).data("countdown-instance");
          if (void 0 !== i) {
            var n = a[i],
              o = e[0];
            l.prototype.hasOwnProperty(o)
              ? n[o].apply(n, e.slice(1))
              : null === String(o).match(/^[$A-Z_][0-9A-Z_$]*$/i)
                ? (n.setFinalDate.call(n, o), n.start())
                : t.error(
                  "Method %s does not exist on jQuery_T4NT.countdown".replace(
                    /\%s/gi,
                    o
                  )
                );
          } else new l(this, e[0], e[1]);
        });
      });
  }),
  (function (t, e) {
    "object" == typeof exports && "undefined" != typeof module
      ? (module.exports = e())
      : "function" == typeof define && define.amd
        ? define(e)
        : ((t = "undefined" != typeof globalThis ? globalThis : t || self).dayjs =
          e());
  })(this, function () {
    "use strict";
    var t = "millisecond",
      e = "second",
      i = "minute",
      n = "hour",
      a = "day",
      o = "week",
      s = "month",
      r = "quarter",
      l = "year",
      d = "date",
      c = "Invalid Date",
      u =
        /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/,
      f =
        /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,
      p = {
        name: "en",
        weekdays:
          "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months:
          "January_February_March_April_May_June_July_August_September_October_November_December".split(
            "_"
          ),
      },
      h = function (t, e, i) {
        var n = String(t);
        return !n || n.length >= e
          ? t
          : "" + Array(e + 1 - n.length).join(i) + t;
      },
      m = {
        s: h,
        z: function (t) {
          var e = -t.utcOffset(),
            i = Math.abs(e),
            n = Math.floor(i / 60),
            a = i % 60;
          return (e <= 0 ? "+" : "-") + h(n, 2, "0") + ":" + h(a, 2, "0");
        },
        m: function t(e, i) {
          if (e.date() < i.date()) return -t(i, e);
          var n = 12 * (i.year() - e.year()) + (i.month() - e.month()),
            a = e.clone().add(n, s),
            o = i - a < 0,
            r = e.clone().add(n + (o ? -1 : 1), s);
          return +(-(n + (i - a) / (o ? a - r : r - a)) || 0);
        },
        a: function (t) {
          return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
        },
        p: function (c) {
          return (
            {
              M: s,
              y: l,
              w: o,
              d: a,
              D: d,
              h: n,
              m: i,
              s: e,
              ms: t,
              Q: r,
            }[c] ||
            String(c || "")
              .toLowerCase()
              .replace(/s$/, "")
          );
        },
        u: function (t) {
          return void 0 === t;
        },
      },
      g = "en",
      v = {};
    v[g] = p;
    var y = function (t) {
      return t instanceof T;
    },
      b = function (t, e, i) {
        var n;
        if (!t) return g;
        if ("string" == typeof t) v[t] && (n = t), e && ((v[t] = e), (n = t));
        else {
          var a = t.name;
          (v[a] = t), (n = a);
        }
        return !i && n && (g = n), n || (!i && g);
      },
      S = function (t, e) {
        if (y(t)) return t.clone();
        var i = "object" == typeof e ? e : {};
        return (i.date = t), (i.args = arguments), new T(i);
      },
      w = m;
    (w.l = b),
      (w.i = y),
      (w.w = function (t, e) {
        return S(t, {
          locale: e.$L,
          utc: e.$u,
          x: e.$x,
          $offset: e.$offset,
        });
      });
    var T = (function () {
      function p(t) {
        (this.$L = b(t.locale, null, !0)), this.parse(t);
      }
      var h = p.prototype;
      return (
        (h.parse = function (t) {
          (this.$d = (function (t) {
            var e = t.date,
              i = t.utc;
            if (null === e) return new Date(NaN);
            if (w.u(e)) return new Date();
            if (e instanceof Date) return new Date(e);
            if ("string" == typeof e && !/Z$/i.test(e)) {
              var n = e.match(u);
              if (n) {
                var a = n[2] - 1 || 0,
                  o = (n[7] || "0").substring(0, 3);
                return i
                  ? new Date(
                    Date.UTC(
                      n[1],
                      a,
                      n[3] || 1,
                      n[4] || 0,
                      n[5] || 0,
                      n[6] || 0,
                      o
                    )
                  )
                  : new Date(
                    n[1],
                    a,
                    n[3] || 1,
                    n[4] || 0,
                    n[5] || 0,
                    n[6] || 0,
                    o
                  );
              }
            }
            return new Date(e);
          })(t)),
            (this.$x = t.x || {}),
            this.init();
        }),
        (h.init = function () {
          var t = this.$d;
          (this.$y = t.getFullYear()),
            (this.$M = t.getMonth()),
            (this.$D = t.getDate()),
            (this.$W = t.getDay()),
            (this.$H = t.getHours()),
            (this.$m = t.getMinutes()),
            (this.$s = t.getSeconds()),
            (this.$ms = t.getMilliseconds());
        }),
        (h.$utils = function () {
          return w;
        }),
        (h.isValid = function () {
          return !(this.$d.toString() === c);
        }),
        (h.isSame = function (t, e) {
          var i = S(t);
          return this.startOf(e) <= i && i <= this.endOf(e);
        }),
        (h.isAfter = function (t, e) {
          return S(t) < this.startOf(e);
        }),
        (h.isBefore = function (t, e) {
          return this.endOf(e) < S(t);
        }),
        (h.$g = function (t, e, i) {
          return w.u(t) ? this[e] : this.set(i, t);
        }),
        (h.unix = function () {
          return Math.floor(this.valueOf() / 1e3);
        }),
        (h.valueOf = function () {
          return this.$d.getTime();
        }),
        (h.startOf = function (t, r) {
          var c = this,
            u = !!w.u(r) || r,
            f = w.p(t),
            p = function (t, e) {
              var i = w.w(
                c.$u ? Date.UTC(c.$y, e, t) : new Date(c.$y, e, t),
                c
              );
              return u ? i : i.endOf(a);
            },
            h = function (t, e) {
              return w.w(
                c
                  .toDate()
                [t].apply(
                  c.toDate("s"),
                  (u ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(e)
                ),
                c
              );
            },
            m = this.$W,
            g = this.$M,
            v = this.$D,
            y = "set" + (this.$u ? "UTC" : "");
          switch (f) {
            case l:
              return u ? p(1, 0) : p(31, 11);
            case s:
              return u ? p(1, g) : p(0, g + 1);
            case o:
              var b = this.$locale().weekStart || 0,
                S = (m < b ? m + 7 : m) - b;
              return p(u ? v - S : v + (6 - S), g);
            case a:
            case d:
              return h(y + "Hours", 0);
            case n:
              return h(y + "Minutes", 1);
            case i:
              return h(y + "Seconds", 2);
            case e:
              return h(y + "Milliseconds", 3);
            default:
              return this.clone();
          }
        }),
        (h.endOf = function (t) {
          return this.startOf(t, !1);
        }),
        (h.$set = function (o, r) {
          var c,
            u = w.p(o),
            f = "set" + (this.$u ? "UTC" : ""),
            p = ((c = {}),
              (c[a] = f + "Date"),
              (c[d] = f + "Date"),
              (c[s] = f + "Month"),
              (c[l] = f + "FullYear"),
              (c[n] = f + "Hours"),
              (c[i] = f + "Minutes"),
              (c[e] = f + "Seconds"),
              (c[t] = f + "Milliseconds"),
              c)[u],
            h = u === a ? this.$D + (r - this.$W) : r;
          if (u === s || u === l) {
            var m = this.clone().set(d, 1);
            m.$d[p](h),
              m.init(),
              (this.$d = m.set(d, Math.min(this.$D, m.daysInMonth())).$d);
          } else p && this.$d[p](h);
          return this.init(), this;
        }),
        (h.set = function (t, e) {
          return this.clone().$set(t, e);
        }),
        (h.get = function (t) {
          return this[w.p(t)]();
        }),
        (h.add = function (t, r) {
          var d,
            c = this;
          t = Number(t);
          var u = w.p(r),
            f = function (e) {
              var i = S(c);
              return w.w(i.date(i.date() + Math.round(e * t)), c);
            };
          if (u === s) return this.set(s, this.$M + t);
          if (u === l) return this.set(l, this.$y + t);
          if (u === a) return f(1);
          if (u === o) return f(7);
          var p =
            ((d = {}), (d[i] = 6e4), (d[n] = 36e5), (d[e] = 1e3), d)[u] ||
            1,
            h = this.$d.getTime() + t * p;
          return w.w(h, this);
        }),
        (h.subtract = function (t, e) {
          return this.add(-1 * t, e);
        }),
        (h.format = function (t) {
          var e = this,
            i = this.$locale();
          if (!this.isValid()) return i.invalidDate || c;
          var n = t || "YYYY-MM-DDTHH:mm:ssZ",
            a = w.z(this),
            o = this.$H,
            s = this.$m,
            r = this.$M,
            l = i.weekdays,
            d = i.months,
            u = function (t, i, a, o) {
              return (t && (t[i] || t(e, n))) || a[i].substr(0, o);
            },
            p = function (t) {
              return w.s(o % 12 || 12, t, "0");
            },
            h =
              i.meridiem ||
              function (t, e, i) {
                var n = t < 12 ? "AM" : "PM";
                return i ? n.toLowerCase() : n;
              },
            m = {
              YY: String(this.$y).slice(-2),
              YYYY: this.$y,
              M: r + 1,
              MM: w.s(r + 1, 2, "0"),
              MMM: u(i.monthsShort, r, d, 3),
              MMMM: u(d, r),
              D: this.$D,
              DD: w.s(this.$D, 2, "0"),
              d: String(this.$W),
              dd: u(i.weekdaysMin, this.$W, l, 2),
              ddd: u(i.weekdaysShort, this.$W, l, 3),
              dddd: l[this.$W],
              H: String(o),
              HH: w.s(o, 2, "0"),
              h: p(1),
              hh: p(2),
              a: h(o, s, !0),
              A: h(o, s, !1),
              m: String(s),
              mm: w.s(s, 2, "0"),
              s: String(this.$s),
              ss: w.s(this.$s, 2, "0"),
              SSS: w.s(this.$ms, 3, "0"),
              Z: a,
            };
          return n.replace(f, function (t, e) {
            return e || m[t] || a.replace(":", "");
          });
        }),
        (h.utcOffset = function () {
          return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }),
        (h.diff = function (t, d, c) {
          var u,
            f = w.p(d),
            p = S(t),
            h = 6e4 * (p.utcOffset() - this.utcOffset()),
            m = this - p,
            g = w.m(this, p);
          return (
            (g =
              ((u = {}),
                (u[l] = g / 12),
                (u[s] = g),
                (u[r] = g / 3),
                (u[o] = (m - h) / 6048e5),
                (u[a] = (m - h) / 864e5),
                (u[n] = m / 36e5),
                (u[i] = m / 6e4),
                (u[e] = m / 1e3),
                u)[f] || m),
            c ? g : w.a(g)
          );
        }),
        (h.daysInMonth = function () {
          return this.endOf(s).$D;
        }),
        (h.$locale = function () {
          return v[this.$L];
        }),
        (h.locale = function (t, e) {
          if (!t) return this.$L;
          var i = this.clone(),
            n = b(t, e, !0);
          return n && (i.$L = n), i;
        }),
        (h.clone = function () {
          return w.w(this.$d, this);
        }),
        (h.toDate = function () {
          return new Date(this.valueOf());
        }),
        (h.toJSON = function () {
          return this.isValid() ? this.toISOString() : null;
        }),
        (h.toISOString = function () {
          return this.$d.toISOString();
        }),
        (h.toString = function () {
          return this.$d.toUTCString();
        }),
        p
      );
    })(),
      _ = T.prototype;
    return (
      (S.prototype = _),
      [
        ["$ms", t],
        ["$s", e],
        ["$m", i],
        ["$H", n],
        ["$W", a],
        ["$M", s],
        ["$y", l],
        ["$D", d],
      ].forEach(function (t) {
        _[t[1]] = function (e) {
          return this.$g(e, t[0], t[1]);
        };
      }),
      (S.extend = function (t, e) {
        return t.$i || (t(e, T, S), (t.$i = !0)), S;
      }),
      (S.locale = b),
      (S.isDayjs = y),
      (S.unix = function (t) {
        return S(1e3 * t);
      }),
      (S.en = v[g]),
      (S.Ls = v),
      (S.p = {}),
      S
    );
  }),
  (function (t, e) {
    "object" == typeof exports && "undefined" != typeof module
      ? (module.exports = e())
      : "function" == typeof define && define.amd
        ? define(e)
        : ((t =
          "undefined" != typeof globalThis
            ? globalThis
            : t || self).dayjs_plugin_utc = e());
  })(this, function () {
    "use strict";
    var t = "minute",
      e = /[+-]\d\d(?::?\d\d)?/g,
      i = /([+-]|\d\d)/g;
    return function (n, a, o) {
      var s = a.prototype;
      (o.utc = function (t) {
        return new a({
          date: t,
          utc: !0,
          args: arguments,
        });
      }),
        (s.utc = function (e) {
          var i = o(this.toDate(), {
            locale: this.$L,
            utc: !0,
          });
          return e ? i.add(this.utcOffset(), t) : i;
        }),
        (s.local = function () {
          return o(this.toDate(), {
            locale: this.$L,
            utc: !1,
          });
        });
      var r = s.parse;
      s.parse = function (t) {
        t.utc && (this.$u = !0),
          this.$utils().u(t.$offset) || (this.$offset = t.$offset),
          r.call(this, t);
      };
      var l = s.init;
      s.init = function () {
        if (this.$u) {
          var t = this.$d;
          (this.$y = t.getUTCFullYear()),
            (this.$M = t.getUTCMonth()),
            (this.$D = t.getUTCDate()),
            (this.$W = t.getUTCDay()),
            (this.$H = t.getUTCHours()),
            (this.$m = t.getUTCMinutes()),
            (this.$s = t.getUTCSeconds()),
            (this.$ms = t.getUTCMilliseconds());
        } else l.call(this);
      };
      var d = s.utcOffset;
      s.utcOffset = function (n, a) {
        var o = this.$utils().u;
        if (o(n))
          return this.$u ? 0 : o(this.$offset) ? d.call(this) : this.$offset;
        if (
          "string" == typeof n &&
          null ===
          (n = (function (t) {
            void 0 === t && (t = "");
            var n = t.match(e);
            if (!n) return null;
            var a = ("" + n[0]).match(i) || ["-", 0, 0],
              o = a[0],
              s = 60 * +a[1] + +a[2];
            return 0 === s ? 0 : "+" === o ? s : -s;
          })(n))
        )
          return this;
        var s = Math.abs(n) <= 16 ? 60 * n : n,
          r = this;
        if (a) return (r.$offset = s), (r.$u = 0 === n), r;
        if (0 !== n) {
          var l = this.$u
            ? this.toDate().getTimezoneOffset()
            : -1 * this.utcOffset();
          ((r = this.local().add(s + l, t)).$offset = s),
            (r.$x.$localOffset = l);
        } else r = this.utc();
        return r;
      };
      var c = s.format;
      (s.format = function (t) {
        var e = t || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
        return c.call(this, e);
      }),
        (s.valueOf = function () {
          var t = this.$utils().u(this.$offset)
            ? 0
            : this.$offset +
            (this.$x.$localOffset || new Date().getTimezoneOffset());
          return this.$d.valueOf() - 6e4 * t;
        }),
        (s.isUTC = function () {
          return !!this.$u;
        }),
        (s.toISOString = function () {
          return this.toDate().toISOString();
        }),
        (s.toString = function () {
          return this.toDate().toUTCString();
        });
      var u = s.toDate;
      s.toDate = function (t) {
        return "s" === t && this.$offset
          ? o(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate()
          : u.call(this);
      };
      var f = s.diff;
      s.diff = function (t, e, i) {
        if (t && this.$u === t.$u) return f.call(this, t, e, i);
        var n = this.local(),
          a = o(t).local();
        return f.call(n, a, e, i);
      };
    };
  }),
  (function (t, e) {
    "object" == typeof exports && "undefined" != typeof module
      ? (module.exports = e())
      : "function" == typeof define && define.amd
        ? define(e)
        : ((t =
          "undefined" != typeof globalThis
            ? globalThis
            : t || self).dayjs_plugin_timezone = e());
  })(this, function () {
    "use strict";
    var t = {
      year: 0,
      month: 1,
      day: 2,
      hour: 3,
      minute: 4,
      second: 5,
    },
      e = {};
    return function (i, n, a) {
      var o,
        s = function (t, i, n) {
          void 0 === n && (n = {});
          var a = new Date(t);
          return (function (t, i) {
            void 0 === i && (i = {});
            var n = i.timeZoneName || "short",
              a = t + "|" + n,
              o = e[a];
            return (
              o ||
              ((o = new Intl.DateTimeFormat("en-US", {
                hour12: !1,
                timeZone: t,
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
                timeZoneName: n,
              })),
                (e[a] = o)),
              o
            );
          })(i, n).formatToParts(a);
        },
        r = function (e, i) {
          for (var n = s(e, i), o = [], r = 0; r < n.length; r += 1) {
            var l = n[r],
              d = l.type,
              c = l.value,
              u = t[d];
            u >= 0 && (o[u] = parseInt(c, 10));
          }
          var f = o[3],
            p = 24 === f ? 0 : f,
            h =
              o[0] +
              "-" +
              o[1] +
              "-" +
              o[2] +
              " " +
              p +
              ":" +
              o[4] +
              ":" +
              o[5] +
              ":000",
            m = +e;
          return (a.utc(h).valueOf() - (m -= m % 1e3)) / 6e4;
        },
        l = n.prototype;
      (l.tz = function (t, e) {
        void 0 === t && (t = o);
        var i = this.utcOffset(),
          n = this.toDate(),
          s = n.toLocaleString("en-US", {
            timeZone: t,
          }),
          r = Math.round((n - new Date(s)) / 1e3 / 60),
          l = a(s)
            .$set("millisecond", this.$ms)
            .utcOffset(15 * -Math.round(n.getTimezoneOffset() / 15) - r, !0);
        if (e) {
          var d = l.utcOffset();
          l = l.add(i - d, "minute");
        }
        return (l.$x.$timezone = t), l;
      }),
        (l.offsetName = function (t) {
          var e = this.$x.$timezone || a.tz.guess(),
            i = s(this.valueOf(), e, {
              timeZoneName: t,
            }).find(function (t) {
              return "timezonename" === t.type.toLowerCase();
            });
          return i && i.value;
        });
      var d = l.startOf;
      (l.startOf = function (t, e) {
        if (!this.$x || !this.$x.$timezone) return d.call(this, t, e);
        var i = a(this.format("YYYY-MM-DD HH:mm:ss:SSS"));
        return d.call(i, t, e).tz(this.$x.$timezone, !0);
      }),
        (a.tz = function (t, e, i) {
          var n = i && e,
            s = i || e || o,
            l = r(+a(), s);
          if ("string" != typeof t) return a(t).tz(s);
          var d = (function (t, e, i) {
            var n = t - 60 * e * 1e3,
              a = r(n, i);
            if (e === a) return [n, e];
            var o = r((n -= 60 * (a - e) * 1e3), i);
            return a === o
              ? [n, a]
              : [t - 60 * Math.min(a, o) * 1e3, Math.max(a, o)];
          })(a.utc(t, n).valueOf(), l, s),
            c = d[0],
            u = d[1],
            f = a(c).utcOffset(u);
          return (f.$x.$timezone = s), f;
        }),
        (a.tz.guess = function () {
          return Intl.DateTimeFormat().resolvedOptions().timeZone;
        }),
        (a.tz.setDefault = function (t) {
          o = t;
        });
    };
  });
var dayjs_utc = window.dayjs_plugin_utc,
  dayjs_timezone = window.dayjs_plugin_timezone;
function createCommonjsModule(t, e, i) {
  return (
    t(
      (i = {
        path: e,
        exports: {},
        require: function (t, e) {
          return commonjsRequire(t, null == e ? i.path : e);
        },
      }),
      i.exports
    ),
    i.exports
  );
}
function commonjsRequire() {
  throw new Error("Error commonjs");
}
dayjs.locale("en"),
  dayjs.extend(dayjs_utc),
  dayjs.extend(dayjs_timezone),
  (function (t) {
    "function" == typeof define && define.amd
      ? define(["jQuery_T4NT"], t)
      : "object" == typeof exports
        ? t(require("jQuery_T4NT"))
        : t(window.jQuery_T4NT || window.Zepto);
  })(function (t) {
    var e,
      i,
      n,
      a,
      o,
      s,
      r = {},
      l = function () { },
      d = !!window.jQuery_T4NT,
      c = t(window),
      u = function (t, i) {
        e.ev.on("mfp" + t + ".mfp", i);
      },
      f = function (e, i, n, a) {
        var o = document.createElement("div");
        return (
          (o.className = "mfp-" + e),
          n && (o.innerHTML = n),
          a ? i && i.appendChild(o) : ((o = t(o)), i && o.appendTo(i)),
          o
        );
      },
      p = function (i, n) {
        e.ev.triggerHandler("mfp" + i, n),
          e.st.callbacks &&
          ((i = i.charAt(0).toLowerCase() + i.slice(1)),
            e.st.callbacks[i] &&
            e.st.callbacks[i].apply(e, t.isArray(n) ? n : [n]));
      },
      h = function (i) {
        return (
          (i === s && e.currTemplate.closeBtn) ||
          ((e.currTemplate.closeBtn = t(
            e.st.closeMarkup.replace("%title%", e.st.tClose)
          )),
            (s = i)),
          e.currTemplate.closeBtn
        );
      },
      m = function () {
        t.magnificPopupT4s.instance ||
          ((e = new l()).init(), (t.magnificPopupT4s.instance = e));
      };
    (l.prototype = {
      constructor: l,
      init: function () {
        var i = navigator.appVersion;
        (e.isLowIE = e.isIE8 = document.all && !document.addEventListener),
          (e.isAndroid = /android/gi.test(i)),
          (e.isIOS = /iphone|ipad|ipod/gi.test(i)),
          (e.supportsTransition = (function () {
            var t = document.createElement("p").style,
              e = ["ms", "O", "Moz", "Webkit"];
            if (void 0 !== t.transition) return !0;
            for (; e.length;) if (e.pop() + "Transition" in t) return !0;
            return !1;
          })()),
          (e.probablyMobile =
            e.isAndroid ||
            e.isIOS ||
            /(Opera Mini)|Kindle|webOS|BlackBerry|(Opera Mobi)|(Windows Phone)|IEMobile/i.test(
              navigator.userAgent
            )),
          (n = t(document)),
          (e.popupsCache = {});
      },
      open: function (i) {
        var a;
        if (!1 === i.isObj) {
          (e.items = i.items.toArray()), (e.index = 0);
          var s,
            r = i.items;
          for (a = 0; a < r.length; a++)
            if (((s = r[a]).parsed && (s = s.el[0]), s === i.el[0])) {
              e.index = a;
              break;
            }
        } else
          (e.items = t.isArray(i.items) ? i.items : [i.items]),
            (e.index = i.index || 0);
        if (!e.isOpen) {
          (e.types = []),
            (o = ""),
            i.mainEl && i.mainEl.length ? (e.ev = i.mainEl.eq(0)) : (e.ev = n),
            i.key
              ? (e.popupsCache[i.key] || (e.popupsCache[i.key] = {}),
                (e.currTemplate = e.popupsCache[i.key]))
              : (e.currTemplate = {}),
            (e.st = t.extend(!0, {}, t.magnificPopupT4s.defaults, i)),
            (e.fixedContentPos =
              "auto" === e.st.fixedContentPos
                ? !e.probablyMobile
                : e.st.fixedContentPos),
            e.st.modal &&
            ((e.st.closeOnContentClick = !1),
              (e.st.closeOnBgClick = !1),
              (e.st.showCloseBtn = !1),
              (e.st.enableEscapeKey = !1)),
            e.bgOverlay ||
            ((e.bgOverlay = f("bg").on("click.mfp", function () {
              e.close();
            })),
              (e.wrap = f("wrap")
                .attr("tabindex", -1)
                .on("click.mfp", function (t) {
                  e._checkIfClose(t.target) && e.close();
                })),
              (e.container = f("container", e.wrap))),
            (e.contentContainer = f("content")),
            e.st.preloader &&
            (e.preloader = f("preloader", e.container, e.st.tLoading));
          var l = t.magnificPopupT4s.modules;
          for (a = 0; a < l.length; a++) {
            var d = l[a];
            (d = d.charAt(0).toUpperCase() + d.slice(1)), e["init" + d].call(e);
          }
          p("BeforeOpen"),
            e.st.showCloseBtn &&
            (e.st.closeBtnInside
              ? (u("MarkupParse", function (t, e, i, n) {
                i.close_replaceWith = h(n.type);
              }),
                (o += " mfp-close-btn-in"))
              : e.wrap.append(h())),
            e.st.alignTop && (o += " mfp-align-top"),
            e.fixedContentPos
              ? e.wrap.css({
                overflow: e.st.overflowY,
                overflowX: "hidden",
                overflowY: e.st.overflowY,
              })
              : e.wrap.css({
                top: c.scrollTop(),
                position: "absolute",
              }),
            (!1 === e.st.fixedBgPos ||
              ("auto" === e.st.fixedBgPos && !e.fixedContentPos)) &&
            e.bgOverlay.css({
              height: n.height(),
              position: "absolute",
            }),
            e.st.enableEscapeKey &&
            n.on("keyup.mfp", function (t) {
              27 === t.keyCode && e.close();
            }),
            c.on("resize.mfp", function () {
              e.updateSize();
            }),
            e.st.closeOnContentClick || (o += " mfp-auto-cursor"),
            o && e.wrap.addClass(o);
          var m = (e.wH = c.height()),
            g = {};
          if (e.fixedContentPos && e._hasScrollBar(m)) {
            var v = e._getScrollbarSize();
            v && (g.marginRight = v);
          }
          e.isIE7
            ? t("body, html").css("overflow", "hidden")
            : (g.overflow = "hidden");
          var y = e.st.mainClass;
          return (
            e.isIE7 && (y += " mfp-ie7"),
            y && e._addClassToMFP(y),
            e.updateItemHTML(),
            p("BuildControls"),
            t("html").css(g),
            e.bgOverlay
              .add(e.wrap)
              .prependTo(e.st.prependTo || t(document.body)),
            (e._lastFocusedEl = document.activeElement),
            setTimeout(function () {
              e.content
                ? (e._addClassToMFP("mfp-ready"), e._setFocus())
                : e.bgOverlay.addClass("mfp-ready"),
                n.on("focusin.mfp", e._onFocusIn);
            }, 16),
            (e.isOpen = !0),
            e.updateSize(m),
            p("Open"),
            i
          );
        }
        e.updateItemHTML();
      },
      close: function () {
        e.isOpen &&
          (p("BeforeClose"),
            (e.isOpen = !1),
            e.st.removalDelay && !e.isLowIE && e.supportsTransition
              ? (e._addClassToMFP("mfp-removing"),
                setTimeout(function () {
                  e._close();
                }, e.st.removalDelay))
              : e._close());
      },
      _close: function () {
        p("Close");
        var i = "mfp-removing mfp-ready ";
        if (
          (e.bgOverlay.detach(),
            e.wrap.detach(),
            e.container.empty(),
            e.st.mainClass && (i += e.st.mainClass + " "),
            e._removeClassFromMFP(i),
            e.fixedContentPos)
        ) {
          var a = {
            marginRight: "",
          };
          e.isIE7 ? t("body, html").css("overflow", "") : (a.overflow = ""),
            t("html").css(a);
        }
        var a = {
          marginRight: "",
        };
        e.isIE7 ? t("body, html").css("overflow", "") : (a.overflow = ""),
          t("html").css(a);
        n.off("keyup.mfp focusin.mfp"),
          e.ev.off(".mfp"),
          e.wrap.attr("class", "mfp-wrap").removeAttr("style"),
          e.bgOverlay.attr("class", "mfp-bg"),
          e.container.attr("class", "mfp-container"),
          !e.st.showCloseBtn ||
          (e.st.closeBtnInside && !0 !== e.currTemplate[e.currItem.type]) ||
          (e.currTemplate.closeBtn && e.currTemplate.closeBtn.detach()),
          e.st.autoFocusLast && e._lastFocusedEl && t(e._lastFocusedEl).focus(),
          (e.currItem = null),
          (e.content = null),
          (e.currTemplate = null),
          (e.prevHeight = 0),
          p("AfterClose");
      },
      updateSize: function (t) {
        if (e.isIOS) {
          var i = document.documentElement.clientWidth / window.innerWidth,
            n = window.innerHeight * i;
          e.wrap.css("height", n), (e.wH = n);
        } else e.wH = t || c.height();
        e.fixedContentPos || e.wrap.css("height", e.wH), p("Resize");
      },
      updateItemHTML: function () {
        var i = e.items[e.index];
        e.contentContainer.detach(),
          e.content && e.content.detach(),
          i.parsed || (i = e.parseEl(e.index));
        var n = i.type;
        if (
          (p("BeforeChange", [e.currItem ? e.currItem.type : "", n]),
            (e.currItem = i),
            !e.currTemplate[n])
        ) {
          var o = !!e.st[n] && e.st[n].markup;
          p("FirstMarkupParse", o), (e.currTemplate[n] = !o || t(o));
        }
        a && a !== i.type && e.container.removeClass("mfp-" + a + "-holder");
        var s = e["get" + n.charAt(0).toUpperCase() + n.slice(1)](
          i,
          e.currTemplate[n]
        );
        e.appendContent(s, n),
          (i.preloaded = !0),
          p("Change", i),
          (a = i.type),
          e.container.prepend(e.contentContainer),
          p("AfterChange");
      },
      appendContent: function (t, i, n) {
        if ("" == t && "ajax" == i) return !1;
        (e.content = t),
          t
            ? e.st.showCloseBtn &&
              e.st.closeBtnInside &&
              !0 === e.currTemplate[i]
              ? e.content.find(".mfp-close").length || e.content.append(h())
              : (e.content = t)
            : (e.content = ""),
          p("BeforeAppend"),
          e.container.addClass("mfp-" + i + "-holder"),
          e.contentContainer.append(e.content);
      },
      parseEl: function (i) {
        var n,
          a = e.items[i];
        if (
          (a.tagName
            ? (a = {
              el: t(a),
            })
            : ((n = a.type),
              (a = {
                data: a,
                src: a.src,
              })),
            a.el)
        ) {
          for (var o = e.types, s = 0; s < o.length; s++)
            if (a.el.hasClass("mfp-" + o[s])) {
              n = o[s];
              break;
            }
          (a.src = a.el.attr("data-mfp-src")),
            a.src || (a.src = a.el.attr("href"));
        }
        return (
          (a.type = n || e.st.type || "inline"),
          (a.index = i),
          (a.parsed = !0),
          (e.items[i] = a),
          p("ElementParse", a),
          e.items[i]
        );
      },
      addGroup: function (t, i) {
        var n = function (n) {
          (n.mfpEl = this), e._openClick(n, t, i);
        };
        i || (i = {});
        var a = "click.magnificPopupT4s";
        (i.mainEl = t),
          i.items
            ? ((i.isObj = !0), t.off(a).on(a, n))
            : ((i.isObj = !1),
              i.delegate
                ? t.off(a).on(a, i.delegate, n)
                : ((i.items = t), t.off(a).on(a, n)));
      },
      _openClick: function (i, n, a) {
        if (
          (void 0 !== a.midClick
            ? a.midClick
            : t.magnificPopupT4s.defaults.midClick) ||
          !(2 === i.which || i.ctrlKey || i.metaKey || i.altKey || i.shiftKey)
        ) {
          var o =
            void 0 !== a.disableOn
              ? a.disableOn
              : t.magnificPopupT4s.defaults.disableOn;
          if (o)
            if (t.isFunction(o)) {
              if (!o.call(e)) return !0;
            } else if (c.width() < o) return !0;
          i.type && (i.preventDefault(), e.isOpen && i.stopPropagation()),
            (a.el = t(i.mfpEl)),
            a.delegate && (a.items = n.find(a.delegate)),
            e.open(a);
        }
      },
      updateStatus: function (t, n) {
        if (e.preloader) {
          i !== t && e.container.removeClass("mfp-s-" + i),
            n || "loading" !== t || (n = e.st.tLoading);
          var a = {
            status: t,
            text: n,
          };
          p("UpdateStatus", a),
            (t = a.status),
            (n = a.text),
            e.preloader.html(n),
            e.preloader.find("a").on("click", function (t) {
              t.stopImmediatePropagation();
            }),
            e.container.addClass("mfp-s-" + t),
            (i = t);
        }
      },
      _checkIfClose: function (i) {
        if (!t(i).hasClass("mfp-prevent-close")) {
          var n = e.st.closeOnContentClick,
            a = e.st.closeOnBgClick;
          if (n && a) return !0;
          if (
            !e.content ||
            t(i).hasClass("mfp-close") ||
            (e.preloader && i === e.preloader[0])
          )
            return !0;
          if (i === e.content[0] || t.contains(e.content[0], i)) {
            if (n) return !0;
          } else if (a && t.contains(document, i)) return !0;
          return !1;
        }
      },
      _addClassToMFP: function (t) {
        e.bgOverlay.addClass(t), e.wrap.addClass(t);
      },
      _removeClassFromMFP: function (t) {
        this.bgOverlay.removeClass(t), e.wrap.removeClass(t);
      },
      _hasScrollBar: function (t) {
        return (
          (e.isIE7 ? n.height() : document.body.scrollHeight) >
          (t || c.height())
        );
      },
      _setFocus: function () {
        (e.st.focus ? e.content.find(e.st.focus).eq(0) : e.wrap).focus();
      },
      _onFocusIn: function (i) {
        if (i.target !== e.wrap[0] && !t.contains(e.wrap[0], i.target))
          return e._setFocus(), !1;
      },
      _parseMarkup: function (e, i, n) {
        var a;
        n.data && (i = t.extend(n.data, i)),
          p("MarkupParse", [e, i, n]),
          t.each(i, function (i, n) {
            if (void 0 === n || !1 === n) return !0;
            if ((a = i.split("_")).length > 1) {
              var o = e.find(".mfp-" + a[0]);
              if (o.length > 0) {
                var s = a[1];
                "replaceWith" === s
                  ? o[0] !== n[0] && o.replaceWith(n)
                  : "img" === s
                    ? o.is("img")
                      ? o.attr("src", n)
                      : o.replaceWith(
                        t("<img>").attr("src", n).attr("class", o.attr("class"))
                      )
                    : o.attr(a[1], n);
              }
            } else e.find(".mfp-" + i).html(n);
          });
      },
      _getScrollbarSize: function () {
        if (void 0 === e.scrollbarSize) {
          var t = document.createElement("div");
          (t.style.cssText =
            "width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;"),
            document.body.appendChild(t),
            (e.scrollbarSize = t.offsetWidth - t.clientWidth),
            document.body.removeChild(t);
        }
        return e.scrollbarSize;
      },
    }),
      (t.magnificPopupT4s = {
        instance: null,
        proto: l.prototype,
        modules: [],
        open: function (e, i) {
          return (
            m(),
            ((e = e ? t.extend(!0, {}, e) : {}).isObj = !0),
            (e.index = i || 0),
            this.instance.open(e)
          );
        },
        close: function () {
          return (
            t.magnificPopupT4s.instance && t.magnificPopupT4s.instance.close()
          );
        },
        registerModule: function (e, i) {
          i.options && (t.magnificPopupT4s.defaults[e] = i.options),
            t.extend(this.proto, i.proto),
            this.modules.push(e);
        },
        defaults: {
          disableOn: 0,
          key: null,
          midClick: !1,
          mainClass: "",
          preloader: !0,
          focus: "",
          closeOnContentClick: !1,
          closeOnBgClick: !0,
          closeBtnInside: !0,
          showCloseBtn: !0,
          enableEscapeKey: !0,
          modal: !1,
          alignTop: !1,
          removalDelay: 0,
          prependTo: null,
          fixedContentPos: "auto",
          fixedBgPos: "auto",
          overflowY: "auto",
          closeMarkup:
            '<button title="%title%" type="button" class="mfp-close"><svg class="t4smfp-icon-close" role="presentation" viewBox="0 0 16 14"><path d="M15 0L1 14m14 0L1 0" stroke="currentColor" fill="none" fill-rule="evenodd"></path></svg></button>',
          tClose: "Close (Esc)",
          tLoading: "Loading...",
          autoFocusLast: !0,
        },
      }),
      (t.fn.magnificPopupT4s = function (i) {
        m();
        var n = t(this);
        if ("string" == typeof i)
          if ("open" === i) {
            var a,
              o = d ? n.data("magnificPopup") : n[0].magnificPopupT4s,
              s = parseInt(arguments[1], 10) || 0;
            o.items
              ? (a = o.items[s])
              : ((a = n),
                o.delegate && (a = a.find(o.delegate)),
                (a = a.eq(s))),
              e._openClick(
                {
                  mfpEl: a,
                },
                n,
                o
              );
          } else
            e.isOpen && e[i].apply(e, Array.prototype.slice.call(arguments, 1));
        else
          (i = t.extend(!0, {}, i)),
            d ? n.data("magnificPopup", i) : (n[0].magnificPopupT4s = i),
            e.addGroup(n, i);
        return n;
      });
    var g,
      v,
      y,
      b = function () {
        y && (v.after(y.addClass(g)).detach(), (y = null));
      };
    t.magnificPopupT4s.registerModule("inline", {
      options: {
        hiddenClass: "hide",
        markup: "",
        tNotFound: "Content not found",
      },
      proto: {
        initInline: function () {
          e.types.push("inline"),
            u("Close.inline", function () {
              b();
            });
        },
        getInline: function (i, n) {
          if ((b(), i.src)) {
            var a = e.st.inline,
              o = t(i.src);
            if (o.length) {
              var s = o[0].parentNode;
              s &&
                s.tagName &&
                (v || ((g = a.hiddenClass), (v = f(g)), (g = "mfp-" + g)),
                  (y = o.after(v).detach().removeClass(g))),
                e.updateStatus("ready");
            } else e.updateStatus("error", a.tNotFound), (o = t("<div>"));
            return (i.inlineElement = o), o;
          }
          return e.updateStatus("ready"), e._parseMarkup(n, {}, i), n;
        },
      },
    });
    var S,
      w,
      T,
      _ = function () {
        S && t(document.body).removeClass(S);
      },
      C = function () {
        _(), e.req && e.req.abort();
      };
    t.magnificPopupT4s.registerModule("ajax", {
      options: {
        settings: null,
        cursor: "mfp-ajax-cur",
        tError: '<a href="%url%">The content</a> could not be loaded.',
      },
      proto: {
        initAjax: function () {
          e.types.push("ajax"),
            (S = e.st.ajax.cursor),
            u("Close.ajax", C),
            u("BeforeChange.ajax", C);
        },
        getAjax: function (i) {
          S && t(document.body).addClass(S), e.updateStatus("loading");
          var n = t(i.el).attr("data-storageid") || "nt94",
            a = t.extend(
              {
                url: i.src,
                success: function (a, o, s) {
                  var l = {
                    data: a,
                    xhr: s,
                  };
                  p("ParseAjax", l),
                    e.appendContent(t(l.data), "ajax"),
                    (i.finished = !0),
                    _(),
                    e._setFocus(),
                    setTimeout(function () {
                      e.wrap.addClass("mfp-ready");
                    }, 16),
                    e.updateStatus("ready"),
                    p("AjaxContentAdded"),
                    (r[n] = a);
                },
                error: function () {
                  _(),
                    (i.finished = i.loadError = !0),
                    e.updateStatus(
                      "error",
                      e.st.ajax.tError.replace("%url%", i.src)
                    );
                },
              },
              e.st.ajax.settings
            ),
            o = r[n];
          if (void 0 !== o) {
            var s = {
              data: o,
            };
            p("ParseAjax", s),
              e.appendContent(t(s.data), "ajax"),
              _(),
              e._setFocus(),
              setTimeout(function () {
                e.wrap.addClass("mfp-ready");
              }, 16),
              e.updateStatus("ready"),
              p("AjaxContentAdded");
          } else e.req = t.ajax(a);
          return "";
        },
      },
    }),
      t.magnificPopupT4s.registerModule("image", {
        options: {
          markup:
            '<div class="mfp-figure"><div class="mfp-close"></div><figure><div class="mfp-img"></div><figcaption><div class="mfp-bottom-bar"><div class="mfp-title"></div><div class="mfp-counter"></div></div></figcaption></figure></div>',
          cursor: "mfp-zoom-out-cur",
          titleSrc: "title",
          verticalFit: !0,
          tError: '<a href="%url%">The image</a> could not be loaded.',
        },
        proto: {
          initImage: function () {
            var i = e.st.image,
              n = ".image";
            e.types.push("image"),
              u("Open" + n, function () {
                "image" === e.currItem.type &&
                  i.cursor &&
                  t(document.body).addClass(i.cursor);
              }),
              u("Close" + n, function () {
                i.cursor && t(document.body).removeClass(i.cursor),
                  c.off("resize.mfp");
              }),
              u("Resize" + n, e.resizeImage),
              e.isLowIE && u("AfterChange", e.resizeImage);
          },
          resizeImage: function () {
            var t = e.currItem;
            if (t && t.img && e.st.image.verticalFit) {
              var i = 0;
              e.isLowIE &&
                (i =
                  parseInt(t.img.css("padding-top"), 10) +
                  parseInt(t.img.css("padding-bottom"), 10)),
                t.img.css("max-height", e.wH - i);
            }
          },
          _onImageHasSize: function (t) {
            t.img &&
              ((t.hasSize = !0),
                w && clearInterval(w),
                (t.isCheckingImgSize = !1),
                p("ImageHasSize", t),
                t.imgHidden &&
                (e.content && e.content.removeClass("mfp-loading"),
                  (t.imgHidden = !1)));
          },
          findImageSize: function (t) {
            var i = 0,
              n = t.img[0],
              a = function (o) {
                w && clearInterval(w),
                  (w = setInterval(function () {
                    n.naturalWidth > 0
                      ? e._onImageHasSize(t)
                      : (i > 200 && clearInterval(w),
                        3 == ++i
                          ? a(10)
                          : 40 === i
                            ? a(50)
                            : 100 === i && a(500));
                  }, o));
              };
            a(1);
          },
          getImage: function (i, n) {
            var a = 0,
              o = function () {
                i &&
                  (i.img[0].complete
                    ? (i.img.off(".mfploader"),
                      i === e.currItem &&
                      (e._onImageHasSize(i), e.updateStatus("ready")),
                      (i.hasSize = !0),
                      (i.loaded = !0),
                      p("ImageLoadComplete"))
                    : ++a < 200
                      ? setTimeout(o, 100)
                      : s());
              },
              s = function () {
                i &&
                  (i.img.off(".mfploader"),
                    i === e.currItem &&
                    (e._onImageHasSize(i),
                      e.updateStatus("error", r.tError.replace("%url%", i.src))),
                    (i.hasSize = !0),
                    (i.loaded = !0),
                    (i.loadError = !0));
              },
              r = e.st.image,
              l = n.find(".mfp-img");
            if (l.length) {
              var d = document.createElement("img");
              (d.className = "mfp-img"),
                i.el &&
                i.el.find("img").length &&
                (d.alt = i.el.find("img").attr("alt")),
                (i.img = t(d).on("load.mfploader", o).on("error.mfploader", s)),
                (d.src = i.src),
                l.is("img") && (i.img = i.img.clone()),
                (d = i.img[0]).naturalWidth > 0
                  ? (i.hasSize = !0)
                  : d.width || (i.hasSize = !1);
            }
            return (
              e._parseMarkup(
                n,
                {
                  title: (function (i) {
                    if (i.data && void 0 !== i.data.title) return i.data.title;
                    var n = e.st.image.titleSrc;
                    if (n) {
                      if (t.isFunction(n)) return n.call(e, i);
                      if (i.el) return i.el.attr(n) || "";
                    }
                    return "";
                  })(i),
                  img_replaceWith: i.img,
                },
                i
              ),
              e.resizeImage(),
              i.hasSize
                ? (w && clearInterval(w),
                  i.loadError
                    ? (n.addClass("mfp-loading"),
                      e.updateStatus("error", r.tError.replace("%url%", i.src)))
                    : (n.removeClass("mfp-loading"), e.updateStatus("ready")),
                  n)
                : (e.updateStatus("loading"),
                  (i.loading = !0),
                  i.hasSize ||
                  ((i.imgHidden = !0),
                    n.addClass("mfp-loading"),
                    e.findImageSize(i)),
                  n)
            );
          },
        },
      }),
      t.magnificPopupT4s.registerModule("zoom", {
        options: {
          enabled: !1,
          easing: "ease-in-out",
          duration: 300,
          opener: function (t) {
            return t.is("img") ? t : t.find("img");
          },
        },
        proto: {
          initZoom: function () {
            var t,
              i = e.st.zoom,
              n = ".zoom";
            if (i.enabled && e.supportsTransition) {
              var a,
                o,
                s = i.duration,
                r = function (t) {
                  var e = t
                    .clone()
                    .removeAttr("style")
                    .removeAttr("class")
                    .addClass("mfp-animated-image"),
                    n = "all " + i.duration / 1e3 + "s " + i.easing,
                    a = {
                      position: "fixed",
                      zIndex: 9999,
                      left: 0,
                      top: 0,
                      "-webkit-backface-visibility": "hidden",
                    },
                    o = "transition";
                  return (
                    (a["-webkit-" + o] =
                      a["-moz-" + o] =
                      a["-o-" + o] =
                      a[o] =
                      n),
                    e.css(a),
                    e
                  );
                },
                l = function () {
                  e.content.css("visibility", "visible");
                };
              u("BuildControls" + n, function () {
                if (e._allowZoom()) {
                  if (
                    (clearTimeout(a),
                      e.content.css("visibility", "hidden"),
                      !(t = e._getItemToZoom()))
                  )
                    return void l();
                  (o = r(t)).css(e._getOffset()),
                    e.wrap.append(o),
                    (a = setTimeout(function () {
                      o.css(e._getOffset(!0)),
                        (a = setTimeout(function () {
                          l(),
                            setTimeout(function () {
                              o.remove(),
                                (t = o = null),
                                p("ZoomAnimationEnded");
                            }, 16);
                        }, s));
                    }, 16));
                }
              }),
                u("BeforeClose" + n, function () {
                  if (e._allowZoom()) {
                    if ((clearTimeout(a), (e.st.removalDelay = s), !t)) {
                      if (!(t = e._getItemToZoom())) return;
                      o = r(t);
                    }
                    o.css(e._getOffset(!0)),
                      e.wrap.append(o),
                      e.content.css("visibility", "hidden"),
                      setTimeout(function () {
                        o.css(e._getOffset());
                      }, 16);
                  }
                }),
                u("Close" + n, function () {
                  e._allowZoom() && (l(), o && o.remove(), (t = null));
                });
            }
          },
          _allowZoom: function () {
            return "image" === e.currItem.type;
          },
          _getItemToZoom: function () {
            return !!e.currItem.hasSize && e.currItem.img;
          },
          _getOffset: function (i) {
            var n,
              a = (n = i
                ? e.currItem.img
                : e.st.zoom.opener(e.currItem.el || e.currItem)).offset(),
              o = parseInt(n.css("padding-top"), 10),
              s = parseInt(n.css("padding-bottom"), 10);
            a.top -= t(window).scrollTop() - o;
            var r = {
              width: n.width(),
              height: (d ? n.innerHeight() : n[0].offsetHeight) - s - o,
            };
            return (
              void 0 === T &&
              (T = void 0 !== document.createElement("p").style.MozTransform),
              T
                ? (r["-moz-transform"] = r.transform =
                  "translate(" + a.left + "px," + a.top + "px)")
                : ((r.left = a.left), (r.top = a.top)),
              r
            );
          },
        },
      });
    var $ = function (t) {
      if (e.currTemplate.iframe) {
        var i = e.currTemplate.iframe.find("iframe");
        i.length &&
          (t || (i[0].src = "//about:blank"),
            e.isIE8 && i.css("display", t ? "block" : "none"));
      }
    };
    t.magnificPopupT4s.registerModule("iframe", {
      options: {
        markup:
          '<div class="mfp-iframe-scaler"><div class="mfp-close"></div><iframe class="mfp-iframe" src="//about:blank" frameborder="0" allowfullscreen></iframe></div>',
        srcAction: "iframe_src",
        patterns: {
          youtube: {
            index: "youtube.com",
            id: "v=",
            src: "//www.youtube.com/embed/%id%?autoplay=1",
          },
          vimeo: {
            index: "vimeo.com/",
            id: "/",
            src: "//player.vimeo.com/video/%id%?autoplay=1",
          },
          gmaps: {
            index: "//maps.google.",
            src: "%id%&output=embed",
          },
        },
      },
      proto: {
        initIframe: function () {
          e.types.push("iframe"),
            u("BeforeChange", function (t, e, i) {
              e !== i && ("iframe" === e ? $() : "iframe" === i && $(!0));
            }),
            u("Close.iframe", function () {
              $();
            });
        },
        getIframe: function (i, n) {
          var a = i.src,
            o = e.st.iframe;
          t.each(o.patterns, function () {
            if (a.indexOf(this.index) > -1)
              return (
                this.id &&
                (a =
                  "string" == typeof this.id
                    ? a.substr(
                      a.lastIndexOf(this.id) + this.id.length,
                      a.length
                    )
                    : this.id.call(this, a)),
                (a = this.src.replace(/%id%/g, a)),
                !1
              );
          });
          var s = {};
          return (
            o.srcAction && (s[o.srcAction] = a),
            e._parseMarkup(n, s, i),
            e.updateStatus("ready"),
            n
          );
        },
      },
    });
    var k = function (t) {
      var i = e.items.length;
      return t > i - 1 ? t - i : t < 0 ? i + t : t;
    },
      x = function (t, e, i) {
        return t.replace(/%curr%/gi, e + 1).replace(/%total%/gi, i);
      };
    t.magnificPopupT4s.registerModule("gallery", {
      options: {
        enabled: !1,
        arrowMarkup:
          '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>',
        preload: [0, 2],
        navigateByImgClick: !0,
        arrows: !0,
        tPrev: "Previous (Left arrow key)",
        tNext: "Next (Right arrow key)",
        tCounter: "%curr% of %total%",
      },
      proto: {
        initGallery: function () {
          var i = e.st.gallery,
            a = ".mfp-gallery";
          if (((e.direction = !0), !i || !i.enabled)) return !1;
          (o += " mfp-gallery"),
            u("Open" + a, function () {
              i.navigateByImgClick &&
                e.wrap.on("click" + a, ".mfp-img", function () {
                  if (e.items.length > 1) return e.next(), !1;
                }),
                n.on("keydown" + a, function (t) {
                  37 === t.keyCode ? e.prev() : 39 === t.keyCode && e.next();
                });
            }),
            u("UpdateStatus" + a, function (t, i) {
              i.text && (i.text = x(i.text, e.currItem.index, e.items.length));
            }),
            u("MarkupParse" + a, function (t, n, a, o) {
              var s = e.items.length;
              a.counter = s > 1 ? x(i.tCounter, o.index, s) : "";
            }),
            u("BuildControls" + a, function () {
              if (e.items.length > 1 && i.arrows && !e.arrowLeft) {
                var n = i.arrowMarkup,
                  a = (e.arrowLeft = t(
                    n.replace(/%title%/gi, i.tPrev).replace(/%dir%/gi, "left")
                  ).addClass("mfp-prevent-close")),
                  o = (e.arrowRight = t(
                    n.replace(/%title%/gi, i.tNext).replace(/%dir%/gi, "right")
                  ).addClass("mfp-prevent-close"));
                a.click(function () {
                  e.prev();
                }),
                  o.click(function () {
                    e.next();
                  }),
                  e.container.append(a.add(o));
              }
            }),
            u("Change" + a, function () {
              e._preloadTimeout && clearTimeout(e._preloadTimeout),
                (e._preloadTimeout = setTimeout(function () {
                  e.preloadNearbyImages(), (e._preloadTimeout = null);
                }, 16));
            }),
            u("Close" + a, function () {
              n.off(a),
                e.wrap.off("click" + a),
                (e.arrowRight = e.arrowLeft = null);
            });
        },
        next: function () {
          (e.direction = !0), (e.index = k(e.index + 1)), e.updateItemHTML();
        },
        prev: function () {
          (e.direction = !1), (e.index = k(e.index - 1)), e.updateItemHTML();
        },
        goTo: function (t) {
          (e.direction = t >= e.index), (e.index = t), e.updateItemHTML();
        },
        preloadNearbyImages: function () {
          var t,
            i = e.st.gallery.preload,
            n = Math.min(i[0], e.items.length),
            a = Math.min(i[1], e.items.length);
          for (t = 1; t <= (e.direction ? a : n); t++)
            e._preloadItem(e.index + t);
          for (t = 1; t <= (e.direction ? n : a); t++)
            e._preloadItem(e.index - t);
        },
        _preloadItem: function (i) {
          if (((i = k(i)), !e.items[i].preloaded)) {
            var n = e.items[i];
            n.parsed || (n = e.parseEl(i)),
              p("LazyLoad", n),
              "image" === n.type &&
              (n.img = t('<img class="mfp-img" />')
                .on("load.mfploader", function () {
                  n.hasSize = !0;
                })
                .on("error.mfploader", function () {
                  (n.hasSize = !0), (n.loadError = !0), p("LazyLoadError", n);
                })
                .attr("src", n.src)),
              (n.preloaded = !0);
          }
        },
      },
    }),
      t.magnificPopupT4s.registerModule("retina", {
        options: {
          replaceSrc: function (t) {
            return t.src.replace(/\.\w+$/, function (t) {
              return "@2x" + t;
            });
          },
          ratio: 1,
        },
        proto: {
          initRetina: function () {
            if (window.devicePixelRatio > 1) {
              var t = e.st.retina,
                i = t.ratio;
              (i = isNaN(i) ? i() : i) > 1 &&
                (u("ImageHasSize.retina", function (t, e) {
                  e.img.css({
                    "max-width": e.img[0].naturalWidth / i,
                    width: "100%",
                  });
                }),
                  u("ElementParse.retina", function (e, n) {
                    n.src = t.replaceSrc(n, i);
                  }));
            }
          },
        },
      }),
      m();
  });
var fastdomT4s = createCommonjsModule(function (t) {
  !(function (e) {
    var i = function () { },
      n =
        e.requestAnimationFrame ||
        e.webkitRequestAnimationFrame ||
        e.mozRequestAnimationFrame ||
        e.msRequestAnimationFrame ||
        function (t) {
          return setTimeout(t, 16);
        };
    function a() {
      (this.reads = []), (this.writes = []), (this.raf = n.bind(e));
    }
    function o(t) {
      t.scheduled ||
        ((t.scheduled = !0),
          t.raf(
            function (t) {
              var e,
                n = t.writes,
                a = t.reads;
              try {
                i("flushing reads", a.length),
                  s(a),
                  i("flushing writes", n.length),
                  s(n);
              } catch (t) {
                e = t;
              }
              (t.scheduled = !1), (a.length || n.length) && o(t);
              if (e) {
                if ((i("task errored", e.message), !t.catch)) throw e;
                t.catch(e);
              }
            }.bind(null, t)
          ));
    }
    function s(t) {
      for (var e; (e = t.shift());) e();
    }
    function r(t, e) {
      var i = t.indexOf(e);
      return !!~i && !!t.splice(i, 1);
    }
    a.prototype = {
      constructor: a,
      measure: function (t, e) {
        var i = e ? t.bind(e) : t;
        return this.reads.push(i), o(this), i;
      },
      mutate: function (t, e) {
        var i = e ? t.bind(e) : t;
        return this.writes.push(i), o(this), i;
      },
      clear: function (t) {
        return r(this.reads, t) || r(this.writes, t);
      },
      extend: function (t) {
        if ("object" != _typeof(t)) throw new Error("expected object");
        var e = Object.create(this);
        return (
          (function (t, e) {
            for (var i in e) e.hasOwnProperty(i) && (t[i] = e[i]);
          })(e, t),
          (e.fastdom = this),
          e.initialize && e.initialize(),
          e
        );
      },
      catch: null,
    };
    var l = (e.fastdom = e.fastdom || new a());
    t.exports = l;
  })("undefined" != typeof window ? window : commonjsGlobal);
}),
  smoothscroll = createCommonjsModule(function (t, e) {
    !(function () {
      t.exports = {
        polyfill: function () {
          var t = window,
            e = document;
          if (
            !(
              "scrollBehavior" in e.documentElement.style &&
              !0 !== t.__forceSmoothScrollPolyfill__
            )
          ) {
            var i,
              n = t.HTMLElement || t.Element,
              a = 468,
              o = {
                scroll: t.scroll || t.scrollTo,
                scrollBy: t.scrollBy,
                elementScroll: n.prototype.scroll || l,
                scrollIntoView: n.prototype.scrollIntoView,
              },
              s =
                t.performance && t.performance.now
                  ? t.performance.now.bind(t.performance)
                  : Date.now,
              r =
                ((i = t.navigator.userAgent),
                  new RegExp(["MSIE ", "Trident/", "Edge/"].join("|")).test(i)
                    ? 1
                    : 0);
            (t.scroll = t.scrollTo =
              function () {
                void 0 !== arguments[0] &&
                  (!0 !== d(arguments[0])
                    ? h.call(
                      t,
                      e.body,
                      void 0 !== arguments[0].left
                        ? ~~arguments[0].left
                        : t.scrollX || t.pageXOffset,
                      void 0 !== arguments[0].top
                        ? ~~arguments[0].top
                        : t.scrollY || t.pageYOffset
                    )
                    : o.scroll.call(
                      t,
                      void 0 !== arguments[0].left
                        ? arguments[0].left
                        : "object" !== _typeof(arguments[0])
                          ? arguments[0]
                          : t.scrollX || t.pageXOffset,
                      void 0 !== arguments[0].top
                        ? arguments[0].top
                        : void 0 !== arguments[1]
                          ? arguments[1]
                          : t.scrollY || t.pageYOffset
                    ));
              }),
              (t.scrollBy = function () {
                void 0 !== arguments[0] &&
                  (d(arguments[0])
                    ? o.scrollBy.call(
                      t,
                      void 0 !== arguments[0].left
                        ? arguments[0].left
                        : "object" !== _typeof(arguments[0])
                          ? arguments[0]
                          : 0,
                      void 0 !== arguments[0].top
                        ? arguments[0].top
                        : void 0 !== arguments[1]
                          ? arguments[1]
                          : 0
                    )
                    : h.call(
                      t,
                      e.body,
                      ~~arguments[0].left + (t.scrollX || t.pageXOffset),
                      ~~arguments[0].top + (t.scrollY || t.pageYOffset)
                    ));
              }),
              (n.prototype.scroll = n.prototype.scrollTo =
                function () {
                  if (void 0 !== arguments[0])
                    if (!0 !== d(arguments[0])) {
                      var t = arguments[0].left,
                        e = arguments[0].top;
                      h.call(
                        this,
                        this,
                        void 0 === t ? this.scrollLeft : ~~t,
                        void 0 === e ? this.scrollTop : ~~e
                      );
                    } else {
                      if (
                        "number" == typeof arguments[0] &&
                        void 0 === arguments[1]
                      )
                        throw new SyntaxError("Value could not be converted");
                      o.elementScroll.call(
                        this,
                        void 0 !== arguments[0].left
                          ? ~~arguments[0].left
                          : "object" !== _typeof(arguments[0])
                            ? ~~arguments[0]
                            : this.scrollLeft,
                        void 0 !== arguments[0].top
                          ? ~~arguments[0].top
                          : void 0 !== arguments[1]
                            ? ~~arguments[1]
                            : this.scrollTop
                      );
                    }
                }),
              (n.prototype.scrollBy = function () {
                void 0 !== arguments[0] &&
                  (!0 !== d(arguments[0])
                    ? this.scroll({
                      left: ~~arguments[0].left + this.scrollLeft,
                      top: ~~arguments[0].top + this.scrollTop,
                      behavior: arguments[0].behavior,
                    })
                    : o.elementScroll.call(
                      this,
                      void 0 !== arguments[0].left
                        ? ~~arguments[0].left + this.scrollLeft
                        : ~~arguments[0] + this.scrollLeft,
                      void 0 !== arguments[0].top
                        ? ~~arguments[0].top + this.scrollTop
                        : ~~arguments[1] + this.scrollTop
                    ));
              }),
              (n.prototype.scrollIntoView = function () {
                if (!0 !== d(arguments[0])) {
                  var i = (function (t) {
                    for (; t !== e.body && !1 === f(t);)
                      t = t.parentNode || t.host;
                    return t;
                  })(this),
                    n = i.getBoundingClientRect(),
                    a = this.getBoundingClientRect();
                  i !== e.body
                    ? (h.call(
                      this,
                      i,
                      i.scrollLeft + a.left - n.left,
                      i.scrollTop + a.top - n.top
                    ),
                      "fixed" !== t.getComputedStyle(i).position &&
                      t.scrollBy({
                        left: n.left,
                        top: n.top,
                        behavior: "smooth",
                      }))
                    : t.scrollBy({
                      left: a.left,
                      top: a.top,
                      behavior: "smooth",
                    });
                } else
                  o.scrollIntoView.call(
                    this,
                    void 0 === arguments[0] || arguments[0]
                  );
              });
          }
          function l(t, e) {
            (this.scrollLeft = t), (this.scrollTop = e);
          }
          function d(t) {
            if (
              null === t ||
              "object" !== _typeof(t) ||
              void 0 === t.behavior ||
              "auto" === t.behavior ||
              "instant" === t.behavior
            )
              return !0;
            if ("object" === _typeof(t) && "smooth" === t.behavior) return !1;
            throw new TypeError(
              "behavior member of ScrollOptions " +
              t.behavior +
              " is not a valid value for enumeration ScrollBehavior."
            );
          }
          function c(t, e) {
            return "Y" === e
              ? t.clientHeight + r < t.scrollHeight
              : "X" === e
                ? t.clientWidth + r < t.scrollWidth
                : void 0;
          }
          function u(e, i) {
            var n = t.getComputedStyle(e, null)["overflow" + i];
            return "auto" === n || "scroll" === n;
          }
          function f(t) {
            var e = c(t, "Y") && u(t, "Y"),
              i = c(t, "X") && u(t, "X");
            return e || i;
          }
          function p(e) {
            var i,
              n,
              o,
              r,
              l = (s() - e.startTime) / a;
            (r = l = l > 1 ? 1 : l),
              (i = 0.5 * (1 - Math.cos(Math.PI * r))),
              (n = e.startX + (e.x - e.startX) * i),
              (o = e.startY + (e.y - e.startY) * i),
              e.method.call(e.scrollable, n, o),
              (n === e.x && o === e.y) || t.requestAnimationFrame(p.bind(t, e));
          }
          function h(i, n, a) {
            var r,
              d,
              c,
              u,
              f = s();
            i === e.body
              ? ((r = t),
                (d = t.scrollX || t.pageXOffset),
                (c = t.scrollY || t.pageYOffset),
                (u = o.scroll))
              : ((r = i), (d = i.scrollLeft), (c = i.scrollTop), (u = l)),
              p({
                scrollable: r,
                method: u,
                startTime: f,
                startX: d,
                startY: c,
                x: n,
                y: a,
              });
          }
        },
      };
    })();
  });
function onYouTubeIframeAPIReady() {
  document.dispatchEvent(new CustomEvent("youtube:ready"));
}
!(function (t) {
  "use strict";
  var e = t(window),
    i = t(document),
    n = t("html"),
    a = t("body"),
    o = e.width(),
    s = o < 768,
    r = window.T4Srequest.design_mode,
    l = window.T4Sstrings,
    d = !!(
      "ontouchstart" in window ||
      (window.DocumentTouch && window.document instanceof DocumentTouch) ||
      window.navigator.maxTouchPoints ||
      window.navigator.msMaxTouchPoints
    );
  (T4SThemeSP.isHover = n.hasClass("t4sp-hover")),
    (T4SThemeSP.isTouch = !T4SThemeSP.isHover && d),
    (T4SThemeSP.getToFetchSection = function (t, e = "text", i = null) {
      let n = t ? T4SThemeSP.root_url + t : i;
      return fetch(n, {
        method: "GET",
        headers: {
          "Cache-Control": "no-cache",
        },
      })
        .then((t) =>
          t.redirected ? "NVT_94" : "text" == e ? t.text() : t.json()
        )
        .then((t) => t)
        .catch((t) => {
          window.report_faro({
            file_name: 'assets/theme.js',
            func_name: 'T4SThemeSP.getToFetchSection',
            desc: 'Failed to fetch theme section',
            error: t
          });
          return "NVT_94";
        });
    }),
    (T4SThemeSP.OverflowScroller = (function () {
      function t(t, e) {
        (!t && o > 767) ||
          ((this.element = t),
            (this.options = e),
            (this.lastKnownY = window.scrollY),
            (this.currentTop = 0),
            (this.initialTopOffset =
              e.offsetTop || parseInt(window.getComputedStyle(this.element).top)),
            this._attachListeners(),
            e.updateOffsetTop &&
            ((this.initialTopOffsetCache = this.initialTopOffset),
              this._updateInitialTopOffset()));
      }
      return (
        (t.prototype = Object.assign({}, t.prototype, {
          _updateInitialTopOffset: function () {
            window.addEventListener("T4sHeaderReveal", function () {
              this.initialTopOffset = this.initialTopOffsetCache;
            }),
              window.addEventListener("T4sHeaderHide", function () {
                this.initialTopOffset = 30;
              });
          },
          _attachListeners: function () {
            (this._checkPositionListener = this._checkPosition.bind(this)),
              window.addEventListener("scroll", this._checkPositionListener);
          },
          _checkPosition: function () {
            var t = this;
            fastdomT4s.measure(function () {
              if (t.options.offsetTopProperty) {
                var offsetTop = parseFloat(
                  window
                    .getComputedStyle(document.documentElement)
                    .getPropertyValue(t.options.offsetTopProperty)
                );

                if (!Number.isNaN(offsetTop)) {
                  t.initialTopOffset = offsetTop;
                }
              }

              var e =
                t.element.getBoundingClientRect().top +
                window.scrollY -
                t.element.offsetTop +
                t.initialTopOffset,
                i =
                  t.element.clientHeight -
                  window.innerHeight +
                  (t.options.offsetBottom || 0);
              window.scrollY < t.lastKnownY
                ? (t.currentTop -= window.scrollY - t.lastKnownY)
                : (t.currentTop += t.lastKnownY - window.scrollY),
                (t.currentTop = Math.min(
                  Math.max(t.currentTop, -i),
                  e,
                  t.initialTopOffset
                )),
                (t.lastKnownY = window.scrollY);
            }),
              fastdomT4s.mutate(function () {
                t.element.style.top = "".concat(t.currentTop, "px");
              });
          },
          destroy: function () {
            window.removeEventListener("scroll", this._checkPositionListener);
          },
        })),
        t
      );
    })());

  function getProductId($container) {
    try {
      return JSON.parse($container.attr("data-product-featured") || "{}").id || "";
    } catch (error) {
      return "";
    }
  }
  // 保留兼容入口，供尺码弹窗和尺码推荐等外部脚本使用
  function initSizeInfo(productId, hiddenBodySizeCols = [], sizeStart) {
    return new T4SThemeSP.SizeInfo({
      productId,
      hiddenBodySizeCols,
      sizeStart
    })
  }

  if (!window.product_size_info || typeof window.product_size_info !== 'object') {
    window.product_size_info = {}
  }

  function getProductSizeInfo(productId) {
    const productKey = String(productId || '').trim()
    if (!productKey) return undefined

    if (!window.product_size_info[productKey]) {
      window.product_size_info[productKey] = initSizeInfo(productKey)
    }

    return window.product_size_info[productKey]
  }

  function mountProductSizeInfoOnSizeGuideClick(event) {
    const sizeGuideButton = event.target.closest?.('.t4s-btn__size-chart')
    if (!sizeGuideButton) return

    const productId =
      sizeGuideButton.getAttribute('data-product-id') ||
      sizeGuideButton
        .closest('[data-product-id]')
        ?.getAttribute('data-product-id')
    if (!productId) return

    sizeGuideButton.setAttribute('data-product-id', productId)
    getProductSizeInfo(productId)
  }

  document.addEventListener(
    'click',
    mountProductSizeInfoOnSizeGuideClick,
    true
  )

  // 全局暴露，product_size_info 按商品 ID 缓存对应的 SizeInfo
  window.initSizeInfo = initSizeInfo
  window.getProductSizeInfo = getProductSizeInfo

  const ProductSwatchInfo = (function () {
    function isSpecialStyleOption(optionTitle) {
      const styleNames = window.style_name_list || []
      return styleNames.includes(String(optionTitle || '').toLocaleLowerCase())
    }

    function updateLengthStyleTips(optionElement, $container, $styleTips) {
      if (
        isBramiTypeOption(optionElement) ||
        !isSpecialStyleOption(optionElement.dataset.optionTitle)
      ) {
        return
      }

      const optionValue = String(optionElement.dataset.value || '')
      const lengthStyleTips = window.length_styles_tips || {}
      const modelInfoList = window.model_info_list || []
      const modelInfoIndex = optionElement.dataset.index

      $container
        .find("form[data-type='add-to-cart-form'] #model-info .model_info_tips")
        .html(modelInfoList[modelInfoIndex] || '')
      $styleTips.text(lengthStyleTips[optionValue.toLocaleLowerCase()] || '')
    }

    function isBramiTypeOption(optionElement) {
      return optionElement
        .closest('[data-swatch-option]')
        ?.classList.contains('is--brami_type_option')
    }

    function updateBramiTypeTips(optionElement) {
      if (!isBramiTypeOption(optionElement)) return

      const optionValue = String(optionElement.dataset.value || '')
      const bramiTypeTips = window.brami_type_info?.tips || {}

      $(optionElement)
        .closest('[data-swatch-option]')
        .find('.t4s-swatch__current')
        .text(bramiTypeTips[optionValue] || '')
    }

    function updateBramiProductTitle(
      optionElement,
      $container,
    ) {
      if (!isBramiTypeOption(optionElement)) return

      const optionValue = String(optionElement.dataset.value || '').trim()
      const newOptionValue = String(
        window.brami_type_info?.new_option_value || ''
      ).trim()
      const shouldUseNewTitle = optionValue === newOptionValue

      $container.find('[data-product-title-text]').each(function () {
        const originalTitle =
          this.dataset.originalProductTitle || this.textContent.trim()

        this.dataset.originalProductTitle = originalTitle
        this.textContent = shouldUseNewTitle
          ? originalTitle.trim() + ' 3.0'
          : originalTitle.trim() + ' 2.0'
      })
    }

    function getSizeTipHtml(label, value) {
      return `<div>${label}: <span>${value}</span></div>`
    }

    function normalizeMeasurementName(name) {
      return String(name || '')
        .replace(/[\s_-]+/g, '')
        .toLocaleUpperCase()
    }

    function normalizeProductSizeTableName(name) {
      return String(name || '')
        .replace(/&nbsp;?|\u00a0|\s+/gi, '')
        .toLocaleLowerCase()
    }

    function isPantsProduct(productInfo) {
      const productCategories = String(productInfo?.type || '')
        .split('>')
        .map(category => category.trim().toLocaleLowerCase())
        .filter(Boolean)

      return productCategories[productCategories.length - 1] === 'pants'
    }

    function getPantsSizeTable(productElement, productSizeJson) {
      const heightOption = productElement.querySelector(
        'div[data-swatch-option].is-t4s-name__height'
      )

      if (!heightOption) {
        return productSizeJson?.default
      }

      const selectedHeight = heightOption.querySelector(
        'div[data-swatch-item].is--selected'
      )
      if (!selectedHeight) return undefined

      const heightTableName = normalizeProductSizeTableName(
        selectedHeight.getAttribute('data-value')
      )
      if (!heightTableName) return undefined

      return productSizeJson?.[heightTableName]
    }

    function getInseamFromSizeTable(sizeTable, selectedSize) {
      const sizeMeasurements = sizeTable?.[
        String(selectedSize || '').trim().toLocaleLowerCase()
      ]
      if (!sizeMeasurements) return undefined

      const inseamKey = Object.keys(sizeMeasurements).find(key => {
        return normalizeMeasurementName(key) === 'INSEAM'
      })

      return inseamKey ? sizeMeasurements[inseamKey] : undefined
    }

    function getProductSizeJsonByUnit(sizeInfo, unit) {
      if (typeof sizeInfo?.getProductSizeJson !== 'function') return {}

      return sizeInfo.getProductSizeJson(unit)
    }

    function formatCmMeasurement(value) {
      const measurement = String(value ?? '').trim()
      return /^\d+(?:\.\d+)?(?:-\d+(?:\.\d+)?)?$/.test(measurement)
        ? `${measurement} cm`
        : measurement
    }

    function getPantsInseam(sizeOption, selectedSize) {
      const productElement = sizeOption.closest(
        'div[data-product-featured][data-product-id]'
      )
      const productId = productElement?.getAttribute('data-product-id')
      if (!productId || typeof window.productInfo !== 'function') {
        return undefined
      }

      const productInfo = window.productInfo(productId)
      if (!isPantsProduct(productInfo)) return undefined

      const pantsSizeTable = getPantsSizeTable(
        productElement,
        getProductSizeJsonByUnit(productInfo?.size_info, 'cm')
      )

      return getInseamFromSizeTable(pantsSizeTable, selectedSize)
    }

    function getSizeTipsInseam(
      $tipsTarget,
      sizeOption,
      sizeInfo,
      selectedSize
    ) {
      if ($tipsTarget.is('#size-bottom-tips')) {
        return getInseamFromSizeTable(
          getProductSizeJsonByUnit(sizeInfo, 'cm').bottom,
          selectedSize
        )
      }

      if ($tipsTarget.is('#size-tips')) {
        return getPantsInseam(sizeOption, selectedSize)
      }

      return undefined
    }

    function getBodySizeTipsHtml(
      sizeInfo,
      currentSizeTips,
      productMetafields,
      excludedMeasurements = []
    ) {
      const bustLabel = sizeInfo.header_name.BUST || 'Bust'
      const waistLabel = sizeInfo.header_name.WAIST || 'Waist'
      const hipLabel = sizeInfo.header_name.HIP || 'Hip'
      const underBustKey = Object.keys(currentSizeTips).find(key => {
        return normalizeMeasurementName(key) === 'UNDERBUST'
      })
      const isMatchingSet = String(
        productMetafields.product_category || ''
      ).includes('Matching Set')
      const excludedMeasurementNames = new Set(
        excludedMeasurements.map(normalizeMeasurementName)
      )
      let measurements

      if (!underBustKey || isMatchingSet) {
        measurements = [
          ['BUST', bustLabel, currentSizeTips.BUST],
          ['WAIST', waistLabel, currentSizeTips.WAIST],
          ['HIP', hipLabel, currentSizeTips.HIP]
        ]
      } else {
        const underBustLabel =
          sizeInfo.header_name[underBustKey] ||
          sizeInfo.header_name.UNDERBUST ||
          'Under Bust'

        measurements = [
          ['BUST', bustLabel, currentSizeTips.BUST],
          [underBustKey, underBustLabel, currentSizeTips[underBustKey]],
          ['WAIST', waistLabel, currentSizeTips.WAIST]
        ]
      }

      return measurements
        .filter(([name]) => {
          return !excludedMeasurementNames.has(normalizeMeasurementName(name))
        })
        .map(([_name, label, value]) => getSizeTipHtml(label, formatCmMeasurement(value)))
        .join('')
    }

    function updateBodySizeTips(sizeOption, sizeInfo, productMetafields) {
      const sizeOptionNames = window.size_name_list || []
      if (!sizeOptionNames.includes(sizeOption.dataset.option)) return

      const selectedSize = String(sizeOption.dataset.value || '')
      const sizeValue = selectedSize.toLocaleUpperCase()
      const currentSizeTips =
        sizeInfo.convertBodySizeJsonUnit('cm', false)[sizeValue]
      if (!currentSizeTips) return

      const $currentSwatchOption = $(sizeOption).closest(
        'div[data-swatch-option]'
      )
      const $tipsTarget = $currentSwatchOption.find(
        '#' + sizeOption.dataset.option + '-tips'
      )
      const $currentValue = $currentSwatchOption.find(
        'span[data-current-value]'
      )
      const numericSize =
        sizeInfo.country_size_json?.[sizeValue]?.[sizeInfo.country]
      const inseam = getSizeTipsInseam(
        $tipsTarget,
        sizeOption,
        sizeInfo,
        selectedSize
      )
      const hasInseam =
        inseam !== undefined && inseam !== null && inseam !== ''
      const bodySizeTipsHtml = getBodySizeTipsHtml(
        sizeInfo,
        currentSizeTips,
        productMetafields,
        hasInseam ? ['BUST'] : []
      )
      const inseamTipsHtml = hasInseam
        ? getSizeTipHtml(
          sizeInfo.header_name.INSEAM || 'Inseam',
          formatCmMeasurement(inseam)
        )
        : ''

      $currentValue.text(
        numericSize === undefined
          ? selectedSize
          : `${selectedSize}(${numericSize})`
      )
      $tipsTarget
        .html(bodySizeTipsHtml + inseamTipsHtml)
        .show()
    }

    function getSelectedOptionText(optionElement, productId) {
      const optionValue = String(optionElement.dataset.value || '')
      const optionTitle = String(optionElement.dataset.optionTitle || '')
      const isColorOption = (window.color_ck || []).includes(
        optionTitle.toLocaleLowerCase()
      )
      const isSizeOption = window.size_name_list.includes(
        optionTitle.toLocaleLowerCase()
      )
      if (!isColorOption && !isSizeOption) {
        return ''
      }
      const defaultTitle = optionTitle ? `${optionTitle}:` : ''
      const productColorGroups = window.color_group_map?.[productId] || {}

      if (isColorOption && productColorGroups[optionValue]) {
        return `${productColorGroups[optionValue]}:${optionValue}`
      }

      return `${defaultTitle}${optionValue}`
    }

    // final-sale-* 标签的尺码提示优先显示在模特信息位置
    function updateFinalSaleSizeTips(
      $container,
      sizeInfo,
      productMetafields
    ) {
      const tagsElement = $container.find('.pr_tags_json').get(0)
      if (!tagsElement) return

      let productTags
      try {
        productTags = JSON.parse(tagsElement.textContent || '[]')
      } catch (error) {
        window.report_faro({
          file_name: 'assets/theme.js',
          func_name: 'updateFinalSaleSizeTips',
          desc: 'Invalid product tags data',
          error: error
        })
        return
      }

      if (!Array.isArray(productTags)) return

      const finalSaleSizeTag = productTags.find(tag => {
        const normalizedTag = String(tag || '').trim().toLocaleLowerCase()
        return normalizedTag.startsWith('final-sale-') &&
          normalizedTag.length > 'final-sale-'.length
      })
      if (!finalSaleSizeTag) return

      const sizeValue = String(finalSaleSizeTag)
        .trim()
        .split('-')
        .pop()
        .toLocaleUpperCase()
      const currentSizeTips =
        sizeInfo.convertBodySizeJsonUnit('cm', false)[sizeValue]
      if (!currentSizeTips) return

      const bodySizeTipsHtml = getBodySizeTipsHtml(
        sizeInfo,
        currentSizeTips,
        productMetafields
      )

      $container
        .find("form[data-type='add-to-cart-form'] #model-info .model_info_tips")
        .html(bodySizeTipsHtml)
    }

    function update($container, productId) {
      if (!$container || !$container.length) return

      const sizeInfo = initSizeInfo(productId)
      const productMetafields = sizeInfo.metafield_data || {}
      const $styleTips = $container
        .find('div[data-swatch-option][data-style-option]')
        .find('.t4s-swatch__current')
      const $bramiTypeTips = $container
        .find('div[data-swatch-option].is--brami_type_option')
        .find('.t4s-swatch__current')
      const $selectedOptions = $container.find(
        'div[data-swatch-item].is--selected'
      )
      const selectedOptionTexts = []

      $styleTips.hide()
      $bramiTypeTips.hide()

      $selectedOptions.each(function (_index, optionElement) {
        selectedOptionTexts.push(
          getSelectedOptionText(optionElement, productId)
        )
        updateLengthStyleTips(optionElement, $container, $styleTips)
        updateBramiTypeTips(optionElement)
        updateBramiProductTitle(
          optionElement,
          $container
        )

        updateBodySizeTips(optionElement, sizeInfo, productMetafields)
      })

      updateFinalSaleSizeTips($container, sizeInfo, productMetafields)

      $container
        .find('#add_cart_wrapper #selected-options')
        .text(selectedOptionTexts.filter(text => text).join(', '))
      $styleTips.show()
      $bramiTypeTips.show()
    }

    return { update }
  })()

  function updateSelectedSwatchText(productId) {
    ProductSwatchInfo.update(this.$container, productId)
  }

  var Variants = (function () {
    var SWATCH_ITEM_SELECTOR = "[data-swatch-item]",
      CLASS_UNAVAILABLE = "is--unavailable",
      CLASS_SOLDOUT = "is--soldout",
      CLASS_SOLDOUT_UNAVAILABLE = `${CLASS_SOLDOUT} ` + CLASS_UNAVAILABLE,
      productStrings = window.T4SProductStrings,
      textUnavailable = productStrings.unavailable,
      textAddToCart = productStrings.addToCart,
      textSoldOut = productStrings.soldOut,
      textPreOrder = productStrings.preOrder,
      textReplaceAddToCart = productStrings.replace_qs_atc,
      textReplacePreOrder = productStrings.replace_qs_pre,
      badgeSavePercentText = productStrings.badgeSavePercent2,
      badgeSaveFixedText = productStrings.badgeSaveFixed2,
      ARIA_DISABLED = "aria-disabled";

    function ProductVariants(config) {
      this.$container = config.$container;
      this.variants = config.variants;
      this.productOptions = config.productOptions;
      this.productOptionSize = config.PrOptionsSize;
      this.formSelectorId = config.formSelectorId;
      this.originalSelectorId = config.originalSelectorId;
      this.enableHistoryState = config.enableHistoryState;
      this.removeSoldout = config.removeSoldout;
      this.$options1 = config.$options1;
      this.$options2 = config.$options2;
      this.$options3 = config.$options3;
      this.isNoPick = config.isNoPick;
      this.isNoPickOriginal = config.isNoPick;
      this.hasSoldoutUnavailable = config.hasSoldoutUnavailable;
      this.canMediaGroup = config.canMediaGroup;
      this.badgesConfigs = config.badgesConfigs;
      this.$variantImg = config.$variantImg;
      this.disableVariantImage = config.disableVariantImage;
      this.swatchWidth = config.swatchWidth;
      this.$incomingMess = t(this.formSelectorId).find("[data-incoming__mess]");
      this.isSticky = config.isSticky;
      this.isMainProduct = config.isMainProduct;
      this.$quantity = t(this.formSelectorId).find("[data-quantity-value]");
      this.clickedOptions = [];
      this.showFirstMedia = config.showFirstMedia;
      this.oldVariant = {};
      this.currentVariant = {};
      this.mediaID = 0;
      this.eventClickedSwatch = !1;
      this.variantState = {
        available: !0,
        soldOut: !1,
        onSale: !1,
        preOrder: !1,
        showUnitPrice: !1,
      };
      this.$productPrice = this.$container.find(
        "[data-product-price]:not([class*=no-save-banner])"
      );
      this.saletype = this.$productPrice.data("saletype");

      var $unitPriceWrapper = this.$container.find("[data-product-unit-price]");
      this.$unit_price = $unitPriceWrapper.find("[data-unit-price]");
      this.$unit_base = $unitPriceWrapper.find("[data-unit-base]");

      var $badgeWrapper = this.$container.find("[data-product-single-badge]"),
        badgeTexts = this.badgesConfigs.texts,
        saleStyle = this.badgesConfigs.saleStyle;

      this.badgeSelector = {
        $onSale: $badgeWrapper.find("[data-badge-sale]"),
        $preOrder: $badgeWrapper.find("[data-badge-preorder]"),
        $soldOut: $badgeWrapper.find("[data-badge-soldout]"),
      };
      this.saleLabel = "2" == saleStyle ? badgeTexts.SavePercent : badgeTexts.sale;

      this.useComingMess = !1;
      if (this.$incomingMess[0]) {
        this.useComingMess = !0;
        this.$incomingAvailable = this.$incomingMess.find(
          "[data-incoming-available]"
        );
        this.$incomingSoldout = this.$incomingMess.find(
          "[data-incoming-soldout]"
        );
        this.$incomingAvailableDate = this.$incomingAvailable.find(
          "[data-incoming-date]"
        );
        this.$incomingSoldoutDate = this.$incomingSoldout.find(
          "[data-incoming-date]"
        );
      }

      this.$addToCartButton = this.formSelectorId.find(
        '[type="submit"][name="add"]'
      );
      this.$quantityWrapper = this.formSelectorId.find("[data-quantity-wrapper]");
      this.$paymentButton = this.formSelectorId.find(".shopify-payment-button");
      this.$addToCartButtonText = this.$addToCartButton.find(".t4s-btn-atc_text");

      if (this.isSticky) {
        var $stickyAddToCart = t("[data-sticky-addtocart]"),
          self = this;
        this.$stickyimg = $stickyAddToCart.find("[data-sticky-img] img");
        this.$stickyVtitle = $stickyAddToCart.find("[data-sticky-v-title]");
        this.$stickyPrice = $stickyAddToCart.find("[data-sticky-price]");
        this.$stickyATC = $stickyAddToCart.find("[data-action-atc]");
        this.$stickyATCText = this.$stickyATC.find(".t4s-btn-atc_text");
        this.stickyImgOrginal = this.$stickyimg.data("orginal");
        this.$stickyQuantityWrapper = $stickyAddToCart.find("[data-quantity-wrapper]");
        this.$stickyQuantity = this.$stickyQuantityWrapper.find(
          "[data-quantity-value]"
        );
        this.$stickyQuantity.change(function () {
          self.$quantity.val(this.value);
        });
        this.$quantity.change(function () {
          self.$stickyQuantity.val(this.value);
        });
      }

      if (T4SThemeSP.isEditCartReplace) {
        this.txt_addToCart = textReplaceAddToCart;
        this.txt_preOrder = textReplacePreOrder;
      }

      this.originalSelectorId.on("change", this._onSelectChange.bind(this));

      if (this.isNoPick) {
        this.currentVariant = this._getVariantFromVariantid();
        this.updateMediaFilterNoPick = this._updateMediaFilterNoPick;
      } else {
        this.originalSelectorId[0].dispatchEvent(
          new Event("change", {
            bubbles: !0,
            cancelable: !0,
          })
        );
      }
    }

    function getClassToRemove(isAvailable) {
      return isAvailable ? CLASS_SOLDOUT_UNAVAILABLE : CLASS_UNAVAILABLE;
    }

    return (
      (ProductVariants.prototype = Object.assign({}, ProductVariants.prototype, {
        _onSelectChange: function () {

          if (!this.eventClickedSwatch) this.oldVariant = this.currentVariant;
          var currentVariant = this.eventClickedSwatch
            ? this.currentVariant
            : this._getVariantFromVariantid();



          if (!currentVariant) {
            this._setVariantState(currentVariant);
            this._updatePrice(currentVariant, this.oldVariant, this.$container);
            this._updateAddToCartButton(
              currentVariant,
              this.oldVariant,
              this.$addToCartButton,
              this.$quantityWrapper,
              this.$paymentButton,
              this.$addToCartButtonText
            );
            this._updateAvailability(currentVariant, this.oldVariant, this.$container);
            this._updateSKU(currentVariant, this.oldVariant, this.$container);
            this._updateBarcode(currentVariant, this.oldVariant, this.$container);
            this._updateDelivery(currentVariant, this.oldVariant, this.$container);
            this._updateInventoryQuantity(currentVariant, this.oldVariant, this.$container);
            this._updatePickupAvailabilityContent(currentVariant, this.$container);
            this._updateNotifyBackinStock(currentVariant, this.$container);
            this._updateBadges();
            this._updateIncomingMess(currentVariant);
            this._updateNewShippingTips(currentVariant, this.$container);
            this.eventClickedSwatch = !1;
            return;
          }

          if (
            !this.eventClickedSwatch &&
            this.productOptionSize == 2 &&
            this.formSelectorId.find("[data-swatch-option] .is--selected").length <= 1 &&
            this.$options1.hasClass("is-t4s-style__color")
          ) {
            this._setVariantState(currentVariant);
            this._updateSwatchSelector(
              currentVariant,
              this.oldVariant,
              this.formSelectorId,
              this.hasSoldoutUnavailable,
              true
            );
            this._updatePrice(currentVariant, this.oldVariant, this.$container);
            this._updateBadges();
            this._updateMedia(currentVariant, this.oldVariant, this.$container);
            updateSelectedSwatchText.bind(this)(getProductId(this.$container));
            return;
          }

          this._setVariantState(currentVariant);
          this._updateSwatchSelector(
            currentVariant,
            this.oldVariant,
            this.formSelectorId,
            this.hasSoldoutUnavailable
          );
          this._updatePrice(currentVariant, this.oldVariant, this.$container);
          this._updateAddToCartButton(
            currentVariant,
            this.oldVariant,
            this.$addToCartButton,
            this.$quantityWrapper,
            this.$paymentButton,
            this.$addToCartButtonText
          );
          this._updateAvailability(currentVariant, this.oldVariant, this.$container);
          this._updateSKU(currentVariant, this.oldVariant, this.$container);
          this._updateBarcode(currentVariant, this.oldVariant, this.$container);
          this._updateMetafield(currentVariant, this.oldVariant, this.$container);
          this._updateDelivery(currentVariant, this.oldVariant, this.$container);
          this._updateInventoryQuantity(currentVariant, this.oldVariant, this.$container);
          this._updatePickupAvailabilityContent(currentVariant, this.$container);
          this._updateNotifyBackinStock(currentVariant, this.$container);
          this._updateBadges();
          this._updateIncomingMess(currentVariant);
          this._updateNewShippingTips(currentVariant, this.$container);

          this.currentVariant = currentVariant;
          if (this.canMediaGroup) {
            this._updateMediaFilter(currentVariant, this.oldVariant, this.$container);
          }
          this._updateMedia(currentVariant, this.oldVariant, this.$container);
          this.eventClickedSwatch = !1;
          this._updateQuantity(currentVariant);
          if (!this.disableVariantImage) this._updateVariantImageSwatch(currentVariant);
          if (this.isSticky) this._updateStickyATC(currentVariant);
          if (this.enableHistoryState) this._updateHistoryState(currentVariant);
          this.$container.trigger({
            type: "variant:changed",
            currentVariant: currentVariant,
            oldVariant: this.oldVariant,
          });
          updateSelectedSwatchText.bind(this)(getProductId(this.$container))
        },

        _getVariantFromOptions: function () {
          var clickedOptions = this.clickedOptions;
          var optionCount = this.productOptionSize;
          if (clickedOptions.length !== optionCount) {
            return 'nathan'
          }
          return (
            this.variants.find(function (variant) {
              return clickedOptions.every(function (option) {
                return variant[option.index] === option.value;
              });
            }) || "nathan"
          );
        },

        _getVariantFromSize: function () {
          var matchedVariants,
            variants = this.variants,
            optionCount = this.productOptionSize,
            removeSoldout = this.removeSoldout,
            option1 = '',
            option2 = '',
            clickedCurrentValue = this.clickedCurrentValue,
            clickedCurrentIndex = this.clickedCurrentIndex;

          this.clickedOptions.forEach((item) => {
            if (item.index == 'option1') {
              option1 = item.value
            }
            if (item.index == 'option2') {
              option2 = item
            }
          })
          if (optionCount == 1) {
            matchedVariants = t.grep(variants, function (variant) {
              return 0 == variant.available;
            });
          } else if (optionCount == 3 && removeSoldout) {
            option2 = option2.value;
            matchedVariants = t.grep(variants, function (variant) {
              return variant.option1 == option1 && variant.option2 == option2 && variant.available;
            });
            matchedVariants[0] ||
              (matchedVariants = t.grep(variants, function (variant) {
                return variant.available && variant[clickedCurrentIndex] == clickedCurrentValue;
              }));
          } else if (removeSoldout) {
            matchedVariants = t.grep(variants, function (variant) {
              return variant.option1 == option1 && variant.available;
            });
            matchedVariants[0] ||
              (matchedVariants = t.grep(variants, function (variant) {
                return variant.available && variant[clickedCurrentIndex] == clickedCurrentValue;
              }));
          } else if (optionCount == 3) {
            option2 = option2.value;
            matchedVariants = t.grep(variants, function (variant) {
              return variant.option1 == option1 && variant.option2 == option2;
            });
            matchedVariants[0] ||
              (matchedVariants = t.grep(variants, function (variant) {
                return variant[clickedCurrentIndex] == clickedCurrentValue;
              }));
          } else {
            matchedVariants = t.grep(variants, function (variant) {
              return variant.option1 == option1;
            });
            matchedVariants[0] ||
              (matchedVariants = t.grep(variants, function (variant) {
                return variant[clickedCurrentIndex] == clickedCurrentValue;
              }));
          }

          return matchedVariants[0];
        },

        _getVariantById: function (variantId) {
          if (variantId == null || variantId === "") return null;

          variantId = String(variantId);

          return (
            this.variants.find(function (variant) {
              return String(variant.id) === variantId;
            }) || null
          );
        },

        // 初始化获取variant ID
        _getVariantFromVariantid: function () {
          var optionCount = this.productOptionSize,
            selectedVariantId = this.originalSelectorId.val();
          var selectedVariant = this._getVariantById(selectedVariantId);

          if (optionCount > 2) {

            const _this = this
            // 初始化所有已选中的 swatch
            this.clickedOptions = [];
            this.formSelectorId
              .find("[data-swatch-option] .is--selected")
              .each(function (_, item) {
                var $item = t(item);
                var optionId = Number($item.closest("[data-swatch-option]").data("id"));

                _this.clickedOptions.push({
                  value: String($item.data("value")),
                  index: "option" + (optionId + 1),
                });
              });
            if (this.clickedOptions.length <= 1) {
              return null
            }
            // 当有三个属性时，且两个属性时默认选中的，这个时候要默认给选中
            return this._getVariantFromSize()
          }
          return selectedVariant;
        },

        _getVariantFromOptionIndex: function (optionIndex, currentVariant) {
          var matchedVariants,
            variants = this.variants,
            option1 = currentVariant.option1,
            option2 = currentVariant.option2,
            option3 = currentVariant.option3;

          switch (optionIndex) {
            case 1:
              matchedVariants = t.grep(variants, function (variant) {
                return variant.option1 == option1;
              });
              break;
            case 2:
              matchedVariants = t.grep(variants, function (variant) {
                return variant.option2 == option2;
              });
              break;
            case 3:
              matchedVariants = t.grep(variants, function (variant) {
                return variant.option3 == option3;
              });
              break;
            case 1.2:
              matchedVariants = t.grep(variants, function (variant) {
                return variant.option1 == option1 && variant.option2 == option2;
              });
              break;
            default:
              matchedVariants = t.grep(variants, function (variant) {
                return 0 == variant.available;
              });
          }
          return matchedVariants || "nathan";
        },

        _updateMediaFilterNoPick: function () {
          if (this.clickedCurrentValue && this.clickedCurrentIndex) {
            var optionIndex = this.clickedCurrentIndex.replace("option", ""),
              optionName = this.productOptions[parseInt(optionIndex) - 1].name || "not4s",
              optionValue = this.clickedCurrentValue || "not4s",
              $mainMedia = this.$container.find("[data-main-media]"),
              groupSelector =
                '[data-grname="' +
                optionName.toLowerCase() +
                '"][data-grpvl="' +
                optionValue.toLowerCase() +
                '"]',
              $matchedSlides = $mainMedia.find(groupSelector),
              $carouselNav = this.$container.find(".t4s-carousel__nav"),
              $matchedNavSlides = $carouselNav.find(groupSelector);

            if ($matchedSlides.length != 0) {
              $mainMedia.find("[data-main-slide]").addClass("is--media-hide");
              $matchedSlides.removeClass("is--media-hide");
              $carouselNav.find(".t4s-carousel__nav-item").addClass("is--media-hide");
              $matchedNavSlides.removeClass("is--media-hide");
              if ($mainMedia.hasClass("flickityt4s-enabled")) {
                $mainMedia.trigger("update.flickityt4s");
                if (!$matchedNavSlides.hasClass("is-nav-selected")) {
                  $matchedNavSlides.first().addClass("is-nav-selected");
                }
              } else if ($mainMedia.hasClass("isotopet4s-enabled")) {
                v($mainMedia);
                $mainMedia.isotopet4s();
              }
            }
          }
        },

        _updateMediaFilter: function (currentVariant, oldVariant, $container) {
          if (this.clickedCurrentValue && this.clickedCurrentIndex) {
            var optionIndex = this.clickedCurrentIndex.replace("option", ""),
              optionName = this.productOptions[parseInt(optionIndex) - 1].name || "not4s",
              optionValue = this.clickedCurrentValue || "not4s",
              $mainMedia = $container.find("[data-main-media]"),
              groupSelector =
                '[data-grname="' +
                optionName.toLowerCase() +
                '"][data-grpvl="' +
                optionValue.toLowerCase() +
                '"]',
              $matchedSlides = $mainMedia.find(groupSelector),
              $carouselNav = $container.find(".t4s-carousel__nav"),
              $matchedNavSlides = $carouselNav.find(groupSelector);

            if ($matchedSlides.length != 0) {
              $mainMedia.find("[data-main-slide]").addClass("is--media-hide");
              $matchedSlides.removeClass("is--media-hide");
              $carouselNav.find(".t4s-carousel__nav-item").addClass("is--media-hide");
              $matchedNavSlides.removeClass("is--media-hide");
              if ($mainMedia.hasClass("flickityt4s-enabled")) {
                $mainMedia.trigger("update.flickityt4s");
                if (currentVariant.featured_media) {
                  var slideIndex = $mainMedia
                    .find('[data-media-id="' + currentVariant.featured_media.id + '"]')
                    .index();
                }
                $mainMedia.flickityt4s("selectCell", slideIndex, !1, !1);
              } else if ($mainMedia.hasClass("isotopet4s-enabled")) {
                v($mainMedia);
                $mainMedia.isotopet4s();
              }
            }
          }
        },
        // 没有选中SKU情况下更新Media
        _updateMediaByColor: function (color) {
          var $mainMedia = this.$container.find("[data-main-media]");
          var firstColorOption = this.variants.find((variant) => {
            return variant.options.includes(color)
          })
          if (!firstColorOption) {
            return
          }
          var targetMediaID = firstColorOption.featured_media.id
          if ($mainMedia.hasClass("flickityt4s-enabled")) {
            var mediaIndex = $mainMedia
              .find('[data-media-id="' + targetMediaID + '"]')
              .index();
            $mainMedia.flickityt4s("select", mediaIndex, !1, !0);
          } else {
            var $targetMedia = $mainMedia.find('[data-media-id="' + targetMediaID + '"]'),
              targetMediaElement = $targetMedia[0];
            if (!targetMediaElement || T4SThemeSP.isVisible($targetMedia)) return;
            const header = document.querySelector(".t4s-section-header");
            header.dispatchEvent(new Event("preventHeaderReveal"));
            window.setTimeout(function () {
              $mainMedia[0].scrollLeft = 0;
              targetMediaElement.scrollIntoView({
                behavior: "smooth",
                block: "center",
              });
            });
          }
        },
        // 更新最后一个swatch
        _updateLastSwatch: function () {
          if (this.clickedOptions.length < this.productOptionSize - 1) {
            return null
          }

          const restOption = this.productOptions.find(productOpt => {
            return !this.clickedOptions.map(clickedOpt => clickedOpt.index).includes(`option${productOpt.position}`)
          })
          if (!restOption) {
            return this._getVariantFromSize()
          }
          // 可售的variants
          const restAvailableVariants = this.variants.filter(variant => {
            const isSeletedOptions = this.clickedOptions.every(clickedOpt => {
              const clickedOptionIndex = clickedOpt.index
              const clickedOptionValue = clickedOpt.value
              return clickedOptionValue == variant[clickedOptionIndex]
            })
            return isSeletedOptions
          })

          if (!restAvailableVariants.length) {
            return this._getVariantFromSize()
          }

          // // 卖完的variants
          // const restSoldoutVariants = restAvailableVariants.filter(variant => {
          //   return !variant.available
          // })

          const $lastOptionEl = this.formSelectorId.find(`[data-swatch-option][data-id='${restOption.position - 1}']`)
          const $lastOptionItems = $lastOptionEl.find('[data-swatch-item]')
          $lastOptionItems.each((_, optionItem) => {
            const cur_variant = restAvailableVariants.find(item => item[`option${restOption.position}`] == optionItem.dataset.value)
            if (cur_variant) {
              optionItem.classList.remove(CLASS_SOLDOUT, CLASS_UNAVAILABLE)
              if (!cur_variant.available) {
                optionItem.classList.add(CLASS_SOLDOUT)
              }
            } else {
              optionItem.classList.add(CLASS_UNAVAILABLE)
            }
            // soldout的item
            // if (restAvailableVariants.map(item => item[`option${restOption.position}`]).includes(optionItem.dataset.value)) {
            //   $availableItem.push(optionItem)
            // }
          })
          return null
        },

        _updateSwatchSelector: function (
          currentVariant,
          oldVariant,
          swatchContainer,
          enableAvailabilityUpdate,
          hasEmptyValue
        ) {
          hasEmptyValue = hasEmptyValue || !1;

          var variant,
            index,
            $option1Container = this.$options1,
            $option2Container = this.$options2,
            $option3Container = this.$options3,
            optionCount = this.productOptionSize,
            variantsList = [],
            variantsCount = 0,
            currentOption1 = currentVariant.option1,
            currentOption2 = currentVariant.option2,
            currentOption3 = currentVariant.option3,
            option1Values = [],
            option2Values = [],
            option3Values = [];

          swatchContainer.find(".is--selected").removeClass("is--selected");
          swatchContainer.find("[data-current-value]").html("");

          option1Values = this.productOptions[0].values;
          $option1Container.find("[data-current-value]").html(currentOption1);
          $option1Container
            .find(SWATCH_ITEM_SELECTOR)
            .eq(option1Values.indexOf(currentOption1))
            .addClass("is--selected");

          if ($option2Container[0]) {
            option2Values = this.productOptions[1].values;
            if (!hasEmptyValue) {
              $option2Container.find("[data-current-value]").html(currentOption2);
              $option2Container
                .find(SWATCH_ITEM_SELECTOR)
                .eq(option2Values.indexOf(currentOption2))
                .addClass("is--selected");
            }
          }

          if ($option3Container[0]) {
            option3Values = this.productOptions[2].values;
            if (!hasEmptyValue) {
              $option3Container.find("[data-current-value]").html(currentOption3);
              $option3Container
                .find(SWATCH_ITEM_SELECTOR)
                .eq(option3Values.indexOf(currentOption3))
                .addClass("is--selected");
            }
          }

          var option2Length = option2Values.length,
            option3Length = option3Values.length;

          if (enableAvailabilityUpdate) {
            switch (optionCount) {
              case 3:
                if (option3Length == 1 && option2Length == 1) {
                  variantsList = this._getVariantFromOptionIndex(0, currentVariant);
                  variantsCount = variantsList.length;
                  for (index = 0; index < variantsCount; index++) {
                    $option2Container
                      .find(SWATCH_ITEM_SELECTOR)
                      .eq(option1Values.indexOf(currentOption1))
                      .addClass("is--soldout");
                  }
                } else if (option3Length == 1) {
                  variantsList = this._getVariantFromOptionIndex(1, currentVariant);
                  variantsCount = variantsList.length;
                  $option1Container.find(SWATCH_ITEM_SELECTOR).addClass(CLASS_SOLDOUT_UNAVAILABLE);
                  $option2Container.find(SWATCH_ITEM_SELECTOR).addClass(CLASS_SOLDOUT_UNAVAILABLE);
                  for (index = 0; index < variantsCount; index++) {
                    variant = variantsList[index];
                    if (variant.option3 == currentOption3) {
                      if (variant.available) {
                        $option2Container
                          .find(SWATCH_ITEM_SELECTOR)
                          .eq(option2Values.indexOf(currentOption2))
                          .removeClass(CLASS_SOLDOUT_UNAVAILABLE);
                        if (variant.option2 == currentOption2) {
                          $option1Container
                            .find(SWATCH_ITEM_SELECTOR)
                            .eq(option1Values.indexOf(currentOption1))
                            .removeClass(CLASS_SOLDOUT_UNAVAILABLE);
                        }
                      } else {
                        $option2Container
                          .find(SWATCH_ITEM_SELECTOR)
                          .eq(option2Values.indexOf(currentOption2))
                          .removeClass(CLASS_UNAVAILABLE);
                        if (variant.option2 == currentOption2) {
                          $option1Container
                            .find(SWATCH_ITEM_SELECTOR)
                            .eq(option1Values.indexOf(currentOption1))
                            .removeClass(CLASS_UNAVAILABLE);
                        }
                      }
                    }
                  }
                } else {
                  variantsList = this._getVariantFromOptionIndex(1, currentVariant);
                  variantsCount = variantsList.length;
                  $option2Container.find(SWATCH_ITEM_SELECTOR).addClass(CLASS_SOLDOUT_UNAVAILABLE);
                  $option3Container.find(SWATCH_ITEM_SELECTOR).addClass(CLASS_SOLDOUT_UNAVAILABLE);
                  for (index = 0; index < variantsCount; index++) {
                    variant = variantsList[index];
                    if (variant.option1 == currentOption1) {
                      if (variant.available) {
                        $option2Container
                          .find(SWATCH_ITEM_SELECTOR)
                          .eq(option2Values.indexOf(variant.option2))
                          .removeClass(CLASS_SOLDOUT_UNAVAILABLE);
                        if (variant.option2 == currentOption2) {
                          $option3Container
                            .find(SWATCH_ITEM_SELECTOR)
                            .eq(option3Values.indexOf(variant.option3))
                            .removeClass(CLASS_SOLDOUT_UNAVAILABLE);
                        }
                      } else {
                        $option2Container
                          .find(SWATCH_ITEM_SELECTOR)
                          .eq(option2Values.indexOf(variant.option2))
                          .removeClass(CLASS_UNAVAILABLE);
                        if (variant.option2 == currentOption2) {
                          $option3Container
                            .find(SWATCH_ITEM_SELECTOR)
                            .eq(option3Values.indexOf(variant.option3))
                            .removeClass(CLASS_UNAVAILABLE);
                        }
                      }
                    }
                  }
                }
                break;
              case 2:
                if (option2Length == 1) {
                  $option1Container.find(SWATCH_ITEM_SELECTOR).addClass(CLASS_SOLDOUT_UNAVAILABLE);
                  variantsList = this._getVariantFromOptionIndex(2, currentVariant);
                  variantsCount = variantsList.length;
                  for (index = 0; index < variantsCount; index++) {
                    variant = variantsList[index];
                    if (variant.option2 == currentOption2) {
                      $option1Container
                        .find(SWATCH_ITEM_SELECTOR)
                        .eq(option1Values.indexOf(variant.option1))
                        .removeClass(getClassToRemove(variant.available));
                    }
                  }
                } else {
                  variantsList = this._getVariantFromOptionIndex(1, currentVariant);
                  variantsCount = variantsList.length;
                  $option2Container.find(SWATCH_ITEM_SELECTOR).addClass(CLASS_SOLDOUT_UNAVAILABLE);
                  for (index = 0; index < variantsCount; index++) {
                    variant = variantsList[index];
                    if (variant.option1 == currentOption1) {
                      $option2Container
                        .find(SWATCH_ITEM_SELECTOR)
                        .eq(option2Values.indexOf(variant.option2))
                        .removeClass(getClassToRemove(variant.available));
                    }
                  }
                }
                break;
              default:
                variantsList = this._getVariantFromOptionIndex(0, currentVariant);
                variantsCount = variantsList.length;
                for (index = 0; index < variantsCount; index++) {
                  variant = variantsList[index];
                  $option1Container
                    .find(SWATCH_ITEM_SELECTOR)
                    .eq(option1Values.indexOf(variant.option1))
                    .addClass("is--soldout");
                }
                if (this.removeSoldout && $option1Container.find(".is--selected").is(":hidden")) {
                  $option1Container.find("[data-swatch-item]:visible:first").trigger("click");
                }
            }
          }
        },

        _updateMetafield: function (currentVariant, oldVariant, $container) {
          if (currentVariant && currentVariant.id != oldVariant.id) {
            $container.find("[data-variant-toggle]").hide();
            $container.find('[data-variant-toggle="' + currentVariant.id + '"]').show();
            if (this.isMainProduct) {
              t("[data-variant-tab][data-variant-toggle]").hide();
              t('[data-variant-tab][data-variant-toggle="' + currentVariant.id + '"]').show();
            }
          }
        },

        _updateMedia: function (currentVariant, oldVariant, $container) {
          if (!currentVariant) return;
          if (
            currentVariant.featured_media &&
            currentVariant.featured_media != oldVariant.featured_media
          ) {
            this.mediaID = currentVariant.featured_media.id;
            var $mainMedia = $container.find("[data-main-media]");
            if ($mainMedia.hasClass("flickityt4s-enabled")) {
              var mediaIndex = $mainMedia
                .find('[data-media-id="' + this.mediaID + '"]')
                .index();
              $mainMedia.flickityt4s("select", mediaIndex, !1, !0);
            } else {
              var $targetMedia = $mainMedia.find('[data-media-id="' + this.mediaID + '"]'),
                targetMediaElement = $targetMedia[0];
              if (!targetMediaElement || T4SThemeSP.isVisible($targetMedia)) return;
              this.header ||
                (this.header = document.querySelector(".t4s-section-header"));
              this.header.dispatchEvent(new Event("preventHeaderReveal"));
              window.setTimeout(function () {
                $mainMedia[0].scrollLeft = 0;
                targetMediaElement.scrollIntoView({
                  behavior: "smooth",
                  block: "center",
                });
              });
            }
          } else {
            this.showFirstMedia = !1;
          }
        },

        _updatePrice: function (currentVariant) {
          if (!currentVariant) {
            // this.$productPrice.hide();
            return;
          }

          var price = currentVariant.price,
            compareAtPrice = currentVariant.compare_at_price;
          this.isNoPickOriginal && (this.isNoPickOriginal = !1);
          var formattedPrice = T4SThemeSP.Currency.formatMoney(price);

          if ((this.$productPrice.show(), compareAtPrice > price)) {
            var priceHtml =
              "<ins>" + formattedPrice +
              "</ins><del>" +
              T4SThemeSP.Currency.formatMoney(compareAtPrice) +
              "</del>",
              discountValue = compareAtPrice - price,
              discountPercent = Math.round((100 * discountValue) / compareAtPrice);
            this.isSticky && this.$stickyPrice.html(priceHtml);
            this.badgeSelector.$onSale.html(
              this.saleLabel.replace("[sale]", discountPercent)
            );
            if ("1" == this.saletype) {
              priceHtml +=
                ' <span class="t4s-badge-price">' +
                badgeSavePercentText.replace("[sale]", discountPercent) +
                "</span>";
            } else if ("2" == this.saletype) {
              priceHtml +=
                ' <span class="t4s-badge-price">' +
                badgeSaveFixedText.replace(
                  "[sale]",
                  T4SThemeSP.Currency.formatMoney(discountValue)
                ) +
                "</span>";
            }
            this.$productPrice.html(priceHtml);
          } else {
            this.$productPrice.html(formattedPrice);
            this.isSticky && this.$stickyPrice.html(formattedPrice);
          }

          if (this.variantState.showUnitPrice) {
            this.$unit_price.html(
              T4SThemeSP.Currency.formatMoney(currentVariant.unit_price)
            );
            this.$unit_base.html(T4SThemeSP.Currency.getBaseUnit(currentVariant));
          }
          a.trigger("currency:update");
        },

        _updateQuantity: function (currentVariant) {
          if (this.variantState.preOrder) {
            this.$quantity.attr("max", 9999);
            this.isSticky && this.$stickyQuantity.attr("max", 9999);
          } else if (null != currentVariant.inventory_management) {
            var inventoryQuantity = currentVariant.inventory_quantity;
            this.$quantity.attr("max", inventoryQuantity);
            this.isSticky && this.$stickyQuantity.attr("max", inventoryQuantity);
            if (parseInt(this.$quantity.val()) > inventoryQuantity) {
              this.$quantity.attr("value", 1).val(1);
            }
            if (
              this.isSticky &&
              parseInt(this.$stickyQuantity.val()) > inventoryQuantity
            ) {
              this.$stickyQuantity.attr("value", 1).val(1);
            }
          } else {
            this.$quantity.attr("max", 9999);
            this.isSticky && this.$stickyQuantity.attr("max", 9999);
          }
        },

        _updateAvailability: function (currentVariant, oldVariant, $container) {
          var $availability = $container.find("[data-product-available]");
          if ($availability[0]) {
            var $availableStatus = $availability.find("[data-available-status]"),
              $soldoutStatus = $availability.find("[data-soldout-status]"),
              $instockStatus = $availability.find("[data-instock-status]"),
              $preorderStatus = $availability.find("[data-preorder-status]");
            if (currentVariant) {
              $availability.show();
              if (this.variantState.available) {
                $availableStatus.show();
                $soldoutStatus.hide();
                if (this.variantState.preOrder) {
                  $preorderStatus.show();
                  $instockStatus.hide();
                } else {
                  $instockStatus.show();
                  $preorderStatus.hide();
                }
              } else {
                $soldoutStatus.show();
                $availableStatus.hide();
              }
            } else {
              $availability.hide();
            }
          }
        },

        _updateBarcode: function (currentVariant, oldVariant, $container) {
          var $barcode = $container.find("[data-product-barcode]");
          if ($barcode[0]) {
            var $barcodeNumber = $barcode.find("[data-product__barcode-number]");
            if (currentVariant && "" !== currentVariant.barcode) {
              if (oldVariant && oldVariant.barcode === currentVariant.barcode) return;
              $barcodeNumber.text(currentVariant.barcode);
              $barcode.show(0);
            } else {
              $barcode.hide(0);
            }
          }
        },

        _updateSKU: function (currentVariant, oldVariant, $container) {
          var $sku = $container.find("[data-product-sku]");
          if ($sku[0]) {
            var $skuNumber = $sku.find("[data-product__sku-number]");
            if (currentVariant && "" !== currentVariant.sku) {
              $skuNumber.text(currentVariant.sku);
              $sku.show(0);
            } else {
              $sku.hide(0);
            }
          }
        },

        _updateAddToCartButton: function (
          currentVariant,
          oldVariant,
          $addToCartButton,
          $quantityWrapper,
          $paymentButton,
          $addToCartButtonText
        ) {
          if ($addToCartButton[0] || $paymentButton[0]) {
            if (
              T4SThemeSP.isEditCartReplace &&
              !$addToCartButton.is("[data-replace-item]")
            ) {
              $addToCartButton.attr("data-replace-item", "");
            }

            if (currentVariant && "nathan" != currentVariant) {
              if (currentVariant.available) {
                var buttonText = this.variantState.preOrder
                  ? this.txt_preOrder || textPreOrder
                  : this.txt_addToCart || textAddToCart;
                $quantityWrapper.show();
                $addToCartButton
                  .removeAttr("stock-disabled disabled " + ARIA_DISABLED)
                  .attr("data-atc-form", "");
                $addToCartButtonText.text(buttonText);
                $paymentButton.show();
                if (this.isSticky) {
                  this.$stickyQuantityWrapper.show();
                  this.$stickyATC.removeAttr("stock-disabled disabled " + ARIA_DISABLED);
                  this.$stickyATCText.text(buttonText);
                }
              } else {
                $quantityWrapper.hide();
                $addToCartButton
                  .attr("stock-disabled", "disabled")
                  .attr(ARIA_DISABLED, !0)
                document.dispatchEvent(new Event('ProductDetailNoAvailable'))
                $addToCartButtonText.text(textSoldOut);
                $paymentButton.hide();
                if (this.isSticky) {
                  this.$stickyQuantityWrapper.hide();
                  this.$stickyATC
                    .attr("stock-disabled", "disabled")
                    .attr(ARIA_DISABLED, !0);
                  this.$stickyATCText.text(textSoldOut);
                }
                window.requestAnimationFrame(() => {
                  const current_sku = $addToCartButton.attr('data-current-sku')
                  const product_id = $addToCartButton.closest('form').attr('data-product-id')
                  Shopify.analytics.publish('stock_alert_subscribe', {
                    product_id: product_id,
                    text: current_sku,
                    event_type: 'impression'
                  });
                })
              }
              $addToCartButton.attr('data-current-sku', currentVariant.sku)
              // 没有选完完整的商品属性
            } else {
              $addToCartButton
                .attr(ARIA_DISABLED, !0)
                .removeAttr('data-current-sku')
              $addToCartButtonText.text(textAddToCart);
              $quantityWrapper.hide();
              $paymentButton.hide();
              if (this.isSticky) {
                this.$stickyQuantityWrapper.hide();
                this.$stickyATC
                  .attr(ARIA_DISABLED, !0);
                this.$stickyATCText.text(textAddToCart);
              }
            }
          }
        },

        _updateDelivery: function (currentVariant, oldVariant, $container) {
          var $delivery = $container.find("[data-order-delivery]");
          if ($delivery[0]) {
            if (currentVariant && currentVariant.available) {
              var deliveryConfig = y($delivery.attr("data-order-delivery"));
              this.variantState.preOrder && deliveryConfig.hideWithPreorder
                ? $delivery.hide()
                : $delivery.show();
            } else {
              $delivery.hide();
            }
          }
        },

        _updateInventoryQuantity: function (currentVariant, oldVariant, $container) {
          var $inventoryQuantity = $container.find("[data-inventory-qty]");
          if ($inventoryQuantity[0]) {
            if (currentVariant && currentVariant.available) {
              $inventoryQuantity.trigger({
                type: "variant:inventory",
                currentVariant: currentVariant,
                oldVariant: this.oldVariant,
              });
            } else {
              $inventoryQuantity.hide();
            }
          }
        },

        _updatePickupAvailabilityContent: function (currentVariant, $container) {
          var eventType = currentVariant && currentVariant.available
            ? "pickupAvailability:update"
            : "pickupAvailability:clear";
          $container.trigger({
            type: eventType,
            currentVariant: currentVariant,
          });
        },

        _updateNotifyBackinStock: function (currentVariant, $container) {
          if (!currentVariant) {
            $container.trigger({
              type: "notifyBackinStock:hide",
              currentVariant: currentVariant,
            });
            return;
          }

          var eventType = this.variantState.available
            ? "notifyBackinStock:hide"
            : "notifyBackinStock:show";
          $container.trigger({
            type: eventType,
            currentVariant: currentVariant,
          });
        },

        _updateBadges: function () {
          var state = this.variantState,
            badges = this.badgeSelector;
          state.onSale
            ? badges.$onSale.removeAttr("hidden")
            : badges.$onSale.attr("hidden", !0);
          state.preOrder
            ? badges.$preOrder.removeAttr("hidden")
            : badges.$preOrder.attr("hidden", !0);
          state.soldOut
            ? badges.$soldOut.removeAttr("hidden")
            : badges.$soldOut.attr("hidden", !0);
        },

        _setVariantState: function (currentVariant) {
          if (currentVariant) {
            this.variantState = {
              available: currentVariant.available,
              soldOut: !currentVariant.available,
              onSale: currentVariant.compare_at_price > currentVariant.price,
              showUnitPrice: !!currentVariant.unit_price,
              preOrder:
                "shopify" == currentVariant.inventory_management &&
                currentVariant.inventory_quantity <= 0 &&
                currentVariant.available,
            };
          } else {
            this.variantState.available = !1;
            this.variantState.soldOut = !1;
            this.variantState.onSale = !1;
            this.variantState.preOrder = !1;
            this.variantState.showUnitPrice = !1;
          }
        },

        _updateVariantImageSwatch: function (currentVariant) {
          if (currentVariant.featured_image) {
            this.$variantImg
              .find(".is--selected")
              .attr(
                "data-bg",
                T4SThemeSP.Images.getNewImageUrl(
                  currentVariant.featured_image.src,
                  this.swatchWidth
                )
              );
          }
        },

        _updateIncomingMess: function (currentVariant) {
          if (!this.useComingMess) return;
          if (!currentVariant) {
            this.$incomingMess.attr("hidden", "");
            return;
          }

          var incomingDate = currentVariant.next_incoming_date,
            inventoryQuantity = currentVariant.inventory_quantity,
            incoming = currentVariant.incoming,
            inventoryManagement = currentVariant.inventory_management;
          if (
            incomingDate &&
            !(inventoryQuantity > 0) &&
            incoming &&
            "shopify" == inventoryManagement
          ) {
            this.$incomingMess.removeAttr("hidden");
            if (this.variantState.available) {
              this.$incomingAvailableDate.html(incomingDate);
              this.$incomingSoldout.hide();
              this.$incomingAvailable.show();
            } else {
              this.$incomingSoldoutDate.html(incomingDate);
              this.$incomingAvailable.hide();
              this.$incomingSoldout.show();
            }
          } else {
            this.$incomingMess.attr("hidden", "");
          }
        },

        // 功能类似于IncomingMess
        _updateNewShippingTips: function (currentVariant, $container) {
          $container
            .find('.sku_after_info')
            .toggle(currentVariant?.new_shipping == 1)
        },

        _updateStickyATC: function (currentVariant) {
          currentVariant.featured_image
            ? this.$stickyimg.attr(
              "data-src",
              T4SThemeSP.Images.lazyloadImagePath(currentVariant.featured_image.src)
            )
            : this.$stickyimg.attr("data-src", this.stickyImgOrginal);
          this.$stickyVtitle.html(currentVariant.title);
          this.$stickyATC.attr("data-variant-id", currentVariant.id);
        },

        _updateHistoryState: function (currentVariant) {
          if (history.replaceState && currentVariant) {
            var url =
              window.location.protocol +
              "//" +
              window.location.host +
              window.location.pathname +
              "?variant=" +
              currentVariant.id;
            window.history.replaceState(
              {
                path: url,
              },
              "",
              url
            );
            void 0 !== window.addthis && addthis.layers.refresh();
          }
        },
      })),
      ProductVariants
    );
  })(),
    u = (function () {
      var e = "data-animation-atc",
        i = T4Sconfigs.timezone,
        n = "t4_nt_guess";
      try {
        n = dayjs.tz.guess();
      } catch (t) { }
      var a = "not4" != i && n != i;
      function o(t) {
        (this.$container = t), this.BootSalesInt();
      }
      function s(t) {
        if (0 != t.length) {
          var i = y(t.attr(e)),
            n = i.ani;
          if ("none" != n) {
            var a = "is--animated " + n,
              o = parseInt(i.time);
            setInterval(function () {
              t.addClass(a),
                setTimeout(function () {
                  t.removeClass(a);
                }, 1e3);
            }, o);
          }
        }
      }
      return (
        (o.prototype = Object.assign({}, o.prototype, {
          BootSalesInt: function () {
            this._liveView(),
              this._flashSold(),
              this._animationATC(),
              this._orderDelivery(),
              this._inventoryQuantity(),
              this._countdown();
          },
          _getRandomInt: function (t, e) {
            return Math.floor(Math.random() * (e - t + 1)) + t;
          },
          _animationATC: function () {
            var t = this.$container.find("[" + e + "]");
            return s(t), void t.length;
          },
          _liveView: function () {
            var t = this.$container.find("[data-live-view]");
            if (0 != t.length) {
              var e = y(t.attr("data-live-view")),
                i = this,
                n = e.min,
                a = e.max,
                o = e.interval,
                s = i._getRandomInt(n, a),
                r = [
                  "1",
                  "2",
                  "4",
                  "3",
                  "6",
                  "10",
                  "-1",
                  "-3",
                  "-2",
                  "-4",
                  "-6",
                ],
                l = ["10", "20", "15"],
                d = "",
                c = "",
                u = "",
                f = t.find("[data-count]");
              p(), t.show(), setInterval(p, o);
            }
            function p() {
              if (
                ((d = Math.floor(Math.random() * r.length)),
                  (c = r[d]),
                  (s = parseInt(s) + parseInt(c)),
                  n >= s)
              ) {
                u = Math.floor(Math.random() * l.length);
                var t = l[u];
                s += t;
              }
              (s < n || s > a) && (s = i._getRandomInt(n, a)),
                f.html(parseInt(s));
            }
          },
          _flashSold: function () {
            var t = this.$container.find("[data-flash-sold]");
            if (0 != t.length) {
              var e = y(t.attr("data-flash-sold")),
                i = this,
                n = e.mins,
                a = e.maxs,
                o = e.mint,
                s = e.maxt,
                r = e.id,
                l =
                  sessionStorage.getItem("soldS" + r) || i._getRandomInt(n, a),
                d =
                  sessionStorage.getItem("soldT" + r) || i._getRandomInt(o, s),
                c = parseInt(l),
                u = parseInt(d),
                f = parseInt(e.time),
                p = t.find("[data-sold]"),
                h = t.find("[data-hour]");
              g(),
                m(c, u),
                t.show(),
                setInterval(function () {
                  (c += i._getRandomInt(1, 4)),
                    (u += 1 * (Math.random() * (0.8 - 0.1) + 0.1).toFixed(1)),
                    g(),
                    m(c, u);
                }, f);
            }
            function m(t, e) {
              p.html(t),
                h.html(Math.floor(u)),
                sessionStorage.setItem("soldS" + r, t),
                sessionStorage.setItem("soldT" + r, e);
            }
            function g() {
              c > a && (c = i._getRandomInt(n, a)),
                u > s && (u = i._getRandomInt(o, s));
            }
          },
          _orderDelivery: function () {
            var e = this.$container.find("[data-order-delivery]");
            if (0 != e.length) {
              var n = y(e.attr("data-order-delivery")),
                o = n.format_day,
                s = n.time.replace("24:00:00", "23:59:59") || "19041994",
                r = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],
                l = n.estimateStartDate || 0,
                d = n.estimateEndDate || 0,
                c = n.cut_day.replace(/ /g, "").split(","),
                u = dayjs(),
                f = 0,
                p = dayjs(),
                h = 0,
                m = n.timezone,
                g = dayjs(),
                v = g.format("HHmmss"),
                b = s.replace(/ /g, "").replace(/:/g, ""),
                S = T4SProductStrings.order_dayNames
                  .replace(/ /g, "")
                  .split(","),
                w = T4SProductStrings.order_monthNames
                  .replace(/ /g, "")
                  .split(",");
              if (a && m)
                try {
                  v = (g = dayjs.tz(g, i)).format("HHmmss");
                } catch (t) {
                }
              if (
                (parseInt(v) >= parseInt(b) &&
                  ((g = g.add(1, "day")),
                    (u = u.add(1, "day")),
                    (p = p.add(1, "day"))),
                  "2" == n.mode)
              ) {
                for (; c.indexOf(r[u.format("d")]) > -1;) u = u.add(1, "day");
                for (; f < l;)
                  f++,
                    (u = u.add(1, "day")),
                    c.indexOf(r[u.format("d")]) > -1 && f--;
                for (; c.indexOf(r[p.format("d")]) > -1;) p = p.add(1, "day");
                for (; h < d;)
                  h++,
                    (p = p.add(1, "day")),
                    c.indexOf(r[p.format("d")]) > -1 && h--;
              } else {
                for (u = u.add(l, "day"); c.indexOf(r[u.format("d")]) > -1;)
                  u = u.add(1, "day");
                for (p = p.add(d, "day"); c.indexOf(r[p.format("d")]) > -1;)
                  p = p.add(1, "day");
              }
              (S = O(S)), (w = O(w));
              var T = parseInt(u.format("D")),
                _ = T + A(T),
                C = w[parseInt(u.format("M")) - 1],
                $ = S[parseInt(u.format("d"))],
                k = parseInt(p.format("D")),
                x = k + A(k),
                I = w[parseInt(p.format("M")) - 1],
                P = S[parseInt(p.format("d"))];
              if (
                (e
                  .find("[data-start-delivery]")
                  .html(
                    u
                      .format(o)
                      .replace("t44", $)
                      .replace("t45", _)
                      .replace("t46", C)
                  ),
                  e
                    .find("[data-end-delivery]")
                    .html(
                      p
                        .format(o)
                        .replace("t44", P)
                        .replace("t45", x)
                        .replace("t46", I)
                    ),
                  "19041994" != s)
              ) {
                var M = e.find("[data-hour-delivery]");
                M.countdown(g.format("YYYY-MM-DD " + s), {
                  elapse: !0,
                }).on("update.countdown", function (i) {
                  if (i.elapsed) e.hide();
                  else {
                    var n = 24 * i.offset.totalDays + i.offset.hours;
                    M.html(
                      i.strftime(t.trim(M.html().replace("[totalHours]", n)))
                    ).show();
                  }
                });
              }
              e.show();
            }
            function O(t) {
              return t.filter(function (t, e, i) {
                return i.indexOf(t) === e;
              });
            }
            function A(t) {
              if (t > 3 && t < 21) return "th";
              switch (t % 10) {
                case 1:
                  return "st";
                case 2:
                  return "nd";
                case 3:
                  return "rd";
                default:
                  return "th";
              }
            }
          },
          _inventoryQuantity: function () {
            var t = this.$container.find("[data-inventory-qty]");
            if (0 != t.length) {
              t.removeAttr("data-ttcalc");
              var e = y(t.attr("data-inventory-qty")),
                i = this,
                n = e.stock,
                a = e.qty,
                o = e.total,
                s = e.min,
                l = e.max,
                d = e.reduce,
                c = e.bgprocess,
                u = e.bgten,
                f = e.id,
                p = e.inventoryQty || 0,
                h = null,
                m = null,
                g = 1,
                v = 1.7,
                b = 0.17,
                S = i._getRandomInt(s, l),
                w = t.find("[data-count]"),
                T = t.find("[data-progressbar]"),
                _ = t.find("[data-message]"),
                C = T.find(">div");
              if (
                (t.on("variant:inventory", function (e) {
                  if ("2" != n) {
                    var o = e.currentVariant,
                      r = o.inventory_quantity || 0;
                    if (((f = o.id), (r >= a || r < 1) && "1" == n)) t.hide();
                    else {
                      (r >= a || 0 == r) &&
                        isStorageSpSession &&
                        ((r =
                          sessionStorage.getItem("probar" + f) ||
                          i._getRandomInt(s, l)),
                          t.attr("data-variant-qty" + f, r)),
                        t.attr("data-variant-qty" + f, r),
                        sessionStorage.setItem("probar" + f, r),
                        w.text(r);
                      var d = (100 * r) / t.attr("data-ttcalc"),
                        p = r < 10 ? u : c;
                      C.css({
                        "background-color": p,
                        width: d + "%",
                      }),
                        _.show(),
                        T.show(),
                        t.show();
                    }
                  } else t.show();
                }),
                  !(p >= a || p < 1) || "1" != n)
              ) {
                if (
                  (p < a && p > 0 && (S = p),
                    isStorageSpSession && !r && "1" != n)
                ) {
                  var $ = sessionStorage.getItem("probar" + f);
                  $ > 0 && (S = $);
                }
                w.text(S).css({
                  "background-color": "#fff",
                  color: c,
                }),
                  k(S, c, u),
                  _.show(),
                  T.show(),
                  (function () {
                    if (!d) return;
                    (h = setTimeout(function () {
                      --S < g &&
                        (S =
                          x(t.attr("data-variant-qty" + f)) ||
                          i._getRandomInt(s, l)),
                        w.css({
                          "background-color": c,
                          color: "#fff",
                        }),
                        setTimeout(function () {
                          w.css({
                            "background-color": "#fff",
                            color: c,
                          });
                        }, 1800),
                        w.text(S),
                        k(S, c, u);
                    }, 6e4 * b)),
                      (m = setInterval(function () {
                        --S < g &&
                          ((S =
                            x(t.attr("data-variant-qty" + f)) ||
                            i._getRandomInt(s, l)),
                            t.on("destroy:inventoryQty").hide()),
                          w.css({
                            "background-color": c,
                            color: "#fff",
                          }),
                          setTimeout(function () {
                            w.css({
                              "background-color": "#fff",
                              color: c,
                            });
                          }, 1800),
                          w.text(S),
                          k(S, c, u);
                      }, 6e4 * v));
                  })(),
                  t.on("destroy:inventoryQty", function () {
                    clearTimeout(h), clearInterval(m);
                  }),
                  t.on("update:inventoryQty", function () {
                    var e = parseInt(w.text()) - 1;
                    if (!(e < 1)) {
                      w.text(e);
                      var i = (100 * e) / t.attr("data-ttcalc"),
                        n = e < 10 ? u : c;
                      C.css({
                        "background-color": n,
                        width: i + "%",
                      });
                    }
                  });
              }
            }
            function k(e, i, n) {
              (e = parseInt(e)),
                isStorageSpSession && sessionStorage.setItem("probar" + f, e),
                (o = t.attr("data-ttcalc") || o > e ? o : e + o),
                t.attr("data-ttcalc", o);
              var a = (100 * e) / o,
                s = e < 10 ? n : i;
              C.css("background-color", s),
                setTimeout(function () {
                  C.css("width", a + "%");
                }, 300),
                C.css("background-color", s);
            }
            function x(t) {
              return t || 0;
            }
          },
          _countdown: function () {
            var t = this.$container.find("[data-countdown-pr]");
            if (0 != t.length) {
              var e,
                n = t.find("[data-cd-options]"),
                o = y(n.attr("data-cd-options"));
              if (!o.isCountdownMeta) {
                e = o.cd_date.replace("24:00:00", "23:59:59").split(",");
                var s,
                  r,
                  l = dayjs(),
                  d = l.format("HHmmss"),
                  c = e.length;
                if (a)
                  try {
                    d = (l = dayjs.tz(l, i)).format("HHmmss");
                  } catch (t) {
                  }
                for (s = 0; s < c; s++) {
                  if (parseInt(e[s].replace(/:/g, "")) >= d) {
                    r = e[s];
                    break;
                  }
                  s == c - 1 && (r = e[s]);
                }
                n.attr("data-date", l.format("YYYY-MM-DD") + " " + r);
              }
              n.attr("data-countdown-t4s", ""), T4SThemeSP.Countdown();
            }
          },
        })),
        {
          init: o,
          ani: s,
        }
      );
    })(),
    // 视频管理
    f = (function () {
      var t = {},
        e = {
          shopify: "shopify",
          external: "external",
        },
        i = {
          productMediaWrapper: "[data-product-single-media-wrapper]",
        },
        n = {
          enableVideoLooping: "enable-video-looping",
          enableVideoMuting: "enable-video-muting",
          enableVideoAutoplaying: "enable-video-autoplaying",
          videoId: "video-id",
        };
      function a(i) {
        i
          ? (function () {
            for (var i in t)
              if (t.hasOwnProperty(i)) {
                var n = t[i];
                if (n.nativeVideo) continue;
                n.host === e.shopify &&
                  (n.element.setAttribute("controls", "controls"),
                    (n.nativeVideo = !0));
              }
          })()
          : o();
      }
      function o() {
        for (var e in t) {
          if (t.hasOwnProperty(e)) t[e].ready();
        }
      }
      return {
        init: function (o, s) {
          if (o) {
            var r = o.querySelector("iframe, video");
            if (r) {
              var l = o.getAttribute("data-nt-media-id");
              (t[l] = {
                mediaId: l,
                sectionId: s,
                host: ((d = r), "VIDEO" === d.tagName ? e.shopify : e.external),
                container: o,
                element: r,
                ready: function () {
                  !(function (t) {
                    if (!t.player) {
                      var enableVideoAutoplaying = false;
                      // 添加寻找size guide视屏的逻辑
                      var e = t.container.closest(i.productMediaWrapper),
                        a =
                          "true" ===
                          e.getAttribute("data-" + n.enableVideoLooping),
                        o =
                          "true" ===
                          e.getAttribute("data-" + n.enableVideoMuting);
                      (enableVideoAutoplaying =
                        "true" ===
                        e.getAttribute("data-" + n.enableVideoAutoplaying)),
                        (t.player = new Shopify.Video(t.element, {
                          loop: {
                            active: a,
                          },
                          volume: o ? 0 : 1,
                          muted: o,
                        })),
                        e.classList.add("is-media__initialized");
                      var s = function () {
                        t.player && t.player.pause();
                      };
                      e.addEventListener("mediaHidden", s),
                        e.addEventListener("xrLaunch", s),
                        e.addEventListener("mediaVisible", function () {
                          !T4SThemeSP.isTouch &&
                            enableVideoAutoplaying &&
                            t.player &&
                            t.player.play();
                        });
                    }
                  })(this);
                },
              }),
                window.Shopify.loadFeatures([
                  {
                    name: "video-ui",
                    version: "2.0",
                    onLoad: a,
                  },
                ]),
                T4SThemeSP.LibraryLoader.load("plyrShopifyStyles");
            }
          }
          var d;
        },
        hosts: e,
        loadVideos: o,
        removeSectionVideos: function (e) {
          for (var i in t)
            if (t.hasOwnProperty(i)) {
              var n = t[i];
              n.sectionId === e &&
                (n.player && n.player.destroy(), delete t[i]);
            }
        },
      };
    })(),
    p = (function () {
      var t = {},
        e = {},
        i = {},
        n = {
          mediaGroup: "[data-product-single-media-group]",
          xrButton: "[data-shopify-xr]",
        };
      function a(e) {
        if (!e)
          if (window.ShopifyXR) {
            for (var i in t)
              if (t.hasOwnProperty(i)) {
                var n = t[i];
                if (n.loaded) continue;
                var o = document.querySelector("#ModelJson-" + i);
                window.ShopifyXR.addModels(JSON.parse(o.innerHTML)),
                  (n.loaded = !0);
              }
            window.ShopifyXR.setupXRElements();
          } else
            document.addEventListener("shopify_xr_initialized", function () {
              a();
            });
      }
      function o(t) {
        if (!t)
          for (var i in e)
            if (e.hasOwnProperty(i)) {
              var n = e[i];
              n.modelViewerUi ||
                (n.modelViewerUi = new Shopify.ModelViewerUI(n.element)),
                s(n);
            }
      }
      function s(t) {
        var e = i[t.sectionId];
        t.container.classList.add("is-media__initialized"),
          t.container.addEventListener("mediaVisible", function () {
            e.element &&
              e.element.setAttribute("data-shopify-model3d-id", t.modelId),
              T4SThemeSP.isTouch || t.modelViewerUi.play();
          }),
          t.container.addEventListener("mediaHidden", function () {
            e.element &&
              e.element.setAttribute("data-shopify-model3d-id", e.defaultId),
              t.modelViewerUi.pause();
          }),
          t.container.addEventListener("xrLaunch", function () {
            t.modelViewerUi.pause();
          });
      }
      return {
        init: function (s, r) {
          (t[r] = {
            loaded: !1,
          }),
            s.forEach(function (t, a) {
              var o = t.getAttribute("data-nt-media-id"),
                s = t.querySelector("model-viewer"),
                l = s.getAttribute("data-model-id");
              if (0 === a) {
                var d = t.closest(n.mediaGroup).querySelector(n.xrButton);
                i[r] = {
                  element: d,
                  defaultId: l,
                };
              }
              e[o] = {
                modelId: l,
                sectionId: r,
                container: t,
                element: s,
              };
            }),
            window.Shopify.loadFeatures([
              {
                name: "shopify-xr",
                version: "1.0",
                onLoad: a,
              },
              {
                name: "model-viewer-ui",
                version: "1.0",
                onLoad: o,
              },
            ]),
            T4SThemeSP.LibraryLoader.load("modelViewerUiStyles");
        },
        removeSectionModels: function (i) {
          for (var n in e)
            e.hasOwnProperty(n) &&
              e[n].sectionId === i &&
              (e[n].modelViewerUi.destroy(), delete e[n]);
          delete t[i];
        },
      };
    })(),
    h = (function () {
      var e = !1;
      function i(e, i) {
        e = e[0];
        let n = JSON.parse(document.querySelector("#Json360-" + i).innerHTML),
          a = n.imgArray,
          o = parseFloat(e.getAttribute("data-min")) || 1.194,
          s = parseFloat(e.getAttribute("data-max")) || 2,
          r = window.devicePixelRatio < o ? o : window.devicePixelRatio,
          l = r > s ? s : r,
          d = Math.round(e.clientWidth * l);
        n.imgArray = [];
        for (let t in a) n.imgArray.push(`${a[t]}&width=${d}`);
        n.onReady = function () {
          !(function (e, i) {
            i.classList.add("is-media__initialized"),
              i.addEventListener("mediaVisible", function () {
                if (!T4SThemeSP.isTouch)
                  try {
                    e.play(),
                      t(i.querySelector(".nav_bar_play"))
                        .removeClass("nav_bar_play")
                        .addClass("nav_bar_stop");
                  } catch (t) { }
              }),
              t(i).hasClass("is-selected") &&
              (e.play(),
                setTimeout(function () {
                  t(i.querySelector(".nav_bar_play"))
                    .removeClass("nav_bar_play")
                    .addClass("nav_bar_stop");
                }, 50));
            i.addEventListener("mediaHidden", function () {
              e.stop(),
                t(i.querySelector(".nav_bar_stop"))
                  .removeClass("nav_bar_stop")
                  .addClass("nav_bar_play");
            });
          })(c, e);
        };
        var c = t(e.querySelector(".t4s-threesixty")).ThreeSixty(n);
      }
      return {
        init: function (t, n) {
          e
            ? i(t, n)
            : $script(T4Sconfigs.script12b, function () {
              i(t, n), (e = !0);
            });
        },
      };
    })(),
    m = (function () {
      var e = "[data-pickup-availability-popup-open]",
        i = "[data-pickup-availability-popup-close]",
        n = l.mfp_close,
        o = l.mfp_loading,
        s = {};
      function r(t, e) {
        (this.container = e),
          (this.idPopup = this.container.dataset.idPopup),
          (this.hasOnlyDefaultVariant =
            "true" === this.container.dataset.hasOnlyDefaultVariant),
          (this.baseUrl = this.container.dataset.baseUrl),
          (this.variantId = this.container.dataset.variantId);
        var i = this;
        t.on("pickupAvailability:update", function (t) {
          i.updateContent(t.currentVariant.id);
        }),
          t.on("pickupAvailability:clear", function (t) {
            i.clearContent();
          });
      }
      return (
        (r.prototype = Object.assign({}, r.prototype, {
          updateContent: function (t = this.variantId) {
            var i =
              this.baseUrl +
              "/variants/" +
              t +
              "/?section_id=pickup-availability",
              n = this,
              a = "pickup-availability" + t,
              o = n.container.querySelector(e);
            (n.container.style.opacity = 0.5),
              o && ((o.disabled = !0), o.setAttribute("aria-busy", !0)),
              s[a]
                ? n.updateResponse(s[a])
                : T4SThemeSP.getToFetchSection(null, "text", i).then((t) => {
                  "NVT_94" != t && ((s[a] = t), n.updateResponse(t));
                });
          },
          updateResponse: function (t) {
            if ("" !== t.trim()) {
              (this.container.innerHTML = t),
                (this.container.innerHTML =
                  this.container.firstElementChild.innerHTML),
                (this.container.style.opacity = 1);
              var i = this.container.querySelector(e);
              i &&
                ((this.container.querySelector("#pickupAvailabilityPopup").id =
                  this.idPopup),
                  i.addEventListener("click", this._onClickModalOpen.bind(this)));
            }
          },
          clearContent: function () {
            this.container.innerHTML = "";
          },
          _onClickModalOpen: function () {
            var e = this;
            t.magnificPopupT4s.open({
              items: {
                src: `#${e.idPopup}`,
              },
              type: "inline",
              removalDelay: 500,
              tClose: n,
              tLoading: o,
              callbacks: {
                beforeOpen: function () {
                  this.st.mainClass =
                    "mfp-move-horizontal t4s-pickup-availability_pp_wrapper";
                },
                open: function () {
                  a.trigger("NTpopupInline:offClose"),
                    a.trigger("currency:update");
                  var t = document.querySelector(`#${e.idPopup} ${i}`);
                  t &&
                    (t.removeEventListener("click", e._onClickModalClose),
                      t.addEventListener("click", e._onClickModalClose));
                },
                beforeClose: function () { },
                close: function () { },
                afterClose: function () {
                  a.trigger("NTpopupInline:onClose");
                },
              },
            });
          },
          _onClickModalClose: function () {
            t.magnificPopupT4s.close();
          },
        })),
        r
      );
    })(),
    g = (function () {
      var n,
        o,
        s = {
          isShow: "is--shown",
          isActive: "sticky-is--active",
          isHiddenMb: "is-hidden--mobile",
        },
        r = e.height(),
        l = i.height();
      function d(i, r) {
        if (i[0]) {
          var l,
            d = this,
            c = "2" == r;
          (o = i.offset().top + i.outerHeight()),
            d._updateContent(),
            u.ani(n.find("[data-action-atc]")),
            d._stickyAddToCartToggle(),
            c || (n.addClass(s.isShow), a.addClass(s.isActive)),
            e.scroll(function () {
              l && clearTimeout(l),
                (l = setTimeout(function () {
                  d._stickyAddToCartToggle(c);
                }, 30));
            }),
            n.find("[data-sticky-v-title]").on("click", function (e) {
              e.preventDefault(),
                t("html, body").animate(
                  {
                    scrollTop: i.offset().top - 100,
                  },
                  500
                );
            });
        }
      }
      return (
        (d.prototype = Object.assign({}, d.prototype, {
          _updateContent: function () {
            T4SThemeSP.$appendComponent.after(t("#t4s-sticky-atc-temp").html()),
              (n = t("[data-sticky-addtocart]"));
          },
          _stickyAddToCartToggle: function (t) {
            var d = e.scrollTop(),
              c = parseInt(d + r) + 60;
            (l = i.height()),
              o < d && c !== l && c < l
                ? (n.addClass(s.isShow), a.addClass(s.isActive))
                : (c === l || c > l || (o > d && t)) &&
                (n.removeClass(s.isShow), a.removeClass(s.isActive));
          },
        })),
        d
      );
    })();
  function v(e) {
    var i = e.find(".t4s-product__media-item:not(.is--media-hide)"),
      n = i.length;
    (4 == n || n > 5) && (n = "normal"),
      e.attr("data-media-sizes", n),
      e
        .find(".t4s-product__media-item:not(.is--media-hide):last")
        .addClass("is--media-last"),
      e.find(".t4s-product__media-item").attr("data-index", ""),
      i.each(function (e) {
        t(this).attr("data-index", e);
      });
  }
  function y(t) {
    return JSON.parse(t || "{}");
  }

  (T4SThemeSP.SizeInfo = (function () {

    const PRODUCT_SIZE_COUNTRY_TITLES = ['NUMERISCHE GRÖSSE', 'NUMERIC SIZE']
    const PRODUCT_SIZE_VALUES = new Set([
      'XXS',
      '2XS',
      'XS',
      'S',
      'M',
      'L',
      'XL',
      'XXL',
      '2XL',
      '3XL',
      '4XL'
    ])

    function _getProductMetafields(productId) {
      if (!productId) {
        return {}
      }

      const productElement =
        document.querySelector(
          `div[data-product-featured][data-product-id="${productId}"]`
        ) ||
        document.querySelector(
          `.t4s-product-form__variants[data-product-id="${productId}"]`
        )
      const metafieldElement =
        productElement?.querySelector('.pr_metafield_json') ||
        document.querySelector(
          `.t4s-product-form__variants[data-product-id="${productId}"] .pr_metafield_json`
        )

      if (!metafieldElement) {
        return {}
      }

      try {
        return JSON.parse(metafieldElement.textContent || '{}')
      } catch (error) {
        window.report_faro({
          file_name: 'assets/theme.js',
          func_name: '_getProductMetafields',
          desc: 'Invalid product metafield data',
          error: error
        })
        return {}
      }
    }

    function _isSizeGuideVersion2(metafieldData) {
      return Number(metafieldData?.size_version) === 2
    }

    // 数据中原本保存的统一使用cm
    function _changeUnit(value, unit, show_unit = false) {
      const d = 2.54;
      // 单位符号
      let unit_str = ''
      // 富豪切换
      if (show_unit) {
        switch (unit) {
          case 'cm':
            unit_str = 'cm'
            break
          case 'inch':
            unit_str = '″'
            break
          default:
            unit_str = ''
            break
        }
      }
      const re1 = new RegExp(/^(\d+(\.\d+)?)-(\d+(\.\d+)?)$/);
      if (/^(\d+)(\.\d+)?$/.test(value) && unit != 'cm') {
        value = value == 0 ? '0' : change_round(value);
      } else if (value == '' || value == null) {
        value = '&nbsp;';
      } else if (re1.test(value) && unit != 'cm') {
        const res = re1.exec(value);
        value = `${change_round(res[1])}${unit_str}-${change_trunc(res[3])}${unit_str}`;
      } else if (re1.test(value) && unit == 'cm') {
        const res = re1.exec(value);
        value = `${res[1]}-${res[3]}${unit_str}`;
      }

      function change_round(v) {
        return Math.round(v / d);
      }

      function change_trunc(v) {
        return Math.trunc(v / d)
      }
      return value;
    }

    function _normalizeBodySizeCol(column) {
      return String(column || '')
        .trim()
        .toLocaleLowerCase()
        .replace(/[\s_-]+/g, '')
    }

    function _isBramiProduct(metafieldData) {
      const hasBra =
        metafieldData.operation_filter && metafieldData.operation_filter.has_bra

      return String(hasBra || '').trim().toLocaleLowerCase() === 'brami'
    }

    function _removeBodySizeCols(bodySizeJson, hiddenBodySizeCols) {
      try {
        if (
          !bodySizeJson ||
          typeof bodySizeJson !== 'object' ||
          Array.isArray(bodySizeJson)
        ) {
          return bodySizeJson
        }

        const hiddenCols = new Set(
          hiddenBodySizeCols
            .map(_normalizeBodySizeCol)
            .filter(Boolean)
        )

        if (!hiddenCols.size) {
          return bodySizeJson
        }

        return Object.fromEntries(
          Object.entries(bodySizeJson).map(([size, measurements]) => {
            if (
              !measurements ||
              typeof measurements !== 'object' ||
              Array.isArray(measurements)
            ) {
              return [size, measurements]
            }

            const filteredMeasurements = Object.fromEntries(
              Object.entries(measurements).filter(([field]) => {
                return !hiddenCols.has(_normalizeBodySizeCol(field))
              })
            )

            return [size, filteredMeasurements]
          })
        )
      } catch (error) {
        window.report_faro({
          file_name: 'assets/theme.js',
          func_name: '_removeBodySizeCols',
          desc: 'Failed to remove hidden body size columns',
          error: error
        })
        return bodySizeJson
      }
    }

    function _parseProductSizeJson(productSizeData) {
      if (typeof productSizeData !== 'string') {
        return []
      }

      return productSizeData
        .split(/\r?\n/)
        .filter(line => line)
        .map(line => line.split('|'))
    }

    function _isProductSizeRow(row) {
      return row.slice(1).some(value => {
        return PRODUCT_SIZE_VALUES.has(
          String(value || '').trim().toLocaleUpperCase()
        )
      })
    }

    function _changeProductSizeTableToJson(productSizeTable) {
      const productSizeJson = {}
      const sizeTables = _splitProductSizeData(productSizeTable)
      const hasSingleTable = sizeTables.length === 1

      sizeTables.forEach(sizeTable => {
        const sizeRowIndex = sizeTable.findIndex(_isProductSizeRow)
        if (sizeRowIndex < 0) return

        const titleRow = sizeTable[Math.max(sizeRowIndex - 1, 0)] || []
        const tableName = hasSingleTable
          ? 'default'
          : titleRow
            .map(value => {
              return String(value || '').replace(/&nbsp;?|\u00a0|\s+/gi, '')
            })
            .filter(Boolean)
            .join('')
            .trim()
            .toLocaleLowerCase()

        if (!tableName) return

        const sizes = sizeTable[sizeRowIndex].slice(1)
        if (!productSizeJson[tableName]) {
          productSizeJson[tableName] = {}
        }

        sizes.forEach((size, sizeIndex) => {
          const sizeName = String(size || '').trim().toLocaleLowerCase()
          if (!sizeName) return

          if (!productSizeJson[tableName][sizeName]) {
            productSizeJson[tableName][sizeName] = {}
          }

          sizeTable.slice(sizeRowIndex + 1).forEach(attributeRow => {
            const attributeName = String(attributeRow[0] || '').trim()
            const attributeValue = attributeRow[sizeIndex + 1]

            if (
              !attributeName ||
              _isCountrySizeTitle(attributeName) ||
              attributeValue === undefined ||
              attributeValue === null ||
              attributeValue === ''
            ) {
              return
            }

            productSizeJson[tableName][sizeName][attributeName] =
              String(attributeValue).trim()
          })
        })
      })

      return productSizeJson
    }

    function _changeProductUnit(value, rowIndex, excludedRows, unit) {
      if (rowIndex === 1 || excludedRows.has(rowIndex)) {
        return value
      }

      const d = 2.54
      const rangePattern = /^(\d+(\.\d+)?)-(\d+(\.\d+)?)$/

      if (/^(\d+)(\.\d+)?$/.test(value) && unit !== 'cm') {
        return value == 0 ? '0' : Math.round(value / d)
      }

      if (value === '' || value == null) {
        return '&nbsp;'
      }

      if (rangePattern.test(value) && unit !== 'cm') {
        const range = rangePattern.exec(value)
        return `${Math.round(range[1] / d)}-${Math.trunc(range[3] / d)}`
      }

      return value
    }

    function _getCountrySizeValue(size, countrySizeJson, countryCode) {
      const sizeKey = String(size || '').trim()
      if (!sizeKey) return undefined
      return countrySizeJson?.[sizeKey]?.[countryCode]
    }

    function _isCountrySizeTitle(value) {
      return PRODUCT_SIZE_COUNTRY_TITLES.includes(String(value || '').trim())
    }

    function _addCountrySizeLine(sizeData, countrySizeJson, countryCode) {
      return _splitProductSizeData(sizeData).flatMap(sizeTable => {
        const sizeLine = sizeTable.find(row => {
          return row.some(item => {
            return _getCountrySizeValue(
              item,
              countrySizeJson,
              countryCode
            ) !== undefined
          })
        })

        return sizeTable.map(row => {
          if (!row.some(_isCountrySizeTitle)) {
            return row
          }

          return row.map((item, index) => {
            if (_isCountrySizeTitle(item)) return countryCode

            const countrySizeValue = _getCountrySizeValue(
              sizeLine?.[index],
              countrySizeJson,
              countryCode
            )
            return countrySizeValue !== undefined ? countrySizeValue : item
          })
        })
      })
    }

    function _convertProductSizeTableUnit(
      productSizeJson,
      countrySizeJson,
      countryCode,
      unit,
      prepareForRender = false,
      addCountrySize = true
    ) {
      const excludedRows = new Set()

      productSizeJson.forEach((row, rowIndex) => {
        if (row.some(_isCountrySizeTitle)) {
          excludedRows.add(rowIndex)
        }
      })

      const convertedData = productSizeJson.map((row, rowIndex) => {
        return row.map(value => {
          return _changeProductUnit(value, rowIndex, excludedRows, unit)
        })
      })

      if (!convertedData.length) {
        return []
      }

      if (prepareForRender) {
        convertedData[0][0] = '&nbsp;'
      }

      return addCountrySize
        ? _addCountrySizeLine(convertedData, countrySizeJson, countryCode)
        : convertedData
    }

    function _splitProductSizeData(sizeData) {
      if (!sizeData.length) {
        return []
      }

      const splitIndexes = []
      sizeData.forEach((row, rowIndex) => {
        if (_isProductSizeRow(row)) {
          splitIndexes.push(Math.max(rowIndex - 1, 0))
        }
      })
      splitIndexes.push(sizeData.length)

      if (splitIndexes.length <= 2) {
        return [sizeData]
      }

      return splitIndexes.slice(0, -1).map((startIndex, index) => {
        return sizeData.slice(startIndex, splitIndexes[index + 1])
      })
    }

    function _makeTableHtml(sizeData) {
      const transposedData = []

      sizeData.forEach((row, rowIndex) => {
        row.forEach((cell, columnIndex) => {
          if (!transposedData[columnIndex]) {
            transposedData[columnIndex] = []
          }
          transposedData[columnIndex][rowIndex] = cell || '&nbsp;'
        })
      })

      let tableHtml = ''
      let tableFieldNameHtml = ''

      transposedData.forEach(row => {
        tableHtml += `<tr> <td>${row.slice(1).join('</td><td>')}</td></tr>`
        tableFieldNameHtml += `<tr><td>${row[0]}</td></tr>`
      })

      return `<div class="content"><div class="fixed_header"><table>${tableFieldNameHtml}</table></div><div class="data"><table>${tableHtml}</table></div></div>`
    }

    function _renderProductSizeTable(sizeData) {
      return _splitProductSizeData(sizeData).map(sizeTable => {
        let tableData = sizeTable.map(row => [...row])

        if (sizeData.length !== sizeTable.length && tableData.length > 1) {
          const tableTitle = tableData[0]
            .filter(item => !String(item).includes('&nbsp'))
            .join('')
          tableData = tableData.slice(1)
          if (tableData[0]) {
            tableData[0][0] = tableTitle
          }
        }

        return `<div class="table-wrapper"> ${_makeTableHtml(tableData)}</div>`
      }).join('')
    }

    function _normalizeOptions(
      bodySizeJson,
      countrySizeJson,
      sizeConfig,
      constructorOptions
    ) {
      // 进入的结构已经是符合要求的完整结构，直接返回
      const isOptionsObject =
        bodySizeJson &&
        typeof bodySizeJson === 'object' &&
        !Array.isArray(bodySizeJson) &&
        (
          Object.prototype.hasOwnProperty.call(bodySizeJson, 'productId') ||
          Object.prototype.hasOwnProperty.call(bodySizeJson, 'bodySizeJson') ||
          Object.prototype.hasOwnProperty.call(bodySizeJson, 'countrySizeJson') ||
          Object.prototype.hasOwnProperty.call(bodySizeJson, 'sizeConfig') ||
          Object.prototype.hasOwnProperty.call(bodySizeJson, 'metafieldData') ||
          Object.prototype.hasOwnProperty.call(bodySizeJson, 'hiddenBodySizeCols') ||
          Object.prototype.hasOwnProperty.call(bodySizeJson, 'sizeStart')
        )

      if (isOptionsObject) {
        return bodySizeJson
      }

      // 判断是否只用商品ID，如果有商品ID那么从，就从DOM中获取数据
      const isProductIdOnly =
        (typeof bodySizeJson === 'string' || typeof bodySizeJson === 'number') &&
        countrySizeJson === undefined &&
        sizeConfig === undefined &&
        constructorOptions === undefined

      if (isProductIdOnly) {
        return { productId: bodySizeJson }
      }

      // 常规sizeInfo，不和产品挂钩，只有body size和country size
      const options =
        constructorOptions && typeof constructorOptions === 'object'
          ? constructorOptions
          : { productId: constructorOptions }

      return {
        ...options,
        bodySizeJson,
        countrySizeJson,
        sizeConfig
      }
    }

    // body_size样例
    // {
    //   "XS": {
    //     "BUST": "76-82",
    //       "WAIST": "56-64",
    //         "HIP": "86-89"
    //   },
    //   "S": {
    //     "BUST": "84-90",
    //       "WAIST": "62-70",
    //         "HIP": "91-94"
    //   },
    //   "M": {
    //     "BUST": "86-96",
    //       "WAIST": "68-76",
    //         "HIP": "97-100"
    //   },
    //   "L": {
    //     "BUST": "98-104",
    //       "WAIST": "74-86",
    //         "HIP": "102-107"
    //   },
    //   "XL": {
    //     "BUST": "106-112",
    //       "WAIST": "88-96",
    //         "HIP": "109-114"
    //   },
    //   "2XL": {
    //     "BUST": "114-120",
    //       "WAIST": "98-106",
    //         "HIP": "117-122"
    //   }
    // }

    function _changeBodyJsonToList(data, country_size_json, size_config) {
      const sizes = Object.keys(data);
      if (!sizes.length) return []
      const fields = Object.keys(data[sizes[0]]);
      const header_name = size_config?.header_name
      const use_country_code = size_config?.country || 'US'

      // 对应的table的表头，主要针对多语言翻译
      let headers = fields
      try {
        if (header_name) {
          headers = fields.map(field => header_name[field] ?? field)
        }
      } catch (err) {
        headers = fields
      }

      return [
        ["&nbsp;", use_country_code, ...headers],
        ...sizes.map(size => [
          size,
          country_size_json?.[size]?.[use_country_code] ?? '&nbsp;',
          ...fields.map(field => data[size][field])
        ])
      ];
    }

    function _changeCountryJsonToList(data) {
      const sizes = Object.keys(data);
      if (!sizes.length) return []
      const fields = Object.keys(data[sizes[0]]);

      return [
        ["&nbsp;", ...fields],
        ...sizes.map(size => [
          size,
          ...fields.map(field => data[size][field])
        ])
      ];
    }

    return function (
      bodySizeJson,
      countrySizeJson,
      sizeConfig,
      constructorOptions
    ) {
      const options = _normalizeOptions(
        bodySizeJson,
        countrySizeJson,
        sizeConfig,
        constructorOptions
      )
      const productId = options.productId
      const metafieldData = options.metafieldData || _getProductMetafields(productId)
      const useSizeGuideVersion2 = _isSizeGuideVersion2(metafieldData)
      const resolvedBodySizeJson = options.bodySizeJson || (
        useSizeGuideVersion2
          ? window.ogl_size_guide_body_2xs
          : window.ogl_size_guide_body
      ) || {}
      const resolvedCountrySizeJson = options.countrySizeJson || (
        useSizeGuideVersion2
          ? window.ogl_size_guide_country_2xs
          : window.ogl_size_guide_country
      ) || {}
      const resolvedSizeConfig = options.sizeConfig || window.ogl_size_config || {}
      const hiddenBodySizeCols = Array.isArray(options.hiddenBodySizeCols)
        ? [...options.hiddenBodySizeCols]
        : [options.hiddenBodySizeCols]
      // 当具有商品的情况下
      if (productId && !_isBramiProduct(metafieldData)) {
        hiddenBodySizeCols.push('underbust')
      }

      const filteredBodySizeJson = _removeBodySizeCols(
        resolvedBodySizeJson,
        hiddenBodySizeCols
      ) || {}
      const header_name = resolvedSizeConfig.header_name || {}
      const use_country_code = resolvedSizeConfig.country || 'US'
      // 当具有商品的情况下
      if (productId) {
        this.product_id = productId
        this.metafield_data = metafieldData
      }

      this.body_size = _changeBodyJsonToList(
        filteredBodySizeJson,
        resolvedCountrySizeJson,
        resolvedSizeConfig
      );
      this.country_size = _changeCountryJsonToList(resolvedCountrySizeJson)
      this.header_name = header_name;
      this.body_size_json = filteredBodySizeJson;
      this.country_size_json = resolvedCountrySizeJson;
      this.product_size_table = _parseProductSizeJson(metafieldData.sizedata)
      this.product_size_json = _changeProductSizeTableToJson(
        this.product_size_table
      )
      this.country = use_country_code

      this.hasProductSize = function hasProductSize() {
        return this.product_size_table.length > 0
      }

      this.getProductSizeJson = function getProductSizeJson(unit = 'cm') {
        return _changeProductSizeTableToJson(
          _convertProductSizeTableUnit(
            this.product_size_table,
            this.country_size_json,
            this.country,
            unit,
            false,
            false
          )
        )
      }

      this.getProductSizeTable = function getProductSizeTable(unit = 'cm') {
        return _convertProductSizeTableUnit(
          this.product_size_table,
          this.country_size_json,
          this.country,
          unit
        )
      }

      this.convertProductSizeTableUnit = this.getProductSizeTable

      this.renderProductSizeTable = function renderProductSizeTable(unit = 'cm') {
        return _renderProductSizeTable(
          _convertProductSizeTableUnit(
            this.product_size_table,
            this.country_size_json,
            this.country,
            unit,
            true
          )
        )
      }

      this.convertBodySizeJsonUnit = function convertBodySizeJsonUnit(unit = 'inch', show_unit = false) {
        const result = {};

        Object.keys(this.body_size_json).forEach(size => {
          result[size] = {};

          Object.keys(this.body_size_json[size]).forEach(key => {
            result[size][key] = _changeUnit(this.body_size_json[size][key], unit, show_unit);
          });
        });

        return result;
      }

      this.convertBodySizeTableUnit = function convertBodySizeTableUnit(unit = 'inch', show_unit = false) {
        return this.body_size.map((row, rowIndex) => {
          return row.map((cell, colIndex) => {
            // 跳过第一行表头，以及每一行第一列 XS/S/M...
            if (rowIndex === 0 || colIndex === 0 || colIndex === 1) {
              return cell;
            }

            return _changeUnit(cell, unit, show_unit);
          });
        });
      }
    }
  })()),
    (T4SThemeSP.Product = (function () {
      var PRODUCT_CONFIG_ATTR = "data-product-featured",
        productVariantsCache = {},
        productOptionsCache = {},
        productSkuTagRequestCache = {},
        recommendSizeRequestCache = {},
        recommendSizeProductInstances = {},
        canRemoveUnavailableVariants = !n.hasClass("is-remove-unavai-0"),
        CLASS_PSWP_DISABLED = "is-pswp-disable",
        RECOMMEND_SIZE_ATTRIBUTE = "data-recommend-size",
        RECOMMEND_LENGTH_STYLE_ATTRIBUTE = "data-recommend-length-style",
        RECOMMEND_SIZE_UPDATED_EVENT = "oglmove:recommend-size:updated",
        RECOMMEND_SIZE_ENDPOINT = "/webhook/v2/get-recommend-size",
        RECOMMEND_SIZE_STORAGE_KEY = "oglmove.size.info",
        VARIANT_IMAGE_SWATCH_SELECTOR =
          ".t4s-color-mode__variant_image .is--first-color",
        MAIN_MEDIA_SELECTOR = "[data-main-media]",
        PICKUP_AVAILABILITY_SELECTOR = "[data-pickup-availability-container]",
        themeConfig = T4Sconfigs,
        productStrings = T4SProductStrings,
        nowTimestamp = themeConfig.nowTimestamp,
        newBadgeDays = themeConfig.new_day_int,
        enableSaleBadge = themeConfig.use_sale_badge,
        saleLabelStyle = themeConfig.label_sale_style,
        enablePreorderBadge = themeConfig.use_preorder_badge,
        enableNewBadge = themeConfig.use_new_badge,
        enableSoldoutBadge = themeConfig.use_soldout_badge,
        enableCustomBadge = themeConfig.use_custom_badge,
        badgeText = {
          sale: productStrings.badgeSale,
          new: productStrings.badgeNew,
          preOrder: productStrings.badgepreOrder,
          soldout: productStrings.badgeSoldout,
          SavePercent: productStrings.badgeSavePercent,
        },
        badgeConfig = {
          texts: badgeText,
          saleStyle: saleLabelStyle,
        };
      // addThisLoaded = !1;

      function normalizeRecommendCategory(value) {
        return String(value || "")
          .trim()
          .toLocaleLowerCase()
          .replace(/\s+/g, " ")
          .replace(/\s*&\s*/g, "&");
      }

      function normalizeProductType(value) {
        return String(value || "")
          .split(">")
          .map(normalizeRecommendCategory)
          .filter(Boolean);
      }

      // 本地身高可能保存为 cm、总英寸或 5'4"，统一转换为 cm 后再匹配版型。
      function convertHeightToCentimeters(height) {
        if (!height || typeof height !== "object") return null;

        var value = height.value,
          unit = String(height.unit || "").trim().toLocaleLowerCase(),
          heightText = String(value || "").trim(),
          feetAndInches = heightText.match(
            /^(\d+)\s*'\s*(\d+(?:\.\d+)?)?/
          ),
          numericValue;

        if (feetAndInches) {
          return (
            Number(feetAndInches[1]) * 30.48 +
            Number(feetAndInches[2] || 0) * 2.54
          );
        }

        numericValue = Number(value);
        if (!Number.isFinite(numericValue) || numericValue <= 0) return null;

        if (unit === "cm") return numericValue;
        if (unit === "in" || unit === "inch" || unit === "inches") {
          return numericValue * 2.54;
        }

        return null;
      }

      // 将商品分类映射到普通、上装或下装尺码。
      function getProductTypeSizeOption(productType) {
        var productTypeParts = normalizeProductType(productType),
          secondCategory = productTypeParts[1] || "",
          fullProductType = productTypeParts.join(">");

        if (secondCategory === "tops") return "size-top";
        if (secondCategory === "bottoms") return "size-bottom";

        if (
          [
            "women>knitwears>cardigans",
            "women>knitwears>knitted tops",
            "women>knitwears>sweaters",
            "women>outerwear>jackets&coats",
          ].indexOf(fullProductType) > -1
        ) {
          return "size-top";
        }

        if (
          [
            "women>knitwears>knitted pants",
            "women>knitwears>knitted skirts",
          ].indexOf(fullProductType) > -1
        ) {
          return "size-bottom";
        }

        return "size";
      }

      function getRecommendationSizeOptionType(category, productType) {
        var normalizedCategory = normalizeRecommendCategory(category),
          topCategories = [
            "top",
            "tops",
            "bra top",
            "bra tops",
            "tank top",
            "tank tops",
            "tee",
            "tees",
            "shirts&tops",
            "hoodies&sweatshirts",
            "sweater",
            "sweaters",
            "cardigan",
            "cardigans",
            "knitted top",
            "knitted tops",
            "jackets&coats",
          ],
          bottomCategories = [
            "bottom",
            "bottoms",
            "pant",
            "pants",
            "short",
            "shorts",
            "skirt",
            "skirts",
            "jean",
            "jeans",
            "skort",
            "skorts",
            "knitted pant",
            "knitted pants",
            "knitted skirt",
            "knitted skirts",
          ];

        if (topCategories.indexOf(normalizedCategory) > -1) {
          return "size-top";
        }

        if (bottomCategories.indexOf(normalizedCategory) > -1) {
          return "size-bottom";
        }

        if (normalizedCategory.indexOf(">") > -1) {
          return getProductTypeSizeOption(category);
        }

        return getProductTypeSizeOption(productType);
      }

      function Product(element) {
        this.$container = t(element);
        this.productConfigs = y(this.$container.attr(PRODUCT_CONFIG_ATTR));
        this.productID = this.productConfigs.id;
        this.container = element;
        this.$mainMedia = this.$container.find(MAIN_MEDIA_SELECTOR);
        this.mainMedia = this.$mainMedia[0];
        this.sectionId = this.productConfigs.sectionId;
        this.disableSwatch = this.productConfigs.disableSwatch;
        this.isSticky = this.productConfigs.isSticky;
        this.isStickyMB = this.productConfigs.isStickyMB;
        this.stickyShow = this.productConfigs.stickyShow;
        this.$addThis = this.$container.find("[data-t4s-addthis]");
        this.eventHandlers = {};
        this.isProductFormReadyForRecommendSize = false;
        this.hasAppliedRecommendSize = false;
        this.recommendSizeResponse = null;
        this.lastRecommendSizeValue = null;
        this.lastRecommendHeightValue = null;

        this._createBadgesProduct();
        this._initBootSales();
        this._initSubmit();

        if (!this.productID) return;

        this._cacheProductElements();

        if (this.productConfigs.isMainProduct) {
          // 同一商品的主商品实例以最新挂载者为准，兼容 Theme Editor 重载。
          recommendSizeProductInstances[String(this.productID)] = this;
        }

        // 尺码推荐：请求与 product form 初始化并行。
        this._initRecommendSize();

        this._initAvailabilityFeatures();

        if (s && !this.isStickyMB) this.isSticky = !1;
        if (this.isSticky) this._initStickyAddToCart();

        this._initProductSwatches();
        this.isProductFormReadyForRecommendSize = true;
        this._tryApplyRecommendSize();

        if (this.mainMedia) {
          this._initProductIsotope();
          this._initDeferredMediaFeatures();
        }

        // if (this._initAddThis()) return;

        this._enableMainMediaClick();
      }

      // 尺码选择器通过全局事件通知对应的主商品实例立即应用最新推荐。
      document.addEventListener(RECOMMEND_SIZE_UPDATED_EVENT, function (event) {
        var detail = event.detail || {},
          eventProductId = String(detail.productId || ""),
          product = recommendSizeProductInstances[eventProductId];

        if (
          !product ||
          !Object.prototype.hasOwnProperty.call(detail, "response")
        ) {
          return;
        }

        product._handleRecommendSizeUpdated(detail.response);
      });

      // function loadAddThisQuickViewHelper() {
      //   $script("https://s7.addthis.com/downloads/ajax_help.min.js", function () {
      //     const addThisTimer = setInterval(function () {
      //       void 0 !== window.addthis_new_tool &&
      //         (clearInterval(addThisTimer),
      //           window.addthis_new_tool(),
      //           addthis.layers.refresh());
      //     }, 100);
      //   });
      // }

      function getProductJson($container, selector) {
        return JSON.parse($container.find(selector).html());
      }

      function hydrateVariantInventoryData($variantSelect, variants) {
        $variantSelect.find("> option").each(function (index) {
          var $option = t(this);
          variants[index].incoming = $option.data("incoming");
          variants[index].next_incoming_date =
            $option.data("nextincomingdate") || null;
          variants[index].inventory_quantity = $option.data("inventoryquantity");
          variants[index].new_shipping = $option.data("newshipping") || 0;
        });
      }

      function normalizeColorOptionOrder(productID, productOptions) {
        const colorOptionName = document.querySelector(
          `[data-product-id='${productID}'] .is-t4s-style__color`
        )?.dataset["optionName"];

        if (!colorOptionName || !productOptions) return;

        for (const option of productOptions) {
          if (option.name.toLowerCase() != colorOptionName.toLowerCase()) continue;

          const swatches = document.querySelectorAll(
            `[data-product-id='${productID}'] .is-t4s-style__color [data-swatch-item]`
          );

          option.values = [...swatches].map(function (swatch) {
            return swatch.getAttribute("data-value");
          });
        }
      }

      function dispatchVariantChange($variantSelect) {
        $variantSelect[0].dispatchEvent(
          new Event("change", {
            bubbles: true,
            cancelable: true,
          })
        );
      }

      function requestProductSkuTags(spu) {
        if (!productSkuTagRequestCache[spu]) {
          productSkuTagRequestCache[spu] = window.ogl_fetch
            .get(
              "/api/v1/spu-attribute-tag/get-spu-attribute-by-spu",
              { spu: spu }
            )
            .then(function (response) {
              return response && response.data ? response.data[spu] : null;
            })
            .catch(function (error) {
              delete productSkuTagRequestCache[spu];
              throw error;
            });
        }

        return productSkuTagRequestCache[spu];
      }

      return (
        (Product.prototype = Object.assign({}, Product.prototype, {
          _cacheProductElements: function () {
            this.$variantImg = this.$container.find(VARIANT_IMAGE_SWATCH_SELECTOR);
            this.disableVariantImage = !this.$variantImg[0];
            this.$formSelectorId = this.$container.find(this.productConfigs.formID);
            this.$formSelectorIdLength = this.$formSelectorId.length;
            this.$sizeGuideButtons = this.$container.find(
              ".t4s-btn__size-chart"
            );
            this.$sizeChartFind = this.$container.find(".size-chart_find");
            this.pickupAvailabilityContainer = this.$container.find(
              PICKUP_AVAILABILITY_SELECTOR
            )[0];
          },

          _setSizeChartFindVisible: function (visible) {
            this.$sizeChartFind.prop("hidden", !visible);
          },

          // 将已选中的长度版型同步给尺码入口，供 size-selector 渲染推荐文案。
          _setRecommendLengthStyle: function (value) {
            var lengthStyle = String(value || "").trim();

            this.$sizeGuideButtons.each(function () {
              if (lengthStyle) {
                this.setAttribute(
                  RECOMMEND_LENGTH_STYLE_ATTRIBUTE,
                  lengthStyle
                );
              } else {
                this.removeAttribute(RECOMMEND_LENGTH_STYLE_ATTRIBUTE);
              }
            });
          },

          // 按顺序命中第一个 height <= max 的规则，max 为 null 时表示无上限。
          _getRecommendLengthStyle: function () {
            var lengthStyleRules = (window.length_styles_limit || [])
              .map(function (rule) {
                var max = rule?.max;

                return {
                  value: String(rule?.value || "").trim(),
                  max:
                    max === null || max === "" || max === undefined
                      ? null
                      : Number(max),
                };
              })
              .filter(function (rule) {
                return (
                  rule.value &&
                  (rule.max === null || Number.isFinite(rule.max))
                );
              }),
              savedCustomerInfo,
              heightInCentimeters;

            if (!lengthStyleRules.length) return "";

            try {
              savedCustomerInfo = JSON.parse(
                window.localStorage.getItem(RECOMMEND_SIZE_STORAGE_KEY) || "null"
              );
            } catch (error) {
              return "";
            }

            heightInCentimeters = convertHeightToCentimeters(
              savedCustomerInfo?.height
            );
            if (!Number.isFinite(heightInCentimeters)) return "";

            var matchedRule = lengthStyleRules.find(function (rule) {
              return rule.max === null || heightInCentimeters <= rule.max;
            });

            return matchedRule ? matchedRule.value : "";
          },

          // 只在 Liquid 标记的长度版型大类中查找目标值，仅用于展示推荐。
          _findRecommendedLengthStyle: function () {
            var targetStyle = this._getRecommendLengthStyle(),
              normalizedTargetStyle = normalizeRecommendCategory(targetStyle),
              $targetOption,
              $targetSwatch;

            if (!normalizedTargetStyle) return "";

            $targetOption = this.$formSelectorId
              .find("[data-swatch-option][data-length-style-option]")
              .filter(function () {
                var hasTargetStyle = false;

                t(this)
                  .find("[data-swatch-item][data-value]")
                  .each(function () {
                    var normalizedValue = normalizeRecommendCategory(
                      this.getAttribute("data-value")
                    );

                    if (normalizedValue === normalizedTargetStyle) {
                      hasTargetStyle = true;
                    }
                  });

                return hasTargetStyle;
              })
              .first();

            if (!$targetOption.length) return "";

            $targetSwatch = $targetOption
              .find("[data-swatch-item][data-value]")
              .filter(function () {
                return (
                  normalizeRecommendCategory(this.getAttribute("data-value")) ===
                  normalizedTargetStyle
                );
              })
              .first();

            return $targetSwatch.length
              ? String($targetSwatch.attr("data-value") || targetStyle).trim()
              : "";
          },

          _getSizeOptionType: function (optionElement) {
            var optionType = String(
              optionElement.getAttribute("data-size-option-type") || ""
            ).trim(),
              optionName = normalizeRecommendCategory(
                optionElement.getAttribute("data-option-name") || ""
              ),
              sizeOptionNameMap = window.size_option_name_map || {
                size: ["size", "sizes", "größe"],
                "size-top": ["size-top", "size top", "top size"],
                "size-bottom": [
                  "size-bottom",
                  "size bottom",
                  "bottom size",
                ],
              };

            if (optionType) return optionType;

            for (var type of ["size-top", "size-bottom", "size"]) {
              if (
                (sizeOptionNameMap[type] || [])
                  .map(normalizeRecommendCategory)
                  .indexOf(optionName) > -1
              ) {
                return type;
              }
            }

            return optionName.split("-")[0] === "size" ? "size" : "";
          },

          _getSizeOptions: function () {
            var product = this;

            return this.$formSelectorId
              .find("[data-swatch-option]")
              .filter(function () {
                return Boolean(product._getSizeOptionType(this));
              });
          },

          _findRecommendedSizeSwatch: function (optionType, size) {
            var product = this,
              normalizedSize = normalizeRecommendCategory(size),
              $sizeOptions = this._getSizeOptions(),
              $targetOption = $sizeOptions
                .filter(function () {
                  return product._getSizeOptionType(this) === optionType;
                })
                .first();

            // 单尺码旧商品回退到唯一的尺码 option。
            if (!$targetOption.length && $sizeOptions.length === 1) {
              $targetOption = $sizeOptions.first();
            }

            if (!$targetOption.length || !normalizedSize) return t();

            return $targetOption
              .find("[data-swatch-item][data-value]")
              .filter(function () {
                return (
                  normalizeRecommendCategory(this.getAttribute("data-value")) ===
                  normalizedSize
                );
              })
              .first();
          },

          // 在尺码标题中展示推荐，不改变 swatch 选中状态。
          _setRecommendedSizeCurrentLabel: function (
            $swatch,
            size,
            lengthStyle
          ) {
            if (!$swatch.length) return;

            var recommendedSize = String(
              $swatch.attr("data-value") || size || ""
            ).trim(),
              countrySize = String(
                $swatch.attr("data-country-size") || ""
              ).trim(),
              recommendedText = String(
                productStrings.recommended || "Recommended"
              ).trim(),
              displaySize =
                recommendedSize + (countrySize ? "/" + countrySize : "");

            if (lengthStyle) displaySize += ", " + lengthStyle;

            $swatch
              .closest("[data-swatch-option]")
              .find(".t4s-swatch__current")
              .addClass("is--recommended-size")
              .text(recommendedText + " (" + displaySize + ")");
          },

          _handleRecommendSizeValue: function (serializedResponse) {
            var currentRecommendHeightValue = "";

            // 尺码结果未变化但身高变化时，也必须重新计算 Petite / Regular / Tall。
            try {
              currentRecommendHeightValue = JSON.stringify(
                JSON.parse(
                  window.localStorage.getItem(RECOMMEND_SIZE_STORAGE_KEY) ||
                  "null"
                )?.height || null
              );
            } catch (error) {
              currentRecommendHeightValue = "";
            }

            if (
              serializedResponse === this.lastRecommendSizeValue &&
              currentRecommendHeightValue === this.lastRecommendHeightValue
            ) {
              return;
            }

            this.lastRecommendSizeValue = serializedResponse;
            this.lastRecommendHeightValue = currentRecommendHeightValue;
            this.hasAppliedRecommendSize = false;
            this._setRecommendLengthStyle("");

            if (!serializedResponse) {
              this.recommendSizeResponse = null;
              this._setSizeChartFindVisible(true);
              return;
            }

            try {
              this.recommendSizeResponse = JSON.parse(serializedResponse);
              this._tryApplyRecommendSize();
            } catch (error) {
              this.recommendSizeResponse = null;
              this._setSizeChartFindVisible(true);
              window.report_faro({
                file_name: "assets/theme.js",
                func_name: "Product._handleRecommendSizeValue",
                desc: "Invalid product size recommendation data",
                error: error,
              });
            }
          },

          _setRecommendSizeResponse: function (response) {
            var serializedResponse;

            try {
              serializedResponse = JSON.stringify(response || null);
            } catch (error) {
              this._setSizeChartFindVisible(true);
              window.report_faro({
                file_name: "assets/theme.js",
                func_name: "Product._setRecommendSizeResponse",
                desc: "Failed to serialize product size recommendation",
                error: error,
              });
              return;
            }

            this._handleRecommendSizeValue(serializedResponse);
            this.$sizeGuideButtons.each(function () {
              if (this.getAttribute(RECOMMEND_SIZE_ATTRIBUTE) !== serializedResponse) {
                this.setAttribute(RECOMMEND_SIZE_ATTRIBUTE, serializedResponse);
              }
            });
          },

          // 用户重新提交身材信息后，以最新接口结果刷新推荐提示。
          _handleRecommendSizeUpdated: function (response) {
            this.hasAppliedRecommendSize = false;
            this.lastRecommendSizeValue = null;
            this.lastRecommendHeightValue = null;
            this._setRecommendSizeResponse(response);
          },

          _observeRecommendSizeAttribute: function () {
            var product = this;

            if (!window.MutationObserver || !this.$sizeGuideButtons.length) return;

            this.recommendSizeObserver = new MutationObserver(function (mutations) {
              for (var mutation of mutations) {
                if (
                  mutation.type === "attributes" &&
                  mutation.attributeName === RECOMMEND_SIZE_ATTRIBUTE
                ) {
                  product._handleRecommendSizeValue(
                    mutation.target.getAttribute(RECOMMEND_SIZE_ATTRIBUTE)
                  );
                }
              }
            });

            this.$sizeGuideButtons.each(function () {
              product.recommendSizeObserver.observe(this, {
                attributes: true,
                attributeFilter: [RECOMMEND_SIZE_ATTRIBUTE],
              });

              var currentValue = this.getAttribute(RECOMMEND_SIZE_ATTRIBUTE);
              if (currentValue) {
                product._handleRecommendSizeValue(currentValue);
              }
            });
          },

          _initRecommendSize: function () {
            if (!this.productConfigs.isMainProduct) return;

            this._observeRecommendSizeAttribute();

            var product = this,
              savedCustomerInfo,
              customerInfo;

            try {
              savedCustomerInfo = window.localStorage.getItem(
                RECOMMEND_SIZE_STORAGE_KEY
              );
              if (!savedCustomerInfo) {
                this._setSizeChartFindVisible(true);
                return;
              }

              customerInfo = JSON.parse(savedCustomerInfo);
              if (
                !customerInfo ||
                typeof customerInfo !== "object" ||
                Array.isArray(customerInfo)
              ) {
                this._setSizeChartFindVisible(true);
                return;
              }
            } catch (error) {
              this._setSizeChartFindVisible(true);
              window.report_faro({
                file_name: "assets/theme.js",
                func_name: "Product._initRecommendSize",
                desc: "Failed to read the saved size profile",
                error: error,
              });
              return;
            }

            if (
              !window.ogl_fetch_ecowrd ||
              typeof window.ogl_fetch_ecowrd.post !== "function"
            ) {
              this._setSizeChartFindVisible(true);
              return;
            }

            var requestData = {
              customer: {
                age: customerInfo.age,
                height: customerInfo.height,
                weight: customerInfo.weight,
                bodyType: customerInfo.bodyType,
                bust: customerInfo.bust,
                underbust: customerInfo.underbust,
                waist: customerInfo.waist,
                hip: customerInfo.hip,
                email: window.customer?.email || "",
                uid: window.ogl_uid || "",
              },
              product: {
                id: this.productID,
              },
            },
              requestCacheKey = this.productID + "::" + savedCustomerInfo;

            if (!recommendSizeRequestCache[requestCacheKey]) {
              recommendSizeRequestCache[requestCacheKey] =
                window.ogl_fetch_ecowrd
                  .post(RECOMMEND_SIZE_ENDPOINT, requestData)
                  .catch(function (error) {
                    delete recommendSizeRequestCache[requestCacheKey];
                    throw error;
                  });
            }

            recommendSizeRequestCache[requestCacheKey]
              .then(function (response) {
                try {
                  if (
                    window.localStorage.getItem(RECOMMEND_SIZE_STORAGE_KEY) !==
                    savedCustomerInfo
                  ) {
                    return;
                  }
                } catch (error) {
                  return;
                }

                product._setRecommendSizeResponse(response);
              })
              .catch(function (error) {
                product._setSizeChartFindVisible(true);
                window.report_faro({
                  file_name: "assets/theme.js",
                  func_name: "Product._initRecommendSize",
                  desc: "Failed to get the current product recommendation",
                  error: error,
                });
              });
          },

          // 接口和 product form 都就绪后展示推荐，不自动选中尺码或版型。
          _tryApplyRecommendSize: function () {
            if (!this.isProductFormReadyForRecommendSize) {
              return;
            }

            if (!this.Variants) {
              this._setSizeChartFindVisible(true);
              return;
            }

            if (this.hasAppliedRecommendSize) return;

            var response = this.recommendSizeResponse,
              recommendations =
                response && response.code === 0 && Array.isArray(response.data)
                  ? response.data
                  : [];

            this.hasAppliedRecommendSize = true;
            if (!recommendations.length) {
              this._setRecommendLengthStyle("");
              this._setSizeChartFindVisible(true);
              return;
            }

            var product = this,
              recommendedOptionTypes = {},
              matchedRecommendations = [],
              expectedRecommendationCount = 0,
              recommendedLengthStyle = "";

            try {
              recommendations.forEach(function (recommendation) {
                if (
                  !recommendation ||
                  typeof recommendation !== "object"
                ) {
                  return;
                }

                var optionType = getRecommendationSizeOptionType(
                  recommendation.category,
                  product.productConfigs.type
                ),
                  size = String(recommendation.size || "").trim();

                if (!size || recommendedOptionTypes[optionType]) return;
                recommendedOptionTypes[optionType] = true;
                expectedRecommendationCount += 1;

                var $recommendedSwatch = product._findRecommendedSizeSwatch(
                  optionType,
                  size
                );

                if ($recommendedSwatch.length) {
                  matchedRecommendations.push({
                    $swatch: $recommendedSwatch,
                    size: size,
                  });
                }
              });

              // 长度版型依赖有效的尺码推荐，不能单独出现在推荐文案中。
              if (matchedRecommendations.length) {
                recommendedLengthStyle = this._findRecommendedLengthStyle();
              }
              this._setRecommendLengthStyle(recommendedLengthStyle);

              matchedRecommendations.forEach(function (recommendation) {
                product._setRecommendedSizeCurrentLabel(
                  recommendation.$swatch,
                  recommendation.size,
                  recommendedLengthStyle
                );
              });

              // 所有接口返回的尺码都成功匹配时保持隐藏，否则展示手动尺码入口。
              this._setSizeChartFindVisible(
                !expectedRecommendationCount ||
                matchedRecommendations.length !== expectedRecommendationCount
              );
            } catch (error) {
              this._setRecommendLengthStyle("");
              this._setSizeChartFindVisible(true);
              window.report_faro({
                file_name: "assets/theme.js",
                func_name: "Product._tryApplyRecommendSize",
                desc: "Failed to display the recommended product size",
                error: error,
              });
            }
          },

          _initAvailabilityFeatures: function () {
            if (this.pickupAvailabilityContainer && this.$formSelectorIdLength > 0) {
              this._initPickupAvailability();

              if (this.disableSwatch) {
                this.pickupAvailability.updateContent();
              }
            }

            this._initNotifyBackinStock();
          },


          _addCountrySizeToSwatches: function () {
            var sizeInfo;

            try {
              sizeInfo = initSizeInfo(this.productID);
            } catch (error) {
              window.report_faro({
                file_name: 'assets/theme.js',
                func_name: 'Product._addCountrySizeToSwatches',
                desc: 'Failed to initialize country size information',
                error: error
              });
              return;
            }

            var countrySizeMap = sizeInfo && sizeInfo.country_size_json,
              countryCode = sizeInfo && sizeInfo.country;

            if (!countrySizeMap || !countryCode) return;

            var countrySizeKeys = {};
            Object.keys(countrySizeMap).forEach(function (sizeKey) {
              countrySizeKeys[String(sizeKey).trim().toLocaleUpperCase()] =
                sizeKey;
            });

            this.$container
              .find(".is-sw__size [data-swatch-item][data-value]")
              .each(function () {
                var swatch = this,
                  swatchValue = swatch.querySelector("[data-swatch-value]"),
                  originalSize = String(
                    swatch.getAttribute("data-value") || ""
                  ).trim(),
                  sizeValue = originalSize.toLocaleUpperCase(),
                  sizeKey = countrySizeKeys[sizeValue],
                  countrySize =
                    sizeKey &&
                    countrySizeMap[sizeKey] &&
                    countrySizeMap[sizeKey][countryCode],
                  normalizedCountryCode = String(countryCode)
                    .trim()
                    .toLocaleUpperCase();

                if (
                  typeof countrySize === "undefined" ||
                  countrySize === null ||
                  String(countrySize).trim() === ""
                ) {
                  if (swatchValue) swatchValue.textContent = originalSize;
                  swatch.removeAttribute("data-country-code");
                  swatch.removeAttribute("data-country-size");
                  swatch.removeAttribute("aria-label");
                  return;
                }

                swatch.dataset.countryCode = normalizedCountryCode;
                swatch.dataset.countrySize = String(countrySize).trim();
                swatch.setAttribute(
                  "aria-label",
                  originalSize +
                  ", " +
                  normalizedCountryCode +
                  " size " +
                  countrySize
                );
                if (swatchValue) {
                  swatchValue.textContent =
                    originalSize +
                    "/" +
                    normalizedCountryCode + ' ' +
                    String(countrySize).trim();
                }
              });
          },

          _initProductSwatches: function () {
            if (this.disableSwatch || this.$formSelectorIdLength < 1) return;

            this.$originalSelectorId = this.$formSelectorId.find('select[name="id"]');
            this.$options1 = this.$formSelectorId.find(
              '[data-swatch-option][data-id="0"]'
            );
            this.$options2 = this.$formSelectorId.find(
              '[data-swatch-option][data-id="1"]'
            );
            this.$options3 = this.$formSelectorId.find(
              '[data-swatch-option][data-id="2"]'
            );

            this._addCountrySizeToSwatches();

            if (!this.disableVariantImage) {
              this.$variantImgItems = this.$variantImg.find("[data-swatch-item]");
              this.swatchWidth = 2 * this.$variantImgItems.outerWidth();
            }

            this._initVariants();
            this._initProductSkuTags();
            this._swatchesEventListeners();
            this._changeMediaSlider();

            if (!this.disableVariantImage) {
              this._updateVariantImageSwatchFirst();
            }
          },

          _initProductSkuTags: function () {
            var product = this,
              variants = this.Variants && this.Variants.variants,
              skuVariant =
                variants &&
                variants.find(function (variant) {
                  return variant && variant.sku;
                }),
              sku = skuVariant && String(skuVariant.sku).trim();

            if (
              !sku ||
              !window.ogl_fetch ||
              typeof window.ogl_fetch.get !== "function"
            ) {
              return;
            }

            var spu = sku.split("-").slice(0, 2).join("-");
            if (!spu) return;

            requestProductSkuTags(spu)
              .then(function (config) {
                if (!config) return;

                var hotValues = Array.isArray(config.hot)
                  ? config.hot.map(String)
                  : [],
                  newValues = Array.isArray(config.new)
                    ? config.new.map(String)
                    : [];

                // 每个 Product 实例只更新自己的表单，兼容主商品、Featured Product、Quick View 和 Quick Shop。
                product.$formSelectorId
                  .find(
                    ".is-t4s-style__color [data-swatch-item][data-value]"
                  )
                  .each(function () {
                    var $swatch = t(this),
                      value = String($swatch.attr("data-value") || "");

                    if (hotValues.indexOf(value) > -1) {
                      $swatch.addClass("hot");
                    }

                    if (newValues.indexOf(value) > -1) {
                      $swatch.addClass("new");
                    }
                  });
              })
              .catch(function (error) {
                window.report_faro({
                  file_name: 'assets/theme.js',
                  func_name: 'Product._initProductSkuTags',
                  desc: 'Failed to initialize product SKU tags',
                  error: error
                });
              });
          },

          _initDeferredMediaFeatures: function () {
            var product = this;

            setTimeout(function () {
              product._initLoadContent();

              setTimeout(function () {
                product._initProductVideo();
                product._initModelViewerLibraries();
                product._initShopifyXrLaunch();
                product._init360ViewerLibraries();

                var stickyInfo = product.container.querySelector(
                  ".t4s-product__info-container--sticky"
                );

                if (stickyInfo && product.productConfigs.infoOverflowScroller) {
                  product.infoOverflowScroller = new T4SThemeSP.OverflowScroller(
                    stickyInfo,
                    {
                      offsetTopProperty: "--t4s-page-sticky-offset",
                      offsetBottom: 30,
                    }
                  );
                }
              }, 100);
            }, 1e3);
          },

          // _initAddThis: function () {
          //   if (!this.$addThis[0]) return !1;

          //   if (this.$addThis.is("[data-qv-addthis]")) {
          //     if (r) addThisLoaded = !1;

          //     if (void 0 !== window.addthis_new_tool) {
          //       window.addthis_new_tool();
          //       addthis.layers.refresh();
          //       return !0;
          //     }

          //     if (addThisLoaded) {
          //       loadAddThisQuickViewHelper();
          //     } else {
          //       $script(
          //         "https://s7.addthis.com/js/300/addthis_widget.js#pubid=ra-56efaa05a768bd19",
          //         function () {
          //           addThisLoaded = !0;
          //           loadAddThisQuickViewHelper();
          //         }
          //       );
          //     }

          //     return !1;
          //   }

          //   if (!addThisLoaded) {
          //     $script(
          //       "//s7.addthis.com/js/300/addthis_widget.js#pubid=ra-56efaa05a768bd19",
          //       function () {
          //         addThisLoaded = !0;
          //       }
          //     );
          //   }

          //   return !1;
          // },

          _enableMainMediaClick: function () {
            var mainClickAction = this.productConfigs.main_click,
              canZoomOnMobile =
                T4SThemeSP.isTouch && this.productConfigs.enable_zoom_click_mb,
              canOpenPhotoSwipeOnHover =
                T4SThemeSP.isHover && "pswp" == mainClickAction;

            if (
              "none" == mainClickAction ||
              !this.mainMedia ||
              (!canZoomOnMobile && !canOpenPhotoSwipeOnHover)
            ) {
              return;
            }

            this.$mainMedia.find("." + CLASS_PSWP_DISABLED).removeClass(
              CLASS_PSWP_DISABLED
            );
          },

          _initVariants: function () {
            var productConfigs = this.productConfigs,
              variants,
              productOptions;

            if (productVariantsCache[this.productID] || productConfigs.isGrouped) {
              if (!productConfigs.isGrouped) {
                variants = productVariantsCache[this.productID];
                productOptions = productOptionsCache[this.productID];
                this.PrOptionsSize = productOptions.length;
              }
            } else {
              try {
                variants = getProductJson(this.$container, ".pr_variants_json");
                hydrateVariantInventoryData(this.$originalSelectorId, variants);
                productVariantsCache[this.productID] = variants;

                productOptions = getProductJson(this.$container, ".pr_options_json");
                productOptionsCache[this.productID] = productOptions;
                this.PrOptionsSize = productOptions.length;
              } catch (error) {
                window.report_faro({
                  file_name: 'assets/theme.js',
                  func_name: 'Product._initVariants',
                  desc: 'Failed to initialize product variants',
                  error: error
                });
                return;
              }
            }

            normalizeColorOptionOrder(this.productID, productOptions);

            var variantsConfig = {
              enableHistoryState: productConfigs.enableHistoryState || !1,
              $container: this.$container,
              formSelectorId: this.$formSelectorId,
              originalSelectorId: this.$originalSelectorId,
              $options1: this.$options1,
              $options2: this.$options2,
              $options3: this.$options3,
              variants: variants,
              productOptions: productOptions,
              PrOptionsSize: this.PrOptionsSize,
              removeSoldout: productConfigs.removeSoldout,
              isNoPick: productConfigs.isNoPick,
              hasSoldoutUnavailable: productConfigs.hasSoldoutUnavailable,
              canMediaGroup: productConfigs.canMediaGroup,
              isMainProduct: productConfigs.isMainProduct,
              oldVariant: {},
              badgesConfigs: badgeConfig,
              $variantImg: this.$variantImg,
              disableVariantImage: this.disableVariantImage,
              swatchWidth: this.swatchWidth,
              isSticky: this.isSticky,
              showFirstMedia: productConfigs.showFirstMedia,
            };

            this.Variants = new Variants(variantsConfig);
          },

          _swatchesEventListeners: function () {
            if (!this.PrOptionsSize) return;

            var product = this,
              shouldShowSpriteSwatches = true,
              isSpriteForm = this.$formSelectorId.hasClass("is-form-t4spritem");

            function updateColorSwatchTitle($target, $form) {
              if (!$target.hasClass("is-sw__color")) return;

              const color = $target.text();
              const $title = $target.prevAll("h4").first();

              $form.find(".mibao-swatch__current").text("");
              $title.find(".mibao-swatch__current").text(color);
            }

            function updateSelectedSwatchState($swatch) {
              $swatch
                .addClass("is--selected")
                .siblings()
                .removeClass("is--selected");

              $swatch
                .closest("[data-swatch-option]")
                .find("[data-current-value]")
                .html($swatch.data("value"));
            }

            function revealSpriteSwatches() {
              if (!isSpriteForm || !shouldShowSpriteSwatches) return;

              product.$formSelectorId.addClass("t4sproduct-swatched");
              product.$formSelectorId
                .find(
                  [
                    '[data-swatch-option][data-id="0"] [data-swatch-name]',
                    '[data-swatch-option][data-id="1"]',
                    '[data-swatch-option][data-id="2"]',
                  ].join(",")
                )
                .show(150);

              shouldShowSpriteSwatches = false;
            }

            function setClickedSwatchContext($swatch) {
              var optionIndex = Number(
                $swatch.closest("[data-swatch-option]").data("id")
              );

              product.Variants.clickedCurrentValue = String($swatch.data("value"));
              product.Variants.clickedCurrentIndex = "option" + (optionIndex + 1);
              product.Variants.isNoPick = false;
            }

            function collectSelectedOptions() {
              product.Variants.clickedOptions = [];

              product.$formSelectorId
                .find("[data-swatch-option] .is--selected")
                .each(function (_, item) {
                  var $item = t(item),
                    optionIndex = Number(
                      $item.closest("[data-swatch-option]").data("id")
                    );

                  product.Variants.clickedOptions.push({
                    value: String($item.data("value")),
                    index: "option" + (optionIndex + 1),
                  });
                });
            }

            function dispatchMatchedVariant(matchedVariant) {
              product.$originalSelectorId.val(matchedVariant.id);
              product.Variants.currentVariant = matchedVariant;
              dispatchVariantChange(product.$originalSelectorId);
            }

            product.Variants._pd

            product.$formSelectorId.on(
              "click",
              "[data-swatch-item]:not(.is--selected)",
              function (event) {
                event.preventDefault();

                var $swatch = t(this),
                  $form = t(event.delegateTarget),
                  $swatchOption = $swatch.closest("[data-swatch-option]"),
                  selectedSwatchCount,
                  matchedVariant,
                  selectedVariantId;

                updateSelectedSwatchState($swatch);
                revealSpriteSwatches();
                setClickedSwatchContext($swatch);

                selectedSwatchCount = product.$formSelectorId.find(
                  ".is--selected"
                ).length;

                if (
                  selectedSwatchCount < product.PrOptionsSize &&
                  product.Variants.isNoPick
                ) {
                  product.Variants._updateMediaFilterNoPick();
                  return;
                }

                if (product.Variants.isNoPick) {
                  a.trigger("hide.t4s.notices");

                  if (product.isSticky) {
                    t("[data-sticky-addtocart]").removeAttr("hidden");
                  }

                  product.Variants.isNoPick = false;
                }

                product.Variants.eventClickedSwatch = true;
                product.Variants.oldVariant = product.Variants.currentVariant;
                collectSelectedOptions();

                product.Variants.oldVariant = product.Variants.currentVariant;
                matchedVariant = product.Variants._getVariantFromOptions();

                product.$originalSelectorId.val(matchedVariant.id);
                selectedVariantId = product.$originalSelectorId.val();

                if (
                  !canRemoveUnavailableVariants ||
                  (selectedVariantId !== null && selectedVariantId !== "")
                ) {
                  product.Variants.currentVariant = matchedVariant;
                  dispatchVariantChange(product.$originalSelectorId);
                } else {
                  if ($swatchOption.hasClass("is-t4s-style__color")) {
                    product.Variants._updateMediaByColor(
                      product.Variants.clickedCurrentValue
                    );
                  }

                  matchedVariant = product.Variants._updateLastSwatch();
                  if (matchedVariant) {
                    dispatchMatchedVariant(matchedVariant);
                  } else {
                    product.Variants.eventClickedSwatch = false;
                  }
                }

                updateColorSwatchTitle($swatch, $form);
                updateSelectedSwatchText.bind(product)(product.productID);
              }
            );
          },

          _changeMediaSlider: function () {
            var product = this,
              variantMediaSelector =
                ".flickityt4s[data-main-media] .t4s-product__media-item--variant",
              $variantMediaItems = this.$container.find(variantMediaSelector);

            function normalizeOptionValue(value) {
              return String(value || "").trim().toLowerCase();
            }

            function getColorOption() {
              return product.$formSelectorId
                .find("[data-swatch-option].is-t4s-style__color")
                .first();
            }

            function findSwatchByValue($option, value) {
              var normalizedValue = normalizeOptionValue(value);

              return $option
                .find("[data-swatch-item]")
                .filter(function () {
                  return normalizeOptionValue(t(this).data("value")) == normalizedValue;
                })
                .first();
            }

            function getColorValueFromMedia($slide, mediaID) {
              var $colorOption = getColorOption(),
                colorOptionName = normalizeOptionValue($colorOption.data("option-name")),
                mediaGroupName = normalizeOptionValue($slide.data("grname")),
                mediaGroupValue = $slide.data("grpvl"),
                mediaVariantID,
                mediaVariant,
                colorOptionIndex;

              if (!$colorOption.length) return "";

              if (
                mediaGroupValue &&
                mediaGroupName &&
                mediaGroupName == colorOptionName
              ) {
                return mediaGroupValue;
              }

              mediaVariantID = product.$originalSelectorId
                .find('option[data-mdid="' + mediaID + '"]')
                .val();

              mediaVariant = product.Variants._getVariantById(mediaVariantID);
              if (!mediaVariant) return "";

              colorOptionIndex = Number($colorOption.data("id")) + 1;
              return mediaVariant["option" + colorOptionIndex] || "";
            }

            function collectSelectedOptions() {
              product.Variants.clickedOptions = [];

              product.$formSelectorId
                .find("[data-swatch-option] .is--selected")
                .each(function (_, item) {
                  var $item = t(item),
                    optionIndex = Number(
                      $item.closest("[data-swatch-option]").data("id")
                    );

                  product.Variants.clickedOptions.push({
                    value: String($item.data("value")),
                    index: "option" + (optionIndex + 1),
                  });
                });
            }

            function updateColorSwatchTitle($swatch) {
              if (!$swatch.hasClass("is-sw__color")) return;

              var color = $swatch.text(),
                $title = $swatch.prevAll("h4").first();

              product.$formSelectorId.find(".mibao-swatch__current").text("");
              $title.find(".mibao-swatch__current").text(color);
            }

            function updateColorSelection(colorValue) {
              var $colorOption = getColorOption(),
                $colorSwatch = findSwatchByValue($colorOption, colorValue);

              if (!$colorSwatch.length) return !1;

              $colorOption.find("[data-swatch-item].is--selected").removeClass("is--selected");
              $colorSwatch.addClass("is--selected");
              $colorOption.find("[data-current-value]").html($colorSwatch.data("value"));
              updateColorSwatchTitle($colorSwatch);

              return !0;
            }

            function updateOnlyRemainingOptionAvailability() {
              var unselectedOptionCount;

              collectSelectedOptions();
              unselectedOptionCount =
                product.PrOptionsSize - product.Variants.clickedOptions.length;

              if (unselectedOptionCount == 1) {
                product.Variants._updateLastSwatch();
              }
            }


            if (
              !this.PrOptionsSize ||
              !this.productConfigs.changeVariantByImg ||
              !$variantMediaItems.length
            ) {
              return;
            }

            this.$container
              .find(".flickityt4s[data-main-media]")
              .off("select.flickityt4s")
              .on("select.flickityt4s", function (event, slideIndex) {
                var $selectedSlide = t(this)
                  .find(".flickityt4s-slider>[data-main-slide]")
                  .eq(slideIndex),
                  mediaID = $selectedSlide.data("media-id"),
                  colorValue = getColorValueFromMedia($selectedSlide, mediaID);


                if (!colorValue) {
                  return;
                }

                if (updateColorSelection(colorValue)) {
                  updateOnlyRemainingOptionAvailability();
                  updateSelectedSwatchText.bind(product)(product.productID);
                }
              });
          },
          _initBootSales: function () {
            this.BootSales = new u.init(this.$container);
          },
          _initSubmit: function () {
            i.trigger({
              type: "submitAtc:t4s",
              $container: this.$container,
            });
          },
          _initProductVideo: function () {
            var sectionId = this.sectionId,
              mediaItems = this.mainMedia.querySelectorAll(
                '[data-media-type="video"], [data-media-type="external_video"]'
              );

            mediaItems.length < 1 ||
              mediaItems.forEach(function (mediaItem) {
                f.init(mediaItem, sectionId);
              });

            // function initSizeGuideVideo() {
            //   try {
            //     if (meta.page.type !== "product") return;

            //     const productType = this.productConfigs.type,
            //       videoConfig = window.size_guide_video_map[productType];

            //     if (!videoConfig?.video) return;

            //     const sizeGuideVideoWrapper =
            //       document.querySelector(".size_guide_video"),
            //       sizeGuideVideo = document.querySelector(".size_guide_video video");

            //     sizeGuideVideo.src = videoConfig.video;
            //     f.init(sizeGuideVideoWrapper, sectionId);
            //   } catch (error) {
            //     console.error("===>>> size_guide_video error:", error);
            //   }
            // }

            // initSizeGuideVideo.call(this);
          },
          _init360ViewerLibraries: function () {
            var t = this.mainMedia.querySelectorAll('[data-media-type="360"]');
            t.length < 1 || h.init(t, this.sectionId);
          },
          _initModelViewerLibraries: function () {
            var t = this.mainMedia.querySelectorAll('[data-media-type="model"]');
            t.length < 1 || p.init(t, this.sectionId);
          },
          _initShopifyXrLaunch: function () {
            (this.eventHandlers.initShopifyXrLaunchHandler =
              this._initShopifyXrLaunchHandler.bind(this)),
              document.addEventListener(
                "shopify_xr_launch",
                this.eventHandlers.initShopifyXrLaunchHandler
              );
          },
          _initShopifyXrLaunchHandler: function () {
            this.mainMedia
              .querySelector("[data-product-single-media-wrapper]")
              .dispatchEvent(
                new CustomEvent("xrLaunch", {
                  bubbles: !0,
                  cancelable: !0,
                })
              );
          },
          loadContent: function (t) {
            if (t.getAttribute("loaded")) return;
            const e = document.createElement("div"),
              i = t.querySelector("template");
            e.appendChild(i.content.firstElementChild.cloneNode(!0)),
              t.setAttribute("loaded", !0);
            t.appendChild(e.querySelector("video, model-viewer, iframe"));
            i.remove();
          },
          _initLoadContent: function () {
            var t = this;
            t.mainMedia
              .querySelectorAll("[data-deferred-media]")
              .forEach(function (e) {
                e.classList.add("is--adding"),
                  t.loadContent(e.querySelector(".t4s-pr"));
              });
          },
          _initProductIsotope: function () {
            var product = this;

            if (s || !product.productConfigs.hasIsotope) return;

            v(this.$mainMedia);
            T4SThemeSP.Isotopet4s.init(this.$mainMedia);

            e.on("resize.prIstope", function () {
              if (
                e.width() < 768 &&
                product.$mainMedia.hasClass("isotopet4s-enabled")
              ) {
                product.$mainMedia
                  .isotopet4s("destroy")
                  .removeClass("isotopet4s-enabled");
              } else if (
                e.width() >= 768 &&
                !product.$mainMedia.hasClass("isotopet4s-enabled")
              ) {
                setTimeout(function () {
                  T4SThemeSP.Isotopet4s.init(product.$mainMedia);
                }, 500);
              }
            });
          },
          _initPickupAvailability: function () {
            this.pickupAvailability = new m(
              this.$container,
              this.pickupAvailabilityContainer
            );
          },
          _initNotifyBackinStock: function () {
            var $notifyButton = this.$container.find("[data-notify-stock-btn]");

            if ($notifyButton[0]) {
              var baseUrl = $notifyButton.data("base-url"),
                notifyUrl = `${baseUrl}/variants/${$notifyButton.data(
                  "variant-id"
                )}/?section_id=back-in-stock`;

              $notifyButton
                .attr("data-mfp-src", notifyUrl)
                .hide()
                .removeClass("t4s-d-none");

              if (
                this.productConfigs.available ||
                !this.productConfigs.disableSwatch
              ) {
                this.$container.on("notifyBackinStock:show", function (event) {
                  notifyUrl = `${baseUrl}/variants/${event.currentVariant.id}/?section_id=back-in-stock`;

                  $notifyButton
                    .attr({
                      "data-mfp-src": notifyUrl,
                      "data-storageid": `notify-stock${event.currentVariant.id}`,
                    })
                    .show();
                });

                this.$container.on("notifyBackinStock:hide", function () {
                  $notifyButton.hide();
                });
              } else {
                $notifyButton.show();
              }
            }
          },
          _createBadgesProduct: function () {
            let $badgeWrapper = this.$container.find("[data-product-single-badge]"),
              badgeSort = ($badgeWrapper.attr("data-sort") || "")
                .replace(/ /g, "")
                .split(","),
              productConfigs = this.productConfigs,
              badgeHtml = "";

            if (0 == badgeSort.length || 0 == $badgeWrapper.length) return;

            for (let index = 0; index < badgeSort.length; index++)
              switch (badgeSort[index]) {
                case "sale":
                  if (!enableSaleBadge) break;

                  let compareAtPrice = productConfigs.compare_at_price,
                    price = productConfigs.price;

                  if (compareAtPrice <= price) {
                    badgeHtml +=
                      '<span data-badge-sale class="t4s-badge-item t4s-badge-sale" hidden></span>';
                    break;
                  }

                  if ("2" == saleLabelStyle)
                    var discountPercent = (100 * (compareAtPrice - price)) / compareAtPrice,
                      saleText = badgeText.SavePercent.replace(
                        "[sale]",
                        Math.round(discountPercent)
                      );
                  else if ("3" == saleLabelStyle) {
                    var discountAmount = compareAtPrice - price;
                    saleText = T4SThemeSP.Currency.formatMoney(discountAmount);
                  } else saleText = badgeText[badgeSort[index]];

                  badgeHtml +=
                    '<span data-badge-sale class="t4s-badge-item t4s-badge-sale">' +
                    saleText +
                    "</span>";
                  break;
                case "preOrder":
                  if (!enablePreorderBadge) break;
                  badgeHtml += `<span data-badge-preorder class="t4s-badge-item t4s-badge-preorder"${productConfigs.isPreoder ? "" : " hidden"
                    }>${badgeText[badgeSort[index]]}</span>`;
                  break;
                case "new":
                  var productAgeSeconds = nowTimestamp - productConfigs.dateStart,
                    productAgeHours = Math.floor(productAgeSeconds / 3600),
                    productAgeDays = Math.floor(productAgeHours / 24);

                  if (productAgeDays >= newBadgeDays || !enableNewBadge) break;

                  badgeHtml +=
                    '<span class="t4s-badge-item t4s-badge-new">' +
                    badgeText[badgeSort[index]] +
                    "</span>";
                  break;
                case "soldout":
                  if (!enableSoldoutBadge) break;
                  badgeHtml += `<span data-badge-soldout class="t4s-badge-item t4s-badge-soldout"${productConfigs.available ? " hidden" : ""
                    }>${badgeText[badgeSort[index]]}</span>`;
                  break;
                default:
                  let customBadges = productConfigs.customBadge;
                  if (!customBadges || !enableCustomBadge) break;

                  for (
                    let customIndex = 0;
                    customIndex < customBadges.length;
                    customIndex++
                  )
                    badgeHtml +=
                      '<span class="t4s-badge-item t4s-badge-custom t4s-badge-' +
                      productConfigs.customBadgeHandle[customIndex] +
                      '">' +
                      customBadges[customIndex] +
                      "</span>";
              }

            $badgeWrapper.html(badgeHtml);
          },
          _updateVariantImageSwatchFirst: function () {
            let product = this,
              variants = product.Variants.variants,
              variantCount = variants.length;

            this.$variantImgItems.each(function () {
              let $swatch = t(this),
                featuredImage = (function (swatchValue) {
                  for (let index = 0; index < variantCount; index++) {
                    let variant = variants[index];
                    if (
                      variant.featured_image &&
                      variant.options.join(" / ").toLowerCase().indexOf(swatchValue) > -1
                    )
                      return variant.featured_image;
                  }
                })($swatch.data("value").toLowerCase());

              featuredImage &&
                $swatch.attr(
                  "data-bg",
                  T4SThemeSP.Images.getNewImageUrl(
                    featuredImage.src,
                    product.swatchWidth
                  )
                );
            });
          },
          _initStickyAddToCart: function () {
            this.stickyAddToCart = new g(this.$formSelectorId, this.stickyShow);
          },
        })),
        Product
      );
    })()),
    (T4SThemeSP._initProducts = (function () {
      var e = "data-product-featured",
        i = "initProducts__enabled";
      return function () {
        t("[" + e + "]:not(." + i + ")").each(function () {
          t(this).addClass(i), new T4SThemeSP.Product(this);
        });
      };
    })()),
    (T4SThemeSP.Cookies = (function () {
      return function () {
        var t;
        (t = navigator.cookieEnabled) ||
          ((document.cookie = "testcookie"),
            (t = -1 !== document.cookie.indexOf("testcookie"))),
          t || n.addClass("not--cookies");
      };
    })()),
    (T4SThemeSP.isVisible = function (i, n, a, o, s) {
      if (!(i.length < 1)) {
        o = o || "both";
        var r = e,
          l = i.length > 1 ? i.eq(0) : i,
          d = null != s,
          c = d ? t(s) : r,
          u = d ? c.position() : 0,
          f = l.get(0),
          p = c.outerWidth(),
          h = c.outerHeight(),
          m = !0 !== a || f.offsetWidth * f.offsetHeight;
        if ("function" == typeof f.getBoundingClientRect) {
          var g = f.getBoundingClientRect(),
            v = d
              ? g.top - u.top >= 0 && g.top < h + u.top
              : g.top >= 0 && g.top < h,
            y = d
              ? g.bottom - u.top > 0 && g.bottom <= h + u.top
              : g.bottom > 0 && g.bottom <= h,
            b = d
              ? g.left - u.left >= 0 && g.left < p + u.left
              : g.left >= 0 && g.left < p,
            S = d
              ? g.right - u.left > 0 && g.right < p + u.left
              : g.right > 0 && g.right <= p,
            w = n ? v || y : v && y,
            T = n ? b || S : b && S;
          (w = (g.top < 0 && g.bottom > h) || w),
            (T = (g.left < 0 && g.right > p) || T);
          if ("both" === o) return m && w && T;
          if ("vertical" === o) return m && w;
          if ("horizontal" === o) return m && T;
        } else {
          var _ = d ? 0 : u,
            C = _ + h,
            $ = c.scrollLeft(),
            k = $ + p,
            x = l.position(),
            I = x.top,
            P = I + l.height(),
            M = x.left,
            O = M + l.width(),
            A = !0 === n ? P : I,
            E = !0 === n ? I : P,
            L = !0 === n ? O : M,
            V = !0 === n ? M : O;
          if ("both" === o) return !!m && E <= C && A >= _ && V <= k && L >= $;
          if ("vertical" === o) return !!m && E <= C && A >= _;
          if ("horizontal" === o) return !!m && V <= k && L >= $;
        }
      }
    }),
    (T4SThemeSP.Tabs = (function () {
      var e,
        i,
        n,
        a,
        refreshTabNav = function (e) {
          e
            .find(
              ".t4s-tabs-base .t4s-tabs-ul.flickityt4s-enabled, [data-t4s-tab-ul].flickityt4s-enabled, [data-t4s-tab-ul2].flickityt4s-enabled"
            )
            .add(
              e.filter(
                ".t4s-tabs-base .t4s-tabs-ul.flickityt4s-enabled, [data-t4s-tab-ul].flickityt4s-enabled, [data-t4s-tab-ul2].flickityt4s-enabled"
              )
            )
            .flickityt4s("resize");
        },
        deferRefreshTabNav = function (e) {
          var i = function () {
            refreshTabNav(e);
          };
          window.requestAnimationFrame ? window.requestAnimationFrame(i) : i(),
            setTimeout(i, 100),
            setTimeout(i, 500),
            document.fonts && document.fonts.ready && document.fonts.ready.then(i);
        },
        o = "t4s-tabs-enabled",
        s = "t4s-tabs-simple-enabled",
        r = "t4s-tabs-accordion-enabled",
        l = "t4s-active",
        d = 300,
        c = 150;
      return {
        Default: function () {
          0 != (i = t(`[data-t4s-tabs]:not(.${o})`)).length &&
            (i.addClass(o),
              i.on(
                "click",
                "[data-t4s-tab-ul] [data-t4s-tab-item]",
                function (i) {
                  i.preventDefault();
                  var n = t(this),
                    a = n.closest("[data-t4s-tabs]"),
                    o = n.attr("href") || n.data("id-tab"),
                    s = a.find(o),
                    r = s.find(".flickityt4s"),
                    d = s.find(".isotopet4s");
                  a.find("." + l).removeClass(l),
                    a.find("[data-t4s-tab-content]").hide(),
                    n.addClass(l),
                    s.show().addClass(l),
                    s.closest("[data-t4s-tab-wrapper]").addClass(l),
                    clearTimeout(e),
                    (e = setTimeout(function () {
                      r.hasClass("flickityt4s-enabled")
                        ? r.flickityt4s("resize")
                        : d.hasClass("isotopet4s-enabled") &&
                        d.isotopet4s("layout");
                    }, 200));
                }
              ),
              deferRefreshTabNav(i));
        },
        Simple: function () {
          0 != (n = t(`[data-t4s-tabs2]:not(.${s})`)).length &&
            (n.addClass(s),
              n.on(
                "click",
                "[data-t4s-tab-ul2] [data-t4s-tab-item]",
                function (e) {
                  e.preventDefault();
                  var i = t(this),
                    n = i.closest("[data-t4s-tabs2]"),
                    a = i.attr("href") || i.data("id-tab");
                  n.find("." + l).removeClass(l),
                    i.addClass(l),
                    n.find(a).addClass(l),
                    n.find(a).closest("[data-t4s-tab-wrapper]").addClass(l);
                }
              ),
              deferRefreshTabNav(n));
        },
        Accordion: function () {
          0 != (a = t(`[data-t4s-tabs]:not(.${r})`)).length &&
            (a.addClass(r),
              t(".t4s-type-accordion, [data-t4s-accordion-pr]")
                .find("." + l)
                .find("[data-t4s-tab-content]")
                .css("display", "block"),
              a.on(
                "click",
                "[data-t4s-tab-wrapper] [data-t4s-tab-item]",
                function (e) {
                  e.preventDefault();
                  var n = t(this),
                    a = n.closest("[data-t4s-tabs]"),
                    o = a.find("[data-t4s-tab-ul]"),
                    s = a.find("[data-t4s-tab-wrapper]." + l),
                    r = s.find("[data-t4s-tab-content]"),
                    f = n.closest("[data-t4s-tab-wrapper]"),
                    p = f.find("[data-t4s-tab-content]"),
                    m = p.find(".flickityt4s"),
                    g = p.find(".isotopet4s"),
                    timerKey = "t4sAccordionTimer",
                    timerId = a.data(timerKey);

                  clearTimeout(timerId);
                  a.removeData(timerKey);

                  if (f.hasClass(l)) {
                    o.find("." + l).removeClass(l);
                    f.removeClass(l);
                    p.slideUp(d).removeClass(l);
                    return;
                  }

                  s.removeClass(l);
                  o.find("." + l).removeClass(l);
                  f.addClass(l);
                  o.find('a[href="' + n.attr("href") + '"]').addClass(l);
                  r.slideUp(c).removeClass(l);
                  p.stop(!0, !0).slideDown(d).addClass(l);

                  // 等待手风琴展开动画结束，再刷新内部布局并定位当前 wrapper
                  timerId = setTimeout(function () {
                    a.removeData(timerKey);

                    if (m.hasClass("flickityt4s-enabled")) {
                      m.flickityt4s("resize");
                    } else if (g.hasClass("isotopet4s-enabled")) {
                      g.isotopet4s("layout");
                    }

                    var header = t(".t4s-section-header"),
                      headerPosition = header.css("position"),
                      headerHeight =
                        headerPosition === "sticky" ||
                          headerPosition === "fixed"
                          ? header.outerHeight() || 0
                          : 0,
                      wrapperOffset = f.offset();

                    if (
                      !T4SThemeSP.isVisible(p, !0) &&
                      wrapperOffset
                    ) {
                      // 仅在内容不可见时，将 wrapper 移到 Header 下方
                      var scrollTop = Math.max(
                        0,
                        wrapperOffset.top - headerHeight
                      );

                      t("body,html").stop(!0).animate({
                        scrollTop: scrollTop,
                      });
                    }
                  }, d);

                  a.data(timerKey, timerId);
                }
              ));
        },
        RefreshNav: function () {
          deferRefreshTabNav(t(document));
        },
      };
    })()),
    (T4SThemeSP.RenderRefresh = (function () {
      function e(t) {
        a.trigger("currency:update");
        let e = t.find(".flickityt4s"),
          i = t.find(".isotopet4s");
        t.find(".t4s-products").length > 0 &&
          T4SThemeSP.reinitProductGridItem(),
          i.length > 0 && T4SThemeSP.Isotopet4s.init(i),
          e.length > 0 && (e[0].flickityt4s = new T4SThemeSP.Carousel(e[0]));
      }
      return function () {
        0 != t("[data-render-lazy-component]").length &&
          (t("[data-render-lazy-component].lazyloadt4sed").each(function () {
            e(t(this));
          }),
            t("[data-render-lazy-component]:not(.lazyloadt4sed)").one(
              "lazyincluded",
              function (i) {
                var n = t(i.target)[0];
                e(t(n));
              }
            ),
            t("[data-render-lazy-component]:not(.lazyloadt4s)").addClass(
              "lazyloadt4s"
            ));
      };
    })()),
    (T4SThemeSP.ParallaxInt = function () {
      var e = t("[data-parallax-t4strue]:not(.parallax_enabled)");
      0 != e.length &&
        e.each(function () {
          var e = t(this),
            i = e.attr("data-imgsl") || ".t4s-parallax-img";
          (e.find(i).length > 0 || e.is(".t4s-parallax-bg.lazyloadt4sed")) &&
            e.addClass("parallax_enabled").t4sJarallax({
              speed: e.attr("data-speed") || 0.8,
              imgElement: i,
            });
        });
    }),
    (T4SThemeSP.Countdown = (function () {
      var e = T4Sconfigs.timezone,
        i = "t4_nt_guess";
      try {
        i = dayjs.tz.guess();
      } catch (t) { }
      return function () {
        var n = t("[data-countdown-t4s]:not(.t4s-countdown-enabled)");
        0 != n.length &&
          n.each(function () {
            var n,
              a = t(this),
              o =
                t(a.attr("data-keyid")).html() ||
                t.trim(a.html()) ||
                "%D days %H:%M:%S",
              s = a.is("[data-refresh-owl]"),
              r = a.data("loop"),
              l = a.data("date"),
              d = parseInt(a.data("dayl")),
              c = dayjs(),
              u = l.replace(/\//g, "").replace(/-/g, "") + "",
              f = parseInt(u),
              p = u.length < 9 ? "YYYYMMDD" : "YYYYMMDDHHmmss";
            if (
              ((f > parseInt(c.format(p)) || d < 1) && (r = !1),
                r || "true" == r)
            ) {
              var h = dayjs(l).format(" HH:mm:ss"),
                m = d - (c.diff(l.replace(/\//g, "-"), "days") % d);
              (l = (c = c.add(m, "day")).format("YYYY/MM/DD") + h),
                a.attr("data-dateloop", l);
            }
            a
              .countdown(
                (function (t) {
                  if (void 0 !== t) {
                    var n = t.replace("24:00:00", "23:59:59");
                    if ("not4" != e && i != e)
                      try {
                        n = dayjs.tz(t.replace(/\//g, "-"), e).toDate();
                      } catch (t) {
                      }
                    else n = new Date(n);
                    return n;
                  }
                })(l),
                {
                  elapse: !0,
                }
              )
              .on("update.countdown", function (t) {
                if (t.elapsed)
                  a.html("")
                    .addClass("expired_cdt4")
                    .closest("[data-countdown-wrap]")
                    .html("")
                    .addClass("expired_cdt4");
                else {
                  var e = 24 * t.offset.totalDays + t.offset.hours;
                  a.html(t.strftime(o.replace("[totalHours]", e)));
                }
              })
              .addClass("t4s-countdown-enabled")
              .closest("[data-countdown-wrap]")
              .addClass("t4s-countdown-enabled"),
              s &&
              (clearTimeout(n),
                (n = setTimeout(() => {
                  a.closest(".flickityt4s-enabled").flickityt4s("resize");
                }, 600)));
          });
      };
    })()),
    (T4SThemeSP.AnimateOnScroll = (function () {
      var e = T4Sconfigs.timeani || 200,
        i = new IntersectionObserver(function (t, n) {
          t.forEach(function (t) {
            var n = t.target;
            t.isIntersecting &&
              !n.classList.contains("t4s_animated") &&
              (setTimeout(function () {
                n.classList.add("t4s_animated");
              }, e),
                i.unobserve(n));
          });
        });
      return function () {
        var e = t("[data-t4s-animate]:not(.t4s-animate-init)");
        0 != e.length &&
          window.IntersectionObserver &&
          e.each(function (e) {
            i.observe(this), t(this).addClass("t4s-animate-init");
          });
      };
    })()),
    (T4SThemeSP.PopupMFP = (function () {
      var enabledClass = "t4s-mfp-enabled",
        closeText = l.mfp_close,
        loadingText = l.mfp_loading,
        ajaxLoadingHtml =
          '<div class="t4s-loading-spin t4s-spin-centered t4s-spin-dark t4s-spin-medium"></div>',
        iframeMarkup =
          '<div class="mfp-iframe-scaler t4s-pr t4s-mfp-iframe"><div class="mfp-close"></div><iframe class="mfp-iframe" allow="autoplay; encrypted-media" frameborder="0" allowfullscreen></iframe></div>',
        videoIframeTemplate =
          '<iframe src="src_t4s" class="class_t4s" title="" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>',
        videoTypes = {
          html5: "html5",
          youtube: "youtube",
          vimeo: "vimeo",
        },
        genericPopupBound = !1;

      function compactList(items) {
        return t.grep(items, function (item) {
          return !!item;
        });
      }

      function getUninitialized(selector) {
        return t(selector + ":not(." + enabledClass + ")");
      }

      function mainClassWithTriggerId(baseClass, triggerElement) {
        var $trigger = triggerElement.jquery ? triggerElement : t(triggerElement),
          triggerId = $trigger.data("id") || "";
        return compactList([baseClass, triggerId]).join(" ");
      }

      function markInitialized($triggers) {
        $triggers.addClass(enabledClass);
      }

      function initInlinePopups() {
        var $inlineTriggers = getUninitialized("[data-open-mfp-inline]");

        if (0 == $inlineTriggers.length) return;

        $inlineTriggers
          .magnificPopupT4s({
            type: "inline",
            removalDelay: 500,
            tClose: closeText,
            tLoading: loadingText,
            callbacks: {
              beforeOpen: function () {
                this.st.mainClass = mainClassWithTriggerId(
                  "mfp-move-horizontal t4s-inline-popup-wrapper",
                  this.st.el
                );
              },
              open: function () {
                a.trigger("NTpopupInline:offClose"),
                  a.trigger("currency:update");
              },
              afterClose: function () {
                a.trigger("NTpopupInline:onClose");
              },
            },
          });

        markInitialized($inlineTriggers);
      }

      function initIframePopups() {
        var $iframeTriggers = getUninitialized("[data-open-mfp-iframe]");

        if (0 == $iframeTriggers.length) return;

        $iframeTriggers
          .magnificPopupT4s({
            type: "iframe",
            tClose: closeText,
            tLoading: loadingText,
            iframe: {
              markup: iframeMarkup,
              patterns: {
                youtube: {
                  index: "youtube.com/",
                  id: "v=",
                  src: "//www.youtube.com/embed/%id%?enablejsapi=1&autoplay=0&rel=0&playlist=%id%&loop=1",
                },
                vimeo: {
                  index: "vimeo.com/",
                  id: "/",
                  src: "//player.vimeo.com/video/%id%?autoplay=0&loop=1",
                },
                gmaps: {
                  index: "//maps.google.",
                  src: "%id%&output=embed",
                },
              },
              srcAction: "iframe_src",
            },
            callbacks: {
              beforeOpen: function () {
                this.st.mainClass = mainClassWithTriggerId(
                  "t4s-iframe-popup-wrapper",
                  this.st.el
                );
              },
              change: function () { },
              open: function () {
                var $trigger = t(this.st.el),
                  $iframe = t(".t4s-mfp-iframe").find(".mfp-iframe"),
                  iframeSrc = $iframe.attr("src");

                if ($trigger.is("[data-autoplay-true]")) {
                  iframeSrc = iframeSrc.replace("autoplay=0", "autoplay=1");
                }

                if ($trigger.is("[data-loop-false]")) {
                  iframeSrc = iframeSrc
                    .split("&playlist=")[0]
                    .replace("loop=1", "loop=0");
                }

                $iframe.attr("src", iframeSrc);
              },
              close: function () { },
            },
          });

        markInitialized($iframeTriggers);
      }

      function buildHtml5Video(videoOptions) {
        var videoAttributes = compactList([
          'class="mfp-video"',
          'src="' + videoOptions.src + '"',
          'preload="auto"',
          "controls",
          videoOptions.autoplay ? "autoplay" : "",
          videoOptions.loop ? "loop" : "",
          "playsinline",
        ]).join(" ");

        return [
          '<div class="mfp-video-scaler t4s-pr t4s-mfp-video">',
          "<video " + videoAttributes + "></video>",
          "</div>",
        ].join("");
      }

      function buildYoutubeVideo(videoOptions) {
        var videoId = videoOptions.vid,
          iframe = videoIframeTemplate
            .replace(
              "src_t4s",
              "//www.youtube.com/embed/" +
              videoId +
              "?enablejsapi=1&showinfo=0&controls=1&modestbranding=1&autoplay=" +
              +videoOptions.autoplay +
              "&rel=0" +
              (videoOptions.loop ? "&playlist=" + videoId + "&loop=1" : "")
            )
            .replace("class_t4s", "js-youtube");

        return (
          '<div class="mfp-iframe-scaler t4s-pr t4s-mfp-iframe">' +
          iframe +
          "</div>"
        );
      }

      function buildVimeoVideo(videoOptions) {
        var iframe = videoIframeTemplate
          .replace(
            "src_t4s",
            "//player.vimeo.com/video/" +
            videoOptions.vid +
            "?&portrait=0&byline=0&color=" +
            videoOptions.accent_color +
            "&autoplay=" +
            +videoOptions.autoplay +
            "&loop=" +
            +videoOptions.loop
          )
          .replace("class_t4s", "js-vimeo");

        return (
          '<div class="mfp-iframe-scaler t4s-pr t4s-mfp-iframe">' +
          iframe +
          "</div>"
        );
      }

      function buildVideoPopupHtml(videoOptions) {
        switch (videoOptions.type) {
          case videoTypes.html5:
            return buildHtml5Video(videoOptions);
          case videoTypes.youtube:
            return buildYoutubeVideo(videoOptions);
          case videoTypes.vimeo:
            return buildVimeoVideo(videoOptions);
        }
      }

      function openVideoPopup(event) {
        event.preventDefault();

        var $trigger = t(this),
          videoOptions = JSON.parse($trigger.attr("data-options") || "{}"),
          videoHtml = buildVideoPopupHtml(videoOptions);

        if (!videoHtml) return;

        t.magnificPopupT4s.open({
          items: {
            src: videoHtml,
            type: "inline",
          },
          tClose: closeText,
          tLoading: loadingText,
          callbacks: {
            beforeOpen: function () {
              this.st.mainClass = mainClassWithTriggerId(
                "t4s-video-popup-wrapper mfp-video-holder",
                $trigger
              );
            },
            open: function () {
              $trigger.addClass(enabledClass);
            },
            afterClose: function () {
              $trigger.removeClass(enabledClass);
            },
          },
        });
      }

      function initVideoPopups() {
        var $videoTriggers = getUninitialized("[data-open-mfp-video]");

        if (0 == $videoTriggers.length) return;

        $videoTriggers
          .off("click.t4sPopupMfpVideo")
          .on("click.t4sPopupMfpVideo", openVideoPopup);
      }

      function replaceAjaxContent($popupContent, replacements) {
        t.each(replacements.split("||"), function (index, replacement) {
          var replacementParts = replacement.split("=>");
          $popupContent.find(replacementParts[0]).html(replacementParts[1]);
        });
      }

      function removeAskPhoneField($popupContent) {
        $popupContent.find("#t4s-ContactFormAsk__phone").remove();
      }

      function initAjaxPopups() {
        var $ajaxTriggers = getUninitialized("[data-open-mfp-ajax]");

        if (0 == $ajaxTriggers.length) return;

        $ajaxTriggers
          .magnificPopupT4s({
            type: "ajax",
            removalDelay: 500,
            tClose: closeText,
            tLoading: ajaxLoadingHtml,
            callbacks: {
              parseAjax: function (response) {
                var $trigger = t(this.st.el),
                  popupId = $trigger.data("id") || "",
                  popupClass = $trigger.data("class") || "",
                  popupStyle = $trigger.data("style") || "",
                  responseHtml = response.data,
                  popupHtml = responseHtml.split("[t4splitlz]")[1] || responseHtml;

                response.data = `<div class="mfp-with-anim t4s-mfp-popup ${popupClass}" id="${popupId}" style="${popupStyle}">${popupHtml}</div>`;
              },
              ajaxContentAdded: function () { },
              beforeOpen: function () {
                this.st.mainClass =
                  "mfp-move-horizontal t4s-ajax-popup-wrapper";
              },
              open: function () {
                var $trigger = t(this.st.el),
                  customReplacements = $trigger.data("custom"),
                  showPhoneField = $trigger.data("phone"),
                  $popupContent = t(
                    ".t4s-ajax-popup-wrapper:not(.mfp-bg) .mfp-content"
                  );

                a.trigger("NTpopupInline:offClose"),
                  a.trigger("currency:update");
                if (0 == showPhoneField) {
                  removeAskPhoneField($popupContent);
                  setTimeout(function () {
                    removeAskPhoneField($popupContent);
                  }, 400);
                }

                if (customReplacements) {
                  replaceAjaxContent($popupContent, customReplacements);
                  setTimeout(function () {
                    replaceAjaxContent($popupContent, customReplacements);
                  }, 400);
                }
              },
              afterClose: function () {
                var $trigger = t(this.st.el),
                  popupId = $trigger.data("id") || "";
                a.trigger("NTpopupInline:onClose", [{
                  popupId
                }]);
              },
            },
          });

        markInitialized($ajaxTriggers);
      }

      function bindGenericPopup() {
        if (genericPopupBound) return;

        genericPopupBound = !0;

        a.on("click.t4sPopupMfpGeneric", "[data-open-mfp]", function (event) {
          event.preventDefault();

          var $trigger = t(event.currentTarget),
            popupData = $trigger.data(),
            popupSource = popupData.opennt,
            colorClass = popupData.color,
            backgroundClass = popupData.bg,
            popupPosition = popupData.pos,
            popupAnimation = popupData.ani || "has_ntcanvas",
            shouldRestoreSource = popupData.remove,
            contentClass = popupData.class,
            closeBtnInside = popupData.close || !1,
            autoFocusLast = popupData.focuslast || !1,
            focusSelector = $trigger.attr("data-focus"),
            pageScrollTop = window.pageYOffset;

          $trigger.addClass("current_clicked");

          t.magnificPopupT4s.open({
            items: {
              src: popupSource,
              type: "inline",
              tLoading: '<div class="loading-spin dark"></div>',
            },
            tClose: nt_settings.close,
            removalDelay: 300,
            closeBtnInside: closeBtnInside,
            focus: focusSelector,
            autoFocusLast: autoFocusLast,
            callbacks: {
              beforeOpen: function () {
                this.st.mainClass = compactList([
                  popupAnimation,
                  colorClass,
                  popupPosition ? popupAnimation + "_" + popupPosition : "",
                ]).join(" ");
              },
              open: function () {
                n.addClass(popupAnimation);

                if (popupPosition) {
                  n.addClass(popupAnimation + "_" + popupPosition);
                }

                if (contentClass) t(".mfp-content").addClass(contentClass);
                if (backgroundClass) t(".mfp-bg").addClass(backgroundClass);

                t(document.body)
                  .off("click.t4sPopupMfpClose", ".close_pp")
                  .on("click.t4sPopupMfpClose", ".close_pp", function (event) {
                    event.preventDefault();
                    t.magnificPopupT4s.close();
                  });

                if (pageScrollTop) t("html, body").scrollTop(pageScrollTop);
              },
              beforeClose: function () {
                n.removeClass(popupAnimation);
              },
              afterClose: function () {
                if (popupPosition) {
                  n.removeClass(popupAnimation + "_" + popupPosition);
                }

                t(".current_clicked").removeClass("current_clicked");
                if (shouldRestoreSource) t(popupSource).removeClass("mfp-hide");
              },
            },
          });
        });
      }

      return function () {
        if (void 0 === t.fn.magnificPopupT4s) return;

        initInlinePopups();
        initIframePopups();
        initVideoPopups();
        initAjaxPopups();
        bindGenericPopup();
      };
    })()),
    (T4SThemeSP.NTpopupInline = (function () {
      var e,
        i = t("#t4s_temp_modal").html(),
        o = "modalt4s:trigger",
        s = "modalt4s:opened",
        r = "modalt4s:closed",
        l = "modalt4s:destroy",
        d = "t4s-modal--is-active",
        c = "t4s-modal-opened",
        u = ".t4s_qv",
        offCloseEvent = "NTpopupInline:offClose" + u,
        onCloseEvent = "NTpopupInline:onClose" + u,
        f = "transitionend webkitTransitionEnd oTransitionEnd";
      function p() {
        return t("html").hasClass(c);
      }
      function h(t) {
        27 === t.keyCode && a.trigger(r);
      }
      function m(e) {
        if (!p()) return;
        t(e.target).parents().is(".t4s-modal__inner") ||
          t(e.target).parents().is(".mfp-ready") ||
          (e.preventDefault(), a.trigger(r));
      }
      function disableModalClose() {
        a.off("keyup" + u, h), a.off("click" + u, m);
      }
      function restoreModalClose() {
        // A nested popup may finish closing after its parent modal was destroyed.
        if (!p()) return;
        a.off("keyup" + u, h).on("keyup" + u, h),
          a.off("click" + u, m).on("click" + u, m);
      }
      return function (g, v, y, b = null, modalClass = null) {
        (e = b),
          a.off(o).on(o, function (t) {
            p() ? a.trigger(r) : a.trigger(s);
          }),
          a.off(s).on(s, function (a) {
            p() ||
              ((function (a) {
                T4SThemeSP.$appendComponent.after(i);
                var $modal = T4SThemeSP.$appendComponent.next(".t4s-modal");

                e && n.addClass(e);
                // Apply the trigger-specific class to the generated modal only.
                modalClass && $modal.addClass(modalClass);
                $modal.find(".t4s-modal__content").html(a);
              })(g),
                (function (e) {
                  n.addClass(c),
                    t(".t4s-modal").addClass(d),
                    t(".t4s-modal").on(f, function () {
                      t(this).focus().off(f);
                    }),
                    setTimeout(function () {
                      t(".t4s-modal").focus();
                    }, 500),
                    e();
                })(y));
          }),
          a.off(r).on(r, function (i) {
            p() &&
              (t(".t4s-modal .flickityt4s-enabled").trigger("destroy.t4s"),
                t("html").removeClass(c).addClass("t4s-modal-closing"),
                t(".t4s-modal").removeClass(d).addClass("t4s-modal--is-closing"),
                setTimeout(function () {
                  t(".t4s-modal").remove(),
                    t("html").removeClass("t4s-modal-closing"),
                    e && n.removeClass(e),
                    (T4SThemeSP.isEditCartReplace = !1);
                }, 500),
                a.trigger(l));
          }),
          a.off(l).on(l, function (t) {
            a.off(o)
              .off(s)
              .off(r)
              .off(l)
              .off(offCloseEvent)
              .off(onCloseEvent)
              .off("click" + u)
              .off("keyup" + u);
          }),
          a.off("click" + u)
            .on("click" + u, "[data-t4s-modal-close]", function (t) {
              t.preventDefault(), a.trigger(r);
            }),
          a.on("click" + u, m),
          a.off("keyup" + u).on("keyup" + u, h),
          a.off(offCloseEvent).on(offCloseEvent, disableModalClose),
          a.off(onCloseEvent).on(onCloseEvent, restoreModalClose);
      };
    })()),
    (T4SThemeSP.Currency = (function () {
      var t = "${{amount}}",
        e = T4SThemeSP.settings && T4SThemeSP.settings.superScriptPrice,
        i = window.T4Sconfigs.moneyFormat,
        n = function (t, e) {
          return null == t || t != t ? e : t;
        };
      return {
        formatMoney: function (a, o) {
          o || (o = i), "string" == typeof a && (a = a.replace(".", ""));
          var s = "",
            r = /\{\{\s*(\w+)\s*\}\}/,
            l = o || t;
          function d(t, e, i, a) {
            if (
              ((e = n(e, 2)),
                (i = n(i, ",")),
                (a = n(a, ".")),
                isNaN(t) || null == t)
            )
              return 0;
            var o = (t = (t / 100).toFixed(e)).split(".");
            return (
              o[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) +
              (o[1] ? a + o[1] : "")
            );
          }
          switch (l.match(r)[1]) {
            case "amount":
              (s = d(a, 2)),
                e &&
                s &&
                s.includes(".") &&
                (s = s.replace(".", "<sup>") + "</sup>");
              break;
            case "amount_no_decimals":
              s = d(a, 0);
              break;
            case "amount_with_comma_separator":
              (s = d(a, 2, ".", ",")),
                e &&
                s &&
                s.includes(".") &&
                (s = s.replace(",", "<sup>") + "</sup>");
              break;
            case "amount_no_decimals_with_comma_separator":
              s = d(a, 0, ".", ",");
              break;
            case "amount_no_decimals_with_space_separator":
              s = d(a, 0, " ");
          }
          return l.replace(r, s);
        },
        getBaseUnit: function (t) {
          if (
            t &&
            t.unit_price_measurement &&
            t.unit_price_measurement.reference_value
          )
            return 1 === t.unit_price_measurement.reference_value
              ? t.unit_price_measurement.reference_unit
              : t.unit_price_measurement.reference_value +
              t.unit_price_measurement.reference_unit;
        },
      };
    })()),
    (T4SThemeSP.Helpers = (function () {
      return {
        disableBodyScroll: function () {
          var t,
            e = !1,
            i = !1;
          Element.prototype.matches ||
            (Element.prototype.matches =
              Element.prototype.msMatchesSelector ||
              Element.prototype.webkitMatchesSelector),
            Element.prototype.closest ||
            (Element.prototype.closest = function (t) {
              var e = this;
              if (!document.documentElement.contains(el)) return null;
              do {
                if (e.matches(t)) return e;
                e = e.parentElement;
              } while (null !== e);
              return el;
            });
          var n = function (t) {
            (!1 !== i && t.target.closest(e)) || t.preventDefault();
          },
            a = function (e) {
              1 === e.targetTouches.length && (t = e.targetTouches[0].clientY);
            },
            o = function (e) {
              if (1 === e.targetTouches.length) {
                var n = e.targetTouches[0].clientY - t;
                0 === i.scrollTop && n > 0 && e.preventDefault(),
                  i.scrollHeight - i.scrollTop <= i.clientHeight &&
                  n < 0 &&
                  e.preventDefault();
              }
            };
          return function (t, s) {
            void 0 !== s && ((e = s), (i = document.querySelector(s))),
              !0 === t
                ? (!1 !== i &&
                  (i.addEventListener("touchstart", a, !1),
                    i.addEventListener("touchmove", o, !1)),
                  document.body.addEventListener("touchmove", n, !1))
                : (!1 !== i &&
                  (i.removeEventListener("touchstart", a, !1),
                    i.removeEventListener("touchmove", o, !1)),
                  document.body.removeEventListener("touchmove", n, !1));
          };
        },
        debounce: function (t, e, i) {
          var n;
          return function () {
            var a = this,
              o = arguments,
              s = i && !n;
            clearTimeout(n),
              (n = setTimeout(function () {
                (n = null), i || t.apply(a, o);
              }, e)),
              s && t.apply(a, o);
          };
        },
        getScript: function (t, e) {
          return new Promise(function (i, n) {
            var a = document.createElement("script"),
              o = e || document.getElementsByTagName("script")[0];
            function s(t, e) {
              (e || !a.readyState || /loaded|complete/.test(a.readyState)) &&
                ((a.onload = null),
                  (a.onreadystatechange = null),
                  (a = void 0),
                  e ? n() : i());
            }
            (a.async = !0),
              (a.defer = !0),
              (a.onload = s),
              (a.onreadystatechange = s),
              (a.src = t),
              o.parentNode.insertBefore(a, o);
          });
        },
        loadScript: function (e, i) {
          null != e &&
            t.ajax({
              url: e,
              dataType: "script",
              success: i,
              async: !0,
            });
        },
        prepareTransition: function (t) {
          t.addEventListener(
            "transitionend",
            function (t) {
              t.currentTarget.classList.remove("is-transitioning");
            },
            {
              once: !0,
            }
          );
          var e = 0;
          [
            "transition-duration",
            "-moz-transition-duration",
            "-webkit-transition-duration",
            "-o-transition-duration",
          ].forEach(function (i) {
            var n = getComputedStyle(t)[i];
            n && (n.replace(/\D/g, ""), e || (e = parseFloat(n)));
          }),
            0 !== e && (t.classList.add("is-transitioning"), t.offsetWidth);
        },
        serialize: function (t) {
          var e = [];
          return (
            Array.prototype.slice.call(t.elements).forEach(function (t) {
              !t.name ||
                t.disabled ||
                ["file", "reset", "submit", "button"].indexOf(t.type) > -1 ||
                ("select-multiple" !== t.type
                  ? (["checkbox", "radio"].indexOf(t.type) > -1 &&
                    !t.checked) ||
                  e.push(
                    encodeURIComponent(t.name) +
                    "=" +
                    encodeURIComponent(t.value)
                  )
                  : Array.prototype.slice.call(t.options).forEach(function (i) {
                    i.selected &&
                      e.push(
                        encodeURIComponent(t.name) +
                        "=" +
                        encodeURIComponent(i.value)
                      );
                  }));
            }),
            e.join("&")
          );
        },
        cookiesEnabled: function () {
          var t = navigator.cookieEnabled;
          return (
            t ||
            ((document.cookie = "testcookie"),
              (t = -1 !== document.cookie.indexOf("testcookie"))),
            t
          );
        },
        promiseStylesheet: function (t) {
          var e = t;
          return (
            void 0 === this.stylesheetPromise &&
            (this.stylesheetPromise = new Promise(function (t) {
              var i = document.querySelector('link[href="' + e + '"]');
              i.loaded && t(),
                i.addEventListener("load", function () {
                  setTimeout(t, 0);
                });
            })),
            this.stylesheetPromise
          );
        },
      };
    })()),
    (T4SThemeSP.slate = {});
  var b = T4SThemeSP.slate;
  (b.utils = {
    getParameterByName: function (t, e) {
      e || (e = window.location.href), (t = t.replace(/[[\]]/g, "\\$&"));
      var i = new RegExp("[?&]" + t + "(=([^&#]*)|&|#|$)").exec(e);
      return i
        ? i[2]
          ? decodeURIComponent(i[2].replace(/\+/g, " "))
          : ""
        : null;
    },
    removeParameterByName: function (t, e) {
      e || (e = window.location.href), (t = t.replace(/[[\]]/g, "\\$&"));
      var i = e.split("?")[0],
        n = [],
        a = -1 !== e.indexOf("?") ? e.split("?")[1] : "";
      if ("" !== a) {
        for (var o = (n = a.split("&")).length - 1; o >= 0; o -= 1)
          n[o].split("=")[0] === t && n.splice(o, 1);
        n.length && (i = i + "?" + n.join("&"));
      }
      return i;
    },
    resizeSelects: function (e) {
      e.each(function () {
        var e = t(this),
          i = e.find("option:selected").text(),
          n = t("<span>").html(i);
        n.appendTo("body");
        var a = n.width();
        n.remove(), e.width(a + 10);
      });
    },
    keyboardKeys: {
      TAB: 9,
      ENTER: 13,
      ESCAPE: 27,
      LEFTARROW: 37,
      RIGHTARROW: 39,
    },
  }),
    (b.rte = {
      wrapTable: function (t) {
        t.$tables.wrap('<div class="' + t.tableWrapperClass + '"></div>');
      },
      wrapIframe: function (e) {
        e.$iframes.each(function () {
          t(this).wrap('<div class="' + e.iframeWrapperClass + '"></div>'),
            (this.src = this.src);
        });
      },
    }),
    (b.a11y = {
      pageLinkFocus: function (t) {
        var e = "js-focus-hidden";
        t.first()
          .attr("tabIndex", "-1")
          .focus()
          .addClass(e)
          .one("blur", function () {
            t.first().removeClass(e).removeAttr("tabindex");
          });
      },
      focusHash: function () {
        var e = window.location.hash;
        e && document.getElementById(e.slice(1)) && this.pageLinkFocus(t(e));
      },
      bindInPageLinks: function () {
        t("a[href*=#]").on(
          "click",
          function (e) {
            this.pageLinkFocus(t(e.currentTarget.hash));
          }.bind(this)
        );
      },
      trapFocus: function (e) {
        var i = {
          focusin: e.namespace ? "focusin." + e.namespace : "focusin",
          focusout: e.namespace ? "focusout." + e.namespace : "focusout",
          keydown: e.namespace
            ? "keydown." + e.namespace
            : "keydown.handleFocus",
        },
          n = e.$container.find(
            t(
              'button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])'
            ).filter(":visible")
          ),
          a = n[0],
          o = n[n.length - 1];
        e.$elementToFocus || (e.$elementToFocus = e.$container),
          e.$container.attr("tabindex", "-1"),
          e.$elementToFocus.focus(),
          t(document).off("focusin"),
          t(document).on(i.focusout, function () {
            t(document).off(i.keydown);
          }),
          t(document).on(i.focusin, function (e) {
            (e.target !== o && e.target !== a) ||
              t(document).on(i.keydown, function (t) {
                !(function (t) {
                  t.keyCode === b.utils.keyboardKeys.TAB &&
                    (t.target !== o ||
                      t.shiftKey ||
                      (t.preventDefault(), a.focus()),
                      t.target === a &&
                      t.shiftKey &&
                      (t.preventDefault(), o.focus()));
                })(t);
              });
          });
      },
      removeTrapFocus: function (e) {
        var i = e.namespace ? "focusin." + e.namespace : "focusin";
        e.$container &&
          e.$container.length &&
          e.$container.removeAttr("tabindex"),
          t(document).off(i);
      },
      accessibleLinks: function (e) {
        var i = document.querySelector("body"),
          n = {
            newWindow: "a11y-new-window-message",
            external: "a11y-external-message",
            newWindowExternal: "a11y-new-window-external-message",
          };
        (void 0 !== e.$links && e.$links.jquery) ||
          (e.$links = t("a[href]:not([aria-describedby])")),
          t.each(e.$links, function () {
            var e = t(this),
              i = e.attr("target"),
              a = e.attr("rel"),
              o = (function (t) {
                var e = window.location.hostname;
                return t[0].hostname !== e;
              })(e),
              s = "_blank" === i;
            o && e.attr("aria-describedby", n.external),
              s &&
              ((void 0 !== a && -1 !== a.indexOf("noopener")) ||
                e.attr("rel", function (t, e) {
                  return (void 0 === e ? "" : e + " ") + "noopener";
                }),
                e.attr("aria-describedby", n.newWindow)),
              o && s && e.attr("aria-describedby", n.newWindowExternal);
          }),
          (function (e) {
            "object" != typeof e && (e = {});
            var a = t.extend(
              {
                newWindow: "Opens in a new window.",
                external: "Opens external website.",
                newWindowExternal: "Opens external website in a new window.",
              },
              e
            ),
              o = document.createElement("ul"),
              s = "";
            for (var r in a) s += "<li id=" + n[r] + ">" + a[r] + "</li>";
            o.setAttribute("hidden", !0), (o.innerHTML = s), i.appendChild(o);
          })(e.messages);
      },
    }),
    (T4SThemeSP.LinkMyltiLang = (function () {
      var e = T4SThemeSP.root_url,
        i = window.location.hostname,
        n = T4Sroutes.root_url,
        a = "is--checked-link",
        o = i + n;
      return function () {
        "/" != e &&
          t(`a[href*="${i}"]:not(.${a})`).each(function () {
            let s = t(this),
              r = s.attr("href");
            s.addClass(a),
              (r.indexOf(i + e) >= 0 && "/" != r) ||
              r.indexOf("preview_theme_id=") > -1 ||
              ("/" != r
                ? s.attr("href", r.replace(i, o))
                : s.attr("href", n));
          });
      };
    })());
  var S,
    w = (function () {
      function e(e) {
        var i = this;
        if (
          ((i.$slider = t(e)),
            (i.slideWrap = i.$slider.closest("[data-slide-wrap]")[0] || e),
            !i.slideWrap)
        )
          return;
        if (
          ((i.sliderOptions = JSON.parse(
            i.$slider.attr("data-options") || "{}"
          )),
            (i.slider = e),
            (i.sliderItems = e.querySelectorAll(".t4s-slider__slide")),
            (i.pageCount = i.slideWrap.querySelector(
              ".t4s-slider-counter--current"
            )),
            (i.pageTotal = i.slideWrap.querySelector(
              ".t4s-slider-counter--total"
            )),
            (i.prevButton = i.slideWrap.querySelector(".t4s-slider__slide-prev")),
            (i.nextButton = i.slideWrap.querySelector(".t4s-slider__slide-next")),
            !i.slider || !i.nextButton)
        )
          return;
        new ResizeObserver((t) => i._initPages()).observe(i.slider),
          i.slider.addEventListener("scroll", i._update.bind(i)),
          i.prevButton.addEventListener("click", i._onButtonClick.bind(i)),
          i.nextButton.addEventListener("click", i._onButtonClick.bind(i));
      }
      return (
        (e.prototype = Object.assign({}, e.prototype, {
          _initPages: function () {
            this.slider.classList.remove("is--active"),
              0 !== !this.sliderItems.length &&
              (this.slider.classList.add("is--active"),
                (this.slidesPerPage = Math.floor(
                  this.slider.clientWidth / this.sliderItems[0].clientWidth
                )),
                (this.totalPages =
                  this.sliderItems.length - this.slidesPerPage + 1),
                this._update());
          },
          _update: function () {
            this.pageCount &&
              this.pageTotal &&
              ((this.currentPage =
                Math.round(
                  this.slider.scrollLeft / this.sliderItems[0].clientWidth
                ) + 1),
                1 === this.currentPage
                  ? this.prevButton.setAttribute("disabled", !0)
                  : this.prevButton.removeAttribute("disabled"),
                this.currentPage === this.totalPages
                  ? this.nextButton.setAttribute("disabled", !0)
                  : this.nextButton.removeAttribute("disabled"),
                (this.pageCount.textContent = this.currentPage),
                (this.pageTotal.textContent = this.totalPages));
          },
          _onButtonClick: function (t) {
            t.preventDefault();
            const e =
              "next" === t.currentTarget.name
                ? this.slider.scrollLeft + this.sliderItems[0].clientWidth
                : this.slider.scrollLeft - this.sliderItems[0].clientWidth;
            this.slider.scrollTo({
              left: e,
            });
          },
        })),
        e
      );
    })();
  (T4SThemeSP.SliderComponentInt = void (
    0 != (S = t(".t4s-slider:not(.t4s-enabled)")).length &&
    S.each(function (t) {
      this.classList.add("t4s-enabled"), (this.sliderComponent = new w(this));
    })
  )),
    (T4SThemeSP.LibraryLoader = (function () {
      var t = {
        link: "link",
        script: "script",
      },
        e = {
          requested: "requested",
          loaded: "loaded",
        },
        n = "https://cdn.shopify.com/shopifycloud/",
        a = {
          youtubeSdk: {
            tagId: "youtube-sdk",
            src: "https://www.youtube.com/iframe_api",
            type: t.script,
          },
          vimeoSdk: {
            tagId: "vimeo-sdk",
            src: "https://player.vimeo.com/api/player.js",
            type: t.script,
          },
          plyrShopifyStyles: {
            tagId: "plyr-shopify-styles",
            src: n + "plyr/v2.0/shopify-plyr.css",
            type: t.link,
          },
          modelViewerUiStyles: {
            tagId: "shopify-model-viewer-ui-styles",
            src: n + "model-viewer-ui/assets/v1.0/model-viewer-ui.css",
            type: t.link,
          },
        };
      return {
        load: function (n, o) {
          var s = a[n];
          if (s) {
            if (r && "youtubeSdk" == n && window.YT)
              return o(), void i.trigger("youtube:ready");
            if (s.status !== e.requested)
              if (((o = o || function () { }), s.status !== e.loaded)) {
                var l;
                switch (((s.status = e.requested), s.type)) {
                  case t.script:
                    l = (function (t, i) {
                      var n = document.createElement("script");
                      return (
                        (n.src = t.src),
                        n.addEventListener("load", function () {
                          (t.status = e.loaded), i();
                        }),
                        n
                      );
                    })(s, o);
                    break;
                  case t.link:
                    l = (function (t, i) {
                      var n = document.createElement("link");
                      return (
                        (n.href = t.src),
                        (n.rel = "stylesheet"),
                        (n.type = "text/css"),
                        n.addEventListener("load", function () {
                          (t.status = e.loaded), i();
                        }),
                        n
                      );
                    })(s, o);
                }
                (l.id = s.tagId), (s.element = l);
                var d = document.getElementsByTagName(s.type)[0];
                d.parentNode.insertBefore(l, d);
              } else o();
          }
        },
      };
    })());
  var T,
    _ = (function () {
      var n = {
        html5: "html5",
        youtube: "youtube",
        vimeo: "vimeo",
      },
        a = !1,
        o = !1;
      function s(e) {
        switch (
        ((this.$video = t(e)),
          (this.video_options = JSON.parse(
            this.$video.attr("data-options") || "{}"
          )),
          (this.video_type = this.video_options.type),
          (this.video_mute = this.video_options.mute),
          (this.$videoInsert = this.$video.find("[data-bgvideo-insert]")),
          (this.$elementToInsert = this.$videoInsert.length
            ? this.$videoInsert
            : this.$video),
          (this.elementToInsert = this.$elementToInsert[0]),
          this.$video.attr("loaded", !0),
          this.video_type)
        ) {
          case n.html5:
            this._setupBgHtml5Video();
            break;
          case n.youtube:
            window.YT
              ? this._setupBgYouTubeVideo()
              : (this._triggerBgYouTubeVideo(),
                a || (T4SThemeSP.LibraryLoader.load("youtubeSdk"), (a = !0)));
            break;
          case n.vimeo:
            window.Vimeo
              ? this._setupBgVimeoVideo()
              : (this._triggerBgVimeoVideo(),
                o ||
                (T4SThemeSP.LibraryLoader.load(
                  "vimeoSdk",
                  this._loadedVimeoSDK.bind(this)
                ),
                  (o = !0)));
        }
      }
      return (
        (s.prototype = Object.assign({}, s.prototype, {
          _triggerBgYouTubeVideo: function () {
            var t = this;
            i.on("youtube:ready", function (e) {
              t._setupBgYouTubeVideo();
            });
          },
          _loadedVimeoSDK: function () {
            i.trigger("vimeo:ready");
          },
          _triggerBgVimeoVideo: function () {
            var t = this;
            i.on("vimeo:ready", function (e) {
              t._setupBgVimeoVideo();
            });
          },
          _setupBgHtml5Video: function () {
            var t = this;
            let e =
              '<video class="t4s_bg_vid_html5" src="' +
              t.video_options.src +
              '" preload="auto" playsinline autoplay ' +
              (t.video_mute ? "muted " : " ") +
              "loop></video>";
            t.$elementToInsert.replaceWith(e),
              t.$video.find(".t4s_bg_vid_html5").on("playing", function (e) {
                t.$video.addClass("t4s-bgvideo-playing");
              });
          },
          _setupBgYouTubeVideo: function () {
            if (window.YT) {
              var t = this;
              (t.player = new YT.Player(t.elementToInsert, {
                videoId: t.video_options.vid,
                playerVars: {
                  iv_load_policy: 3,
                  enablejsapi: 1,
                  disablekb: 1,
                  autoplay: 0,
                  controls: 0,
                  rel: 0,
                  loop: 0,
                  playsinline: 1,
                  modestbranding: 1,
                  autohide: 1,
                  branding: 0,
                  cc_load_policy: 0,
                  fs: 0,
                  quality: "hd1080",
                  wmode: "transparent",
                  height: "100%",
                  width: "100%",
                  origin: t.video_options.requestHost,
                },
                events: {
                  onReady: t.onPlayerReady.bind(this),
                  onStateChange: t.onPlayerStateChange.bind(this),
                },
              })),
                t.resizeVideoBackground(),
                e.on(
                  "resize",
                  T4SThemeSP.debounce(
                    300,
                    function () {
                      t.resizeVideoBackground();
                    }.bind(t)
                  )
                );
            }
          },
          onPlayerReady: function (t) {
            this.video_mute && this.player.mute(), this.player.playVideo();
          },
          onPlayerStateChange: function (t) {
            t.data === YT.PlayerState.PLAYING
              ? this.$video.addClass("t4s-bgvideo-playing")
              : t.data === YT.PlayerState.ENDED && this.player.playVideo();
          },
          _setupBgVimeoVideo: function () {
            if (window.Vimeo) {
              var t = this;
              (t.player = new Vimeo.Player(t.elementToInsert.parentNode, {
                id: t.video_options.vid,
                autoplay: !0,
                autopause: !1,
                muted: !0,
                background: !0,
                loop: t.video_mute,
              })),
                t.$videoInsert.remove(),
                t.resizeVideoBackground(),
                e.on(
                  "resize",
                  T4SThemeSP.debounce(
                    300,
                    function () {
                      t.resizeVideoBackground();
                    }.bind(t)
                  )
                ),
                t.player.on("play", function () {
                  t.$video.addClass("t4s-bgvideo-playing");
                }),
                t.player.on("ended", function () { });
            }
          },
          resizeVideoBackground: function () {
            var t,
              e,
              i,
              n,
              a = this.$video,
              o = a.innerWidth(),
              s = a.innerHeight();
            o / s < 16 / 9
              ? ((t = s * (16 / 9)),
                (e = s),
                (i = -Math.round((t - o) / 2) + "px"),
                (n = -Math.round((e - s) / 2) + "px"))
              : ((e = (t = o) * (9 / 16)),
                (n = -Math.round((e - s) / 2) + "px"),
                (i = -Math.round((t - o) / 2) + "px")),
              (t += "px"),
              (e += "px"),
              a.find("iframe").css({
                maxWidth: "1000%",
                marginLeft: i,
                marginTop: n,
                width: t,
                height: e,
              });
          },
        })),
        s
      );
    })();
  (T4SThemeSP.BgVideo = function () {
    var e = t('[data-video-background]:not([loaded="true"])');
    0 != e.length &&
      e.each(function (t) {
        this.bgVideo = new _(this);
      });
  }),
    (T4SThemeSP.Footer = (function () {
      var a,
        o = {
          opened: "is--footer_opened",
          btnClose: ".t4s-announcement-bar__close",
        },
        s = 200,
        r = t("#t4s-footer"),
        l = t("#MainContent"),
        d = t(".t4s-prefooter"),
        c = n.hasClass("t4s-browser-Safari");
      function u() {
        l.css({
          "--main-mb": r.outerHeight() + "px",
        });
      }
      function f() {
        c &&
          ((a = e.scrollTop()),
            i.outerHeight() - r.outerHeight() <
              a + r.outerHeight() + e.outerHeight()
              ? r.addClass("is--visible-footer")
              : r.removeClass("is--visible-footer"));
      }
      function p() {
        t("[data-footer-open]")
          .off("click")
          .on("click", function () {
            var e = t(this).parent(),
              i = e.find("> [data-footer-content]");
            e.hasClass(o.opened)
              ? (e.removeClass(o.opened), i.stop().slideUp(s))
              : (e.addClass(o.opened), i.stop().slideDown(s));
          }),
          e.off("resize.FooterCollapse");
      }
      return (
        d.length > 0 && (l = d),
        function () {
          e.on("resize.FooterCollapse", p),
            e.width() < 768 && t(".is--footer-collapse-true").length > 0 && p(),
            e.width() < 1025 ||
            0 == t(".is--footer-sticky-true").length ||
            (u(), e.on("resize", u), c && (f(), e.on("scroll", f)));
        }
      );
    })()),
    (T4SThemeSP.Notices = (function () {
      var e,
        i,
        o,
        s,
        r,
        l = t("#t4s-notices__tmp"),
        d = l.html(),
        c = "is--show",
        u = "is--active-notices",
        f = "click.notices",
        p = "hide.t4s.notices",
        h = !1,
        m = 200,
        g = T4Sconfigs.autoHideNotices,
        v = T4Sconfigs.timeOutNotices;
      function y() {
        o.hide(),
          clearTimeout(r),
          e.removeClass(c),
          n.removeClass(u),
          e.off(f).off(p);
      }
      return (
        l.remove(),
        function (l, b = "warning") {
          h ||
            (T4SThemeSP.$appendComponent.after(d),
              (e = t("#t4s-notices__wrapper")),
              (i = e.find(".t4s-notices__mess")),
              (o = e.find(".t4s-notices__progressbar")),
              (s = o.show().find(">span")),
              (h = !0),
              (d = null),
              s.css("animation-duration", `${v}ms`)),
            e.attr("data-notices-status", b),
            i.html(l),
            g ? o.show() : o.hide(),
            setTimeout(function () {
              e.addClass(c), n.addClass(u);
            }, m),
            g &&
            (r = setTimeout(function () {
              y();
            }, v + m)),
            e.on(f, function () {
              y();
            }),
            a.on(p, function () {
              y();
            });
        }
      );
    })()),
    (T4SThemeSP.FormShopifyMessSuccess = function () {
      let t = location.href;
      t.indexOf("contact_posted=true") < 0 ||
        (t.indexOf("contact_posted=true#ContactFormNotifyStock") > -1
          ? T4SThemeSP.Notices(l.frm_notify_stock_success, "success")
          : t.indexOf("contact_posted=true#ContactFormAsk") > -1
            ? T4SThemeSP.Notices(l.frm_contact_ask_success, "success")
            : t.indexOf("contact_posted=true#t4sNewsletterFormPopup") > -1 &&
            T4SThemeSP.Notices(l.frm_newsletter_popup_success, "success"));
    }),
    (T4SThemeSP.PreloadStylePopup = function () {
      var e = t("#t4s-style-popup");
      0 != e.length && a.prepend(e.html());
    }),
    (T4SThemeSP.BtnMore = (function () {
      var e = {
        enabled: "is--enabled",
        btn: "[data-btn-toogle]",
        open: "is--open",
      };
      function i(i) {
        (this.el = i),
          (this.$el = t(i)),
          this.clickHandler(),
          this.$el.addClass(e.enabled),
          (this.selector = this.$el.data("slector")),
          (this.tMore = this.$el.data("tmore")),
          (this.tLess = this.$el.data("tless")),
          (this.hasIsotope = this.$el.hasClass("isotopet4s"));
      }
      return (
        (i.prototype = Object.assign({}, i.prototype, {
          clickHandler: function () {
            var i = this;
            i.$el.on("click.more", e.btn, function (n) {
              n.preventDefault();
              let a = t(this);
              a.parent().find(i.selector).slideToggle(200),
                a.toggleClass(e.open),
                a.hasClass(e.open) ? a.html(i.tLess) : a.html(i.tMore),
                i.hasIsotope &&
                (i.$el.isotopet4s("layout"),
                  setTimeout(function () {
                    i.$el.isotopet4s("layout");
                  }, 219));
            });
          },
        })),
        i
      );
    })()),
    (T4SThemeSP.initBtnMore = void (
      0 != (T = t("[data-wrap-toogle]:not(.is--enabled)")).length &&
      T.each(function () {
        this.btnMore = new T4SThemeSP.BtnMore(this);
      })
    ));
})(jQuery_T4NT);

jQuery_T4NT(document).ready(function (t) {
  smoothscroll.polyfill(),
    T4SThemeSP.FormShopifyMessSuccess(),
    T4SThemeSP.BgVideo(),
    T4SThemeSP.ParallaxInt(),
    t(".t4s-parallax-bg:not(.lazyloadt4sed)").one("lazyloaded", function (t) {
      setTimeout(function () {
        T4SThemeSP.ParallaxInt();
      }, 100);
    }),
    T4SThemeSP.Countdown(),
    T4SThemeSP.AnimateOnScroll(),
    T4SThemeSP._initProducts(),
    T4SThemeSP.slate.a11y.accessibleLinks({
      $links: t("a[href]:not([aria-describedby])"),
    }),
    T4SThemeSP.Tabs.Default(),
    T4SThemeSP.Tabs.Simple(),
    T4SThemeSP.Tabs.Accordion(),
    T4SThemeSP.Tabs.RefreshNav(),
    T4SThemeSP.Footer(),
    T4SThemeSP.PopupMFP(),
    T4SThemeSP.Cookies(),
    $script([T4Sconfigs.script3, T4Sconfigs.script6]),
    setTimeout(function () {
      T4SThemeSP.LinkMyltiLang();
    }, 500),
    setTimeout(function () {
      T4SThemeSP.PreloadStylePopup();
    }, 1500);
});

// 通用 Shopify Video 组件，与商品媒体逻辑解耦。
// 用法：在容器上添加 data-shopify-video，并在容器内放置 video 或 iframe。
T4SThemeSP.ShopifyVideo = (function () {
  var selector = "[data-shopify-video]",
    instances = new WeakMap(),
    pendingInstances = new WeakMap(),
    videoUiPromise;

  function loadVideoUi() {
    T4SThemeSP.LibraryLoader.load("plyrShopifyStyles");

    if (window.Shopify && window.Shopify.Video) {
      return Promise.resolve();
    }

    if (videoUiPromise) return videoUiPromise;

    videoUiPromise = new Promise(function (resolve, reject) {
      if (
        !window.Shopify ||
        "function" !== typeof window.Shopify.loadFeatures
      ) {
        reject(new Error("Shopify.loadFeatures is unavailable"));
        return;
      }

      window.Shopify.loadFeatures([
        {
          name: "video-ui",
          version: "2.0",
          onLoad: function (error) {
            if (error) {
              videoUiPromise = null;
              reject(error);
              return;
            }

            resolve();
          },
        },
      ]);
    });

    return videoUiPromise;
  }

  function readBoolean(container, attributes, fallback) {
    for (var index = 0; index < attributes.length; index += 1) {
      var value = container.getAttribute(attributes[index]);

      if (null !== value) return "true" === value;
    }

    return fallback;
  }

  function getOptions(container, options) {
    options = options || {};

    return {
      loop:
        undefined !== options.loop
          ? options.loop
          : readBoolean(
            container,
            ["data-video-loop", "data-enable-video-looping"],
            false
          ),
      muted:
        undefined !== options.muted
          ? options.muted
          : readBoolean(
            container,
            ["data-video-muted", "data-enable-video-muting"],
            false
          ),
      autoplay:
        undefined !== options.autoplay
          ? options.autoplay
          : readBoolean(
            container,
            ["data-video-autoplay", "data-enable-video-autoplaying"],
            false
          ),
    };
  }

  function init(container, options) {
    if (!container) return Promise.resolve(null);

    var instance = instances.get(container);
    if (instance) return Promise.resolve(instance);

    var pendingInstance = pendingInstances.get(container);
    if (pendingInstance) return pendingInstance;

    var element = container.querySelector("video, iframe");
    if (!element) return Promise.resolve(null);

    var settings = getOptions(container, options);
    container.setAttribute("data-shopify-video-status", "loading");

    pendingInstance = loadVideoUi()
      .then(function () {
        var player = new window.Shopify.Video(element, {
          loop: {
            active: settings.loop,
          },
          volume: settings.muted ? 0 : 1,
          muted: settings.muted,
        }),
          controller;

        function play() {
          return player.play();
        }

        function pause() {
          return player.pause();
        }

        function playWithoutThrowing() {
          var playResult = play();

          if (playResult && "function" === typeof playResult.catch) {
            playResult.catch(function () { });
          }
        }

        function handleShow() {
          if (settings.autoplay) playWithoutThrowing();
        }

        function handleHide() {
          pause();
        }

        controller = {
          container: container,
          element: element,
          player: player,
          play: play,
          pause: pause,
          destroy: function () {
            container.removeEventListener("video:show", handleShow);
            container.removeEventListener("video:hide", handleHide);
            player.destroy();
            instances.delete(container);
            container.classList.remove("is-video-initialized");
            container.removeAttribute("data-shopify-video-status");
          },
        };

        container.addEventListener("video:show", handleShow);
        container.addEventListener("video:hide", handleHide);
        container.classList.add("is-video-initialized");
        container.setAttribute("data-shopify-video-status", "ready");

        instances.set(container, controller);
        pendingInstances.delete(container);

        if (settings.autoplay) playWithoutThrowing();

        return controller;
      })
      .catch(function (error) {
        pendingInstances.delete(container);
        container.setAttribute("data-shopify-video-status", "native");

        if ("VIDEO" === element.tagName) {
          element.setAttribute("controls", "controls");
        }

        if (window.console && "function" === typeof window.console.error) {
          window.console.error("Failed to initialize Shopify Video", error);
        }

        return null;
      });

    pendingInstances.set(container, pendingInstance);
    return pendingInstance;
  }

  function initAll(root) {
    root = root || document;

    var containers = [];

    if (root.matches && root.matches(selector)) containers.push(root);

    if (root.querySelectorAll) {
      containers = containers.concat(
        Array.prototype.slice.call(root.querySelectorAll(selector))
      );
    }

    return Promise.all(
      containers.map(function (container) {
        return init(container);
      })
    );
  }

  function destroy(container) {
    var instance = instances.get(container);
    if (instance) instance.destroy();
  }

  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });

  return {
    init: init,
    initAll: initAll,
    destroy: destroy,
  };
})();

jQuery_T4NT(document).ready(function () {
  T4SThemeSP.ShopifyVideo.initAll(document);
});

// 购物车相关初始化
function handleCartPageAddMore(cart_wrapper_dom) {
  if (cart_wrapper_dom == '.t4s-main-cart') {
    const addmore_btn = $(cart_wrapper_dom).find('.mibao_coupon_info #add_more_btn')
    addmore_btn.off('click.cartPageAddMore').on('click.cartPageAddMore', function (e) {
      e.preventDefault()
      window.T4SThemeSP?.Drawer?.opend?.($('#cart_page_add_more'))
    })
  }
}

function makeAddCartButtonEmptyTips(selector) {
  return function () {
    console.log('test1 addCartButtonSizeEmptyTips')
    const wrapper = document.querySelector(selector)
    const addCartBtn = wrapper.querySelectorAll('form[data-type="add-to-cart-form"] [data-atc-form]')
    const sizeSelectors = wrapper.querySelectorAll('form[data-type="add-to-cart-form"] [data-swatch-option] .is-sw__size')
    const optionSelectors = wrapper.querySelectorAll('form[data-type="add-to-cart-form"] [data-swatch-option]')
    console.log('test1 sizeSelectors', sizeSelectors)

    addCartBtn.forEach(item => item.addEventListener("click", function (e) {
      console.log('test1 addCartBTN', e)
      const no_selected_size_list =
        Array.from(sizeSelectors).filter(sizeSelector => {
          return !Array.from(sizeSelector.children).some(item => {
            const classList = Array.from(item.classList)
            return !!classList.find((item) => item == "is--selected")
          })
        })
      console.log('test1 no_selected_size_list', no_selected_size_list)
      no_selected_size_list.forEach((no_selected) => {
        no_selected.classList.add('blink-outline')
      })
      // 是否存在未选项
      const no_selected_options = Array.from(optionSelectors).filter(selector => {
        return !Array.from(selector.children).some(item => {
          const classList = Array.from(item.classList)
          return !!classList.find((item) => item == "is--selected")
        })
      })
      if (no_selected_options.length) {
        addCartBtn[0].scrollIntoView({
          behavior: "smooth",
          block: "end"
        });
      }
    }))

    // 点击任何一个尺码后，移除 blink-outline
    sizeSelectors.forEach(selector => {
      selector.querySelectorAll('.t4s-swatch__item').forEach((option) => {
        option.addEventListener('click', function () {
          selector.classList.remove('blink-outline')
        })
      })
    })
  }
}
// 给商品页面添加提示
const handleAddCartEmptry = makeAddCartButtonEmptyTips('body')
handleAddCartEmptry()

function init_add_more() {
  const mini_cart_DOM = document.querySelector(
    '#t4s-mini_cart #mini_cart-main'
  );
  const add_more_DOM = document.querySelector(
    '#t4s-mini_cart #mini_cart-add_more'
  );
  if (!mini_cart_DOM || !add_more_DOM) {
    return
  }

  const add_more_handle = add_more_DOM.dataset.add_more_handle || 'products-for-cart'
  const close_add_more_btn = add_more_DOM.querySelectorAll('.add_more_close');

  // 给关闭按钮绑定事件
  function addEventToCloseBtn(event) {
    event.preventDefault();
    mini_cart_DOM.style.display = 'flex';
    add_more_DOM.style.display = 'none';
  }
  Array.from(close_add_more_btn).forEach((target) => {
    if (target.dataset.addMoreCloseInitialized != 'true') {
      target.addEventListener('click', addEventToCloseBtn);
      target.dataset.addMoreCloseInitialized = 'true'
    }
  });

  // 初始化加购弹窗
  const addmore_container = document.querySelector(
    '#mini_cart-add_more .t4s-drawer__main div[data-t4s-scroll-me]'
  );
  const addmore_mounted_target = document.querySelector(
    '#mini_cart-add_more .t4s-drawer__main div[data-t4s-scroll-me] #cart-add_more_list'
  );
  const addmore_loadingDOM = document.querySelector(
    '#mini_cart-add_more .t4s-drawer__main div[data-t4s-scroll-me] #cart-add_more_loading'
  );
  const addmore_requestApi = `${window.Shopify.routes.root || '/'}collections/${add_more_handle}?section_id=collection-scroll-loader`;
  if (
    addmore_container &&
    addmore_mounted_target &&
    addmore_loadingDOM &&
    addmore_container.dataset.addMoreListInitialized != 'true' &&
    typeof initScrollProductList == 'function'
  ) {
    initScrollProductList(addmore_mounted_target, addmore_container, addmore_loadingDOM, addmore_requestApi)
    addmore_container.dataset.addMoreListInitialized = 'true'
  }

  // 请求AB，执行AB逻辑
  function addEventAddMore() {
    try {
      const add_more_btns = mini_cart_DOM.querySelectorAll('#add_more_btn');
      // 初始化按钮
      Array.from(add_more_btns).forEach((target) => {
        if (target.dataset.addMoreOpenInitialized != 'true') {
          target.addEventListener('click', function (event) {
            event.preventDefault();
            mini_cart_DOM.style.display = 'none';
            add_more_DOM.style.display = 'flex';
          });
          target.dataset.addMoreOpenInitialized = 'true'
        }
      })
    } catch (error) {
      console.error('===>>> addmore-ab error:', error);
    }
  }
  addEventAddMore()
}

// 购物车页面相关逻辑， 处理购物车变化
window.handleCartChange = function cartHandle(cart_wrapper_dom) {
  const cart_wrapper = $(cart_wrapper_dom)
  if (!cart_wrapper.length) {
    return
  }

  let price_tips
  let count_tips
  let price_without_code_tips
  if (window.Shopify?.locale == 'de') {
    price_tips = [
      `Es fehlen Ihnen nur noch {{rest}} zu {{discount}} RABATT.`,
      `{{amount}} sparen mit "{{code}}". Noch {{rest}} für {{discount}} Rabatt`,
      `Gutscheincode "<b>{{code}}</b>" für {{discount}} Rabatt.`,
    ]
    count_tips = [
      `{{rest}} Artikel mehr hinzufügen, <b>{{discount}} gratis bekommen</b>.`,
      `Mit Code <b>{{code}}</b>: {{rest}} Artikel kaufen, <b>{{discount}} gratis</b> dazu erhalten!`,
      `Nutzen Sie code <b>{{code}}</b> für <b>{{discount}} Kostenlose</b>.`,
      `<b>{{discount}} Gratisartikel</b> freigeschaltet.`
    ]
    price_without_code_tips = [
      `Du bist nur noch <b>{{rest}}</b> von {{discount}} Rabatt entfernt.`,
      `{{last_discount}} Rabatt ab {{last_max}} frei! Noch {{rest}} für {{discount}} Rabatt.`,
      `{{discount}} Rabatt ab {{min}}+ freigeschaltet!`
    ]

  } else {
    price_tips = [
      `You are only {{rest}} away from {{discount}} OFF.`,
      `Save {{amount}} Code:<b>{{code}}</b>, or add <b>{{rest}}</b> for {{discount}} OFF.`,
      `Use <b>{{code}}</b> for {{discount}} OFF.`,
    ]
    count_tips = [
      `Add <b>{{rest}}</b> more items to get <b>{{discount}} Free</b>.`,
      `Use code <b>{{code}}</b>. Add <b>{{rest}}</b> more items to get <b>{{discount}} Free</b>.`,
      `Use code <b>{{code}}</b> for <b>{{discount}} Free</b>.`,
      `Unlocked <b>{{discount}} Free</b>.`
    ]
    price_without_code_tips = [
      `You are only <b>{{rest}}</b> away from {{discount}} OFF.`,
      `Unlocked {{last_discount}} off {{last_max}}+! Or add <b>{{rest}}</b> for {{discount}} OFF.`,
      `Unlocked {{discount}} off {{min}}+!.`
    ]
  }

  setTimeout(() => {
    window.Samita?.ProductLabels?.init?.()
    window.T4SThemeSP?.PopupMFP?.()
  }, 100)

  const copy_button = cart_wrapper.find('.mibao_coupon_info #copy').first()
  if (
    copy_button.length &&
    copy_button[0].dataset.oglClipboardInitialized != 'true' &&
    typeof window.ogl_clipboard == 'function'
  ) {
    const clipboard = new window.ogl_clipboard(
      cart_wrapper_dom + ' .mibao_coupon_info #copy'
    );
    clipboard.on('success', function () {
      window.oglToast?.show?.({
        message: 'Copy Success!',
        type: 'success'
      });
    });
    copy_button[0].dataset.oglClipboardInitialized = 'true'
  }

  // 初始化add按钮
  cart_wrapper_dom == '#t4s-mini_cart' && init_add_more()
  // 初始化加购弹窗
  handleCartPageAddMore(cart_wrapper_dom)

  let info = ''
  let copy_code = ''
  let is_show_info = false
  let show_copy = false
  let show_add = false
  // 购物车件数
  const item_count = cart_wrapper
    .find('[data-cart-item][data-discount-valid="true"]')
    .toArray()
    .reduce((acc, item) => {
      const quantity = Number(item.dataset.quantity || 0)
      return acc + (Number.isFinite(quantity) && quantity > 0 ? quantity : 0)
    }, 0)
  // 购物车原价总数
  const total_price_value = cart_wrapper
    .find('.t4s-cart__totalPrice #mibao_cart_original_total_price')
    .first()
    .val()
  const original_total_price = Number(
    total_price_value ?? window.mibaoCartData?.original_total_price ?? 0
  )
  const original_total_amount = Number.isFinite(original_total_price)
    ? original_total_price / 100
    : 0

  function reportRuleError(error) {
    if (typeof window.report_faro == 'function') {
      window.report_faro({
        file_name: 'assets/theme.js',
        func_name: 'handleCartChange',
        desc: 'Invalid cart discount rules',
        error: error
      })
    } else {
      console.error('Invalid cart discount rules', error)
    }
  }

  function parseRules(value) {
    try {
      const parsed = typeof value == 'string'
        ? JSON.parse(value || '[]')
        : value
      if (!Array.isArray(parsed)) {
        throw new TypeError('Discount rules must be an array')
      }

      return parsed
        .map((rule) => {
          if (!rule || typeof rule != 'object' || Array.isArray(rule)) {
            return null
          }

          const min = Number(rule.min || 0)
          const has_max = ![undefined, null, '', 0, '0'].includes(rule.max)
          const max = has_max ? Number(rule.max) : null
          const discount = Number(rule.discount || 0)
          if (
            !Number.isFinite(min) ||
            min < 0 ||
            (max != null && (!Number.isFinite(max) || max <= min)) ||
            !Number.isFinite(discount) ||
            discount < 0
          ) {
            return null
          }

          return {
            min: min,
            max: max,
            discount: discount,
            code: String(rule.code || '').trim()
          }
        })
        .filter(Boolean)
        .sort((first_rule, second_rule) => first_rule.min - second_rule.min)
    } catch (error) {
      reportRuleError(error)
      return []
    }
  }

  function escapeHtml(value) {
    return String(value).replace(/[&<>'"]/g, function (character) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        "'": '&#39;',
        '"': '&quot;'
      }[character]
    })
  }

  function renderTip(template, values) {
    return Object.entries(values).reduce((result, entry) => {
      return result.split(`{{${entry[0]}}}`).join(String(entry[1]))
    }, template)
  }

  if (
    window.mibao_cart_discount_info_rules &&
    String(window.mibao_cart_discount_info_rules.show) == '1'
  ) {
    const rule_config = window.mibao_cart_discount_info_rules
    const rule_type = rule_config.type
    const coupon_rule = {
      type: rule_type,
      rules: parseRules(
        rule_type == 'price' || rule_type == 'price_without_code'
          ? rule_config.price_rules
          : rule_config.count_rules
      )
    };

    const configured_currency_rate = Number(window.Shopify?.currency?.rate || 1)
    const currency_rate = Number.isFinite(configured_currency_rate) && configured_currency_rate > 0
      ? configured_currency_rate
      : 1
    const formatCurrency = function (amount, decimal_places = 0) {
      const formatted_amount = Number(amount).toFixed(decimal_places)
      return window.T4Sconfigs?.moneyFormat
        ? window.T4Sconfigs.moneyFormat.replace(
          /\{\{(amount_with_comma_separator|amount)\}\}/g,
          (_, format) => format == 'amount_with_comma_separator'
            ? formatted_amount.replace('.', ',')
            : formatted_amount
        )
        : formatted_amount
    }

    function calc_price(rule, rule_index) {
      const min_price = rule.min * currency_rate
      const max_price = rule.max == null ? null : rule.max * currency_rate
      if (
        original_total_amount < min_price ||
        (max_price != null && original_total_amount >= max_price)
      ) {
        return false
      }

      const discount_price_currency = formatCurrency(rule.discount * currency_rate)
      if (max_price == null) {
        info = renderTip(rule.code ? price_tips[2] : price_without_code_tips[2], {
          code: escapeHtml(rule.code),
          discount: discount_price_currency,
          min: formatCurrency(min_price)
        })
        is_show_info = true
        copy_code = rule.code
        show_copy = Boolean(copy_code)
        show_add = false
        return true
      }

      const rest_price_currency = formatCurrency(
        Math.max(0, max_price - original_total_amount),
        2
      )
      if (!rule.code) {
        info = renderTip(price_tips[0], {
          rest: rest_price_currency,
          discount: discount_price_currency
        })
      } else {
        const last_rule = coupon_rule.rules[rule_index - 1] || rule
        info = renderTip(price_tips[1], {
          amount: formatCurrency(last_rule.discount * currency_rate),
          code: escapeHtml(rule.code),
          rest: rest_price_currency,
          discount: discount_price_currency
        })
        copy_code = rule.code
        show_copy = true
      }
      is_show_info = true
      show_add = true
      return true
    }

    function calc_count(rule) {
      if (
        item_count <= rule.min ||
        (rule.max != null && item_count > rule.max)
      ) {
        return false
      }

      if (rule.max == null) {
        info = renderTip(rule.code ? count_tips[2] : count_tips[3], {
          code: escapeHtml(rule.code),
          discount: rule.discount
        })
        copy_code = rule.code
        show_copy = Boolean(copy_code)
        show_add = false
      } else {
        const tip_template = rule.code ? count_tips[1] : count_tips[0]
        info = renderTip(tip_template, {
          rest: rule.max - item_count + 1,
          discount: rule.discount,
          code: escapeHtml(rule.code)
        })
        copy_code = rule.code
        show_copy = Boolean(copy_code)
        show_add = true
      }
      is_show_info = true
      return true
    }

    function calc_price_without_code() {
      const active_rule_index = coupon_rule.rules.findIndex((rule) => {
        const min_price = rule.min * currency_rate
        const max_price = rule.max == null ? null : rule.max * currency_rate
        return original_total_amount >= min_price &&
          (max_price == null || original_total_amount < max_price)
      })
      if (active_rule_index == -1) {
        return false
      }

      const active_rule = coupon_rule.rules[active_rule_index]
      const discount_price_currency = formatCurrency(
        active_rule.discount * currency_rate
      )
      const min_price_currency = formatCurrency(active_rule.min * currency_rate)
      if (active_rule.max == null) {
        info = renderTip(price_without_code_tips[2], {
          discount: discount_price_currency,
          min: min_price_currency
        })
        is_show_info = true
        show_add = false
        return true
      }

      const max_price = active_rule.max * currency_rate
      const rest_price_currency = formatCurrency(
        Math.max(0, max_price - original_total_amount),
        2
      )
      const last_rule = coupon_rule.rules[active_rule_index - 1]
      if (!last_rule) {
        info = renderTip(price_without_code_tips[0], {
          rest: rest_price_currency,
          discount: discount_price_currency
        })
      } else {
        info = renderTip(price_without_code_tips[1], {
          last_discount: formatCurrency(last_rule.discount * currency_rate),
          last_max: formatCurrency(last_rule.max * currency_rate),
          rest: rest_price_currency,
          discount: discount_price_currency
        })
      }
      is_show_info = true
      show_add = true
      return true
    }

    switch (coupon_rule.type) {
      case 'price':
        for (const [rule_index, rule] of coupon_rule.rules.entries()) {
          if (calc_price(rule, rule_index)) {
            break
          }
        }
        break;
      case 'price_without_code':
        calc_price_without_code()
        break;
      default:
        for (const rule of coupon_rule.rules) {
          if (calc_count(rule)) {
            break
          }
        }
        break
    }
  }

  const discount_info = cart_wrapper.find('.mibao_coupon_info').first()
  const add_more_button = discount_info.find('#add_more_btn')
  if (is_show_info) {
    discount_info.stop(true, true).show(300)
    discount_info.find('#tips').html(info)
  } else {
    discount_info.stop(true, true).hide(300)
  }

  copy_button.toggle(is_show_info && show_copy)
  if (copy_code) {
    copy_button.attr('data-clipboard-text', copy_code)
  } else {
    copy_button.removeAttr('data-clipboard-text')
  }
  add_more_button.toggle(is_show_info && show_add)
}


// 货币提示弹窗逻辑
// function showCurrencyTips() {
//   // 非北美站不做
//   if (window.Shopify.shop !== 'oglmove.myshopify.com') {
//     return
//   }
//   try {
//     const currency_tips_showed = 'ogl_currency_tips'
//     // 已经展示过
//     if (localStorage.getItem(currency_tips_showed) == 1) {
//       return
//     }
//     // 获取定位cookie国家码
//     const user_local_iso = performance.getEntriesByType("navigation")[0].serverTiming.find(n => n.name === "_cmp")?.description.split("_")[1].slice(0, 2);
//     window.user_local_iso = user_local_iso

//     if (!user_local_iso) {
//       return
//     }
//     const country_currency_map = window.country_currecncy_map
//     const cur_local_price_unit = country_currency_map[user_local_iso.toUpperCase()]
//     async function sendData(currency_code) {
//       const localization_form = document.querySelector(
//         '#ogl-localization-form #localization_form'
//       )
//       const currency_input = localization_form.querySelector('input[name="currency_code"]')
//       currency_input.value = currency_code
//       localization_form.submit()
//       try {
//         // 切换货币成功上报
//         Shopify?.analytics?.publish("currency_change", {
//           country_code: user_local_iso.toUpperCase(),
//           currency_code: cur_local_price_unit,
//           event_type: 'currency_change_success'
//         });
//       } catch (e) {
//         console.error(e);
//         // 切换货币成功上报
//         Shopify?.analytics?.publish("currency_change", {
//           country_code: user_local_iso.toUpperCase(),
//           currency_code: cur_local_price_unit,
//           event_type: 'currency_change_error'
//         });
//       }
//     }
//     // 判断用户定位不在美国，弹出切换货币弹窗
//     if (user_local_iso.toUpperCase() !== 'US' && cur_local_price_unit) {
//       const currency_confirm = new window.oglConfirm({
//         title: "Friendly Tip",
//         content: `Wanna see local prices?`,
//         showCancel: false,
//         confirmId: 'currency-tips',
//         ok: () => {
//           localStorage.setItem(currency_tips_showed, 1)
//           sendData(cur_local_price_unit)
//           sessionStorage.removeItem('timeMenuT4s');
//         },
//         okBtnText: "Easy—switch now!",
//         cancel: () => {
//           localStorage.setItem(currency_tips_showed, 1);
//           sendData('USD');
//           sessionStorage.removeItem('timeMenuT4s');
//         }
//       })
//       currency_confirm.show()
//       // 弹出上报
//       Shopify?.analytics?.publish("currency_change", {
//         country_code: user_local_iso.toUpperCase(),
//         currency_code: cur_local_price_unit,
//         event_type: 'currency_change_alert'
//       });
//     }
//   } catch (err) {
//     //上报错误
//     console.log('error', err)
//   }

// }
// window.addEventListener('DOMContentLoaded', showCurrencyTips)

// 多通道登录逻辑
// social_media_register_type google: 1
// async function multipassLogin(token, redirect_url, social_media_register_type = 1) {
//   try {
//     Shopify.analytics.publish("member-datac", {
//       social_media_register_type: social_media_register_type,
//       platform: !window.innerWidth < 768 ? "pc" : "mobile",
//       name: 'multipass_login_click',
//     });
//     const site_id = window.ogl_config.site.id
//     const res = await ogl_fetch.post(
//       '/api/v1/customer-center/generate-shopify-multipass-token',
//       {
//         id_token: token,
//         site_id: site_id,
//         redirect_url: redirect_url,
//         social_media_register_type: social_media_register_type,
//       }
//     );
//     return res
//   } catch (err) {
//     oglToast.show({ message: 'Social Login Fail!' });
//     return null
//   }
// }

// window.addEventListener('DOMContentLoaded', () => {
//   window.social_login_redirect_url = `${window.location.origin}${window.location.pathname}?social_media_register_type=google`
//   google.accounts.id.initialize({
//     client_id: "535250284478-2ims786n7omf3pn826ogubls9p8hjd5q.apps.googleusercontent.com",
//     auto_select: false,
//     use_fedcm_for_button: false,
//     button_auto_select: false,
//     callback: async (response) => {
//       window.oglLoading(true)
//       const res = await multipassLogin(response.credential, window.social_login_redirect_url)
//       if (res) {
//         const multipass_token = res.data
//         Shopify.analytics.publish("member-datac", {
//           social_media_register_type: 1,
//           name: 'multipass_login_success',
//         });
//         window.location.href = `/account/login/multipass/${multipass_token}`
//       } else {
//         window.oglLoading(false)
//         oglToast.show({ message: 'Social Login Fail!' });
//       }
//     }
//   });
//   // 渲染登录按钮
//   google.accounts.id.renderButton(
//     document.getElementById("g_id_signin"),
//     {
//       theme: "outline", size: "large", width: "700px", type: "standard", text: "signin_with", locale: "en", click_listener: (e) => {
//         window.social_login_redirect_url = `${window.location.origin}${window.location.pathname}?social_media_register_type=google&open_cart=1`
//       }
//     } // 极简样式，可删
//   );

//   // 渲染注册按钮
//   google.accounts.id.renderButton(
//     document.getElementById("g_id_signup"),
//     {
//       theme: "outline", size: "large", width: "700px", type: "standard", text: "signin_with", locale: "en", click_listener: (e) => {
//         window.social_login_redirect_url = `${window.location.origin}${window.location.pathname}?social_media_register_type=google&open_cart=1`
//       }
//     } // 极简样式，可删
//   );
// })

window.ogl_event_subscribe_type_map = {
  1: 'add_wishlist',
  6: 'new_color_alert',
  7: 'select_size_no_add_cart',
}
// 自定义的弹窗系统订阅上报
function handleOglSubscibeEvent(event) {
  const info = event.detail || {};
  const productId = info.product_id || ''
  const subscribe_type = info.subscribe_type
  const subscribe_email = localStorage.getItem("ogl_subsrcibe_email") || window.customer?.email

  const popupKey = window.ogl_event_subscribe_type_map[subscribe_type]
  const shouldAlwaysOpen = ['new_color_alert'].includes(popupKey)
  // 更新对应策略弹窗的状态
  window.oglPopup?.updateStrategy(popupKey, info)
  window.ogl_event_subscribe = async function (event_type, option) {
    try {
      // 不调用cartsee的情况
      if (shouldAlwaysOpen) {
        return
      }
      await ogl_fetch.post('/api/v1/customer-center/save-customer-pop-up-window-log', {
        event_type,
        site_id: window.ogl_config.site.id,
        // client_id无用
        client_id: '',
        ...option
      })
    } catch (err) {
      throw ('ogl_event_subscribe error')
    }
  }
  if (subscribe_email && !shouldAlwaysOpen) {
    window.ogl_event_subscribe(subscribe_type, {
      email: subscribe_email,
      product_id: productId
    })
    return
  }
  // 打开弹窗
  const is_opened = window.oglPopup?.open({
    key: popupKey,
    info: {
      product_id: productId,
      event_type: info.subscribe_type
    }
  })
  if (is_opened) {
    window.ogl_event_subscribe(subscribe_type, {
      product_id: productId
    })
    Shopify.analytics.publish('interest_subscribe_popup', {
      product_id: productId,
      event_type: popupKey
    });
  }
}
document.addEventListener('ogl-subscribe:active', handleOglSubscibeEvent);

jQuery_T4NT(function ($) {
  // 给quickView添加提示
  const bindFlag = "__$bindEvent__";
  if (window[bindFlag]) return;
  window[bindFlag] = true;

  const eventNS = ".addCart";
  const $body = $("body");
  const $doc = $(document)

  const handleModalAddCartEmptry = makeAddCartButtonEmptyTips('.t4s-modal')
  $body
    .off(`modalt4s:opened${eventNS}`)
    .on(`modalt4s:opened${eventNS}`, handleModalAddCartEmptry)

  $doc
    .off(`modalt4s:opened${eventNS}`)
    .on(`modalt4s:opened${eventNS}`, handleModalAddCartEmptry)

})

// // hiko 事件
// document.addEventListener("hiko", (event) => {
//   console.log(event.detail);
//   const data = event.detail || {}
//   data.customerId = event.detail.customer_id
//   data.new_customer = event.detail.new_customer ? 1 : 0
//   Shopify.analytics.publish("member-datac", {
//     name: 'hiko_social_login',
//     ...data
//   });
// });
